
try{/* Zepto v1.1.6 - zepto event ajax form ie - zeptojs.com/license */
var Zepto=function(){function L(t){return null==t?String(t):j[S.call(t)]||"object"}function Z(t){return"function"==L(t)}function _(t){return null!=t&&t==t.window}function $(t){return null!=t&&t.nodeType==t.DOCUMENT_NODE}function D(t){return"object"==L(t)}function M(t){return D(t)&&!_(t)&&Object.getPrototypeOf(t)==Object.prototype}function R(t){return"number"==typeof t.length}function k(t){return s.call(t,function(t){return null!=t})}function z(t){return t.length>0?n.fn.concat.apply([],t):t}function F(t){return t.replace(/::/g,"/").replace(/([A-Z]+)([A-Z][a-z])/g,"$1_$2").replace(/([a-z\d])([A-Z])/g,"$1_$2").replace(/_/g,"-").toLowerCase()}function q(t){return t in f?f[t]:f[t]=new RegExp("(^|\\s)"+t+"(\\s|$)")}function H(t,e){return"number"!=typeof e||c[F(t)]?e:e+"px"}function I(t){var e,n;return u[t]||(e=a.createElement(t),a.body.appendChild(e),n=getComputedStyle(e,"").getPropertyValue("display"),e.parentNode.removeChild(e),"none"==n&&(n="block"),u[t]=n),u[t]}function V(t){return"children"in t?o.call(t.children):n.map(t.childNodes,function(t){return 1==t.nodeType?t:void 0})}function B(n,i,r){for(e in i)r&&(M(i[e])||A(i[e]))?(M(i[e])&&!M(n[e])&&(n[e]={}),A(i[e])&&!A(n[e])&&(n[e]=[]),B(n[e],i[e],r)):i[e]!==t&&(n[e]=i[e])}function U(t,e){return null==e?n(t):n(t).filter(e)}function J(t,e,n,i){return Z(e)?e.call(t,n,i):e}function X(t,e,n){null==n?t.removeAttribute(e):t.setAttribute(e,n)}function W(e,n){var i=e.className||"",r=i&&i.baseVal!==t;return n===t?r?i.baseVal:i:void(r?i.baseVal=n:e.className=n)}function Y(t){try{return t?"true"==t||("false"==t?!1:"null"==t?null:+t+""==t?+t:/^[\[\{]/.test(t)?n.parseJSON(t):t):t}catch(e){return t}}function G(t,e){e(t);for(var n=0,i=t.childNodes.length;i>n;n++)G(t.childNodes[n],e)}var t,e,n,i,C,N,r=[],o=r.slice,s=r.filter,a=window.document,u={},f={},c={"column-count":1,columns:1,"font-weight":1,"line-height":1,opacity:1,"z-index":1,zoom:1},l=/^\s*<(\w+|!)[^>]*>/,h=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,p=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,d=/^(?:body|html)$/i,m=/([A-Z])/g,g=["val","css","html","text","data","width","height","offset"],v=["after","prepend","before","append"],y=a.createElement("table"),x=a.createElement("tr"),b={tr:a.createElement("tbody"),tbody:y,thead:y,tfoot:y,td:x,th:x,"*":a.createElement("div")},w=/complete|loaded|interactive/,E=/^[\w-]*$/,j={},S=j.toString,T={},O=a.createElement("div"),P={tabindex:"tabIndex",readonly:"readOnly","for":"htmlFor","class":"className",maxlength:"maxLength",cellspacing:"cellSpacing",cellpadding:"cellPadding",rowspan:"rowSpan",colspan:"colSpan",usemap:"useMap",frameborder:"frameBorder",contenteditable:"contentEditable"},A=Array.isArray||function(t){return t instanceof Array};return T.matches=function(t,e){if(!e||!t||1!==t.nodeType)return!1;var n=t.webkitMatchesSelector||t.mozMatchesSelector||t.oMatchesSelector||t.matchesSelector;if(n)return n.call(t,e);var i,r=t.parentNode,o=!r;return o&&(r=O).appendChild(t),i=~T.qsa(r,e).indexOf(t),o&&O.removeChild(t),i},C=function(t){return t.replace(/-+(.)?/g,function(t,e){return e?e.toUpperCase():""})},N=function(t){return s.call(t,function(e,n){return t.indexOf(e)==n})},T.fragment=function(e,i,r){var s,u,f;return h.test(e)&&(s=n(a.createElement(RegExp.$1))),s||(e.replace&&(e=e.replace(p,"<$1></$2>")),i===t&&(i=l.test(e)&&RegExp.$1),i in b||(i="*"),f=b[i],f.innerHTML=""+e,s=n.each(o.call(f.childNodes),function(){f.removeChild(this)})),M(r)&&(u=n(s),n.each(r,function(t,e){g.indexOf(t)>-1?u[t](e):u.attr(t,e)})),s},T.Z=function(t,e){return t=t||[],t.__proto__=n.fn,t.selector=e||"",t},T.isZ=function(t){return t instanceof T.Z},T.init=function(e,i){var r;if(!e)return T.Z();if("string"==typeof e)if(e=e.trim(),"<"==e[0]&&l.test(e))r=T.fragment(e,RegExp.$1,i),e=null;else{if(i!==t)return n(i).find(e);r=T.qsa(a,e)}else{if(Z(e))return n(a).ready(e);if(T.isZ(e))return e;if(A(e))r=k(e);else if(D(e))r=[e],e=null;else if(l.test(e))r=T.fragment(e.trim(),RegExp.$1,i),e=null;else{if(i!==t)return n(i).find(e);r=T.qsa(a,e)}}return T.Z(r,e)},n=function(t,e){return T.init(t,e)},n.extend=function(t){var e,n=o.call(arguments,1);return"boolean"==typeof t&&(e=t,t=n.shift()),n.forEach(function(n){B(t,n,e)}),t},T.qsa=function(t,e){var n,i="#"==e[0],r=!i&&"."==e[0],s=i||r?e.slice(1):e,a=E.test(s);return $(t)&&a&&i?(n=t.getElementById(s))?[n]:[]:1!==t.nodeType&&9!==t.nodeType?[]:o.call(a&&!i?r?t.getElementsByClassName(s):t.getElementsByTagName(e):t.querySelectorAll(e))},n.contains=a.documentElement.contains?function(t,e){return t!==e&&t.contains(e)}:function(t,e){for(;e&&(e=e.parentNode);)if(e===t)return!0;return!1},n.type=L,n.isFunction=Z,n.isWindow=_,n.isArray=A,n.isPlainObject=M,n.isEmptyObject=function(t){var e;for(e in t)return!1;return!0},n.inArray=function(t,e,n){return r.indexOf.call(e,t,n)},n.camelCase=C,n.trim=function(t){return null==t?"":String.prototype.trim.call(t)},n.uuid=0,n.support={},n.expr={},n.map=function(t,e){var n,r,o,i=[];if(R(t))for(r=0;r<t.length;r++)n=e(t[r],r),null!=n&&i.push(n);else for(o in t)n=e(t[o],o),null!=n&&i.push(n);return z(i)},n.each=function(t,e){var n,i;if(R(t)){for(n=0;n<t.length;n++)if(e.call(t[n],n,t[n])===!1)return t}else for(i in t)if(e.call(t[i],i,t[i])===!1)return t;return t},n.grep=function(t,e){return s.call(t,e)},window.JSON&&(n.parseJSON=JSON.parse),n.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(t,e){j["[object "+e+"]"]=e.toLowerCase()}),n.fn={forEach:r.forEach,reduce:r.reduce,push:r.push,sort:r.sort,indexOf:r.indexOf,concat:r.concat,map:function(t){return n(n.map(this,function(e,n){return t.call(e,n,e)}))},slice:function(){return n(o.apply(this,arguments))},ready:function(t){return w.test(a.readyState)&&a.body?t(n):a.addEventListener("DOMContentLoaded",function(){t(n)},!1),this},get:function(e){return e===t?o.call(this):this[e>=0?e:e+this.length]},toArray:function(){return this.get()},size:function(){return this.length},remove:function(){return this.each(function(){null!=this.parentNode&&this.parentNode.removeChild(this)})},each:function(t){return r.every.call(this,function(e,n){return t.call(e,n,e)!==!1}),this},filter:function(t){return Z(t)?this.not(this.not(t)):n(s.call(this,function(e){return T.matches(e,t)}))},add:function(t,e){return n(N(this.concat(n(t,e))))},is:function(t){return this.length>0&&T.matches(this[0],t)},not:function(e){var i=[];if(Z(e)&&e.call!==t)this.each(function(t){e.call(this,t)||i.push(this)});else{var r="string"==typeof e?this.filter(e):R(e)&&Z(e.item)?o.call(e):n(e);this.forEach(function(t){r.indexOf(t)<0&&i.push(t)})}return n(i)},has:function(t){return this.filter(function(){return D(t)?n.contains(this,t):n(this).find(t).size()})},eq:function(t){return-1===t?this.slice(t):this.slice(t,+t+1)},first:function(){var t=this[0];return t&&!D(t)?t:n(t)},last:function(){var t=this[this.length-1];return t&&!D(t)?t:n(t)},find:function(t){var e,i=this;return e=t?"object"==typeof t?n(t).filter(function(){var t=this;return r.some.call(i,function(e){return n.contains(e,t)})}):1==this.length?n(T.qsa(this[0],t)):this.map(function(){return T.qsa(this,t)}):n()},closest:function(t,e){var i=this[0],r=!1;for("object"==typeof t&&(r=n(t));i&&!(r?r.indexOf(i)>=0:T.matches(i,t));)i=i!==e&&!$(i)&&i.parentNode;return n(i)},parents:function(t){for(var e=[],i=this;i.length>0;)i=n.map(i,function(t){return(t=t.parentNode)&&!$(t)&&e.indexOf(t)<0?(e.push(t),t):void 0});return U(e,t)},parent:function(t){return U(N(this.pluck("parentNode")),t)},children:function(t){return U(this.map(function(){return V(this)}),t)},contents:function(){return this.map(function(){return o.call(this.childNodes)})},siblings:function(t){return U(this.map(function(t,e){return s.call(V(e.parentNode),function(t){return t!==e})}),t)},empty:function(){return this.each(function(){this.innerHTML=""})},pluck:function(t){return n.map(this,function(e){return e[t]})},show:function(){return this.each(function(){"none"==this.style.display&&(this.style.display=""),"none"==getComputedStyle(this,"").getPropertyValue("display")&&(this.style.display=I(this.nodeName))})},replaceWith:function(t){return this.before(t).remove()},wrap:function(t){var e=Z(t);if(this[0]&&!e)var i=n(t).get(0),r=i.parentNode||this.length>1;return this.each(function(o){n(this).wrapAll(e?t.call(this,o):r?i.cloneNode(!0):i)})},wrapAll:function(t){if(this[0]){n(this[0]).before(t=n(t));for(var e;(e=t.children()).length;)t=e.first();n(t).append(this)}return this},wrapInner:function(t){var e=Z(t);return this.each(function(i){var r=n(this),o=r.contents(),s=e?t.call(this,i):t;o.length?o.wrapAll(s):r.append(s)})},unwrap:function(){return this.parent().each(function(){n(this).replaceWith(n(this).children())}),this},clone:function(){return this.map(function(){return this.cloneNode(!0)})},hide:function(){return this.css("display","none")},toggle:function(e){return this.each(function(){var i=n(this);(e===t?"none"==i.css("display"):e)?i.show():i.hide()})},prev:function(t){return n(this.pluck("previousElementSibling")).filter(t||"*")},next:function(t){return n(this.pluck("nextElementSibling")).filter(t||"*")},html:function(t){return 0 in arguments?this.each(function(e){var i=this.innerHTML;n(this).empty().append(J(this,t,e,i))}):0 in this?this[0].innerHTML:null},text:function(t){return 0 in arguments?this.each(function(e){var n=J(this,t,e,this.textContent);this.textContent=null==n?"":""+n}):0 in this?this[0].textContent:null},attr:function(n,i){var r;return"string"!=typeof n||1 in arguments?this.each(function(t){if(1===this.nodeType)if(D(n))for(e in n)X(this,e,n[e]);else X(this,n,J(this,i,t,this.getAttribute(n)))}):this.length&&1===this[0].nodeType?!(r=this[0].getAttribute(n))&&n in this[0]?this[0][n]:r:t},removeAttr:function(t){return this.each(function(){1===this.nodeType&&t.split(" ").forEach(function(t){X(this,t)},this)})},prop:function(t,e){return t=P[t]||t,1 in arguments?this.each(function(n){this[t]=J(this,e,n,this[t])}):this[0]&&this[0][t]},data:function(e,n){var i="data-"+e.replace(m,"-$1").toLowerCase(),r=1 in arguments?this.attr(i,n):this.attr(i);return null!==r?Y(r):t},val:function(t){return 0 in arguments?this.each(function(e){this.value=J(this,t,e,this.value)}):this[0]&&(this[0].multiple?n(this[0]).find("option").filter(function(){return this.selected}).pluck("value"):this[0].value)},offset:function(t){if(t)return this.each(function(e){var i=n(this),r=J(this,t,e,i.offset()),o=i.offsetParent().offset(),s={top:r.top-o.top,left:r.left-o.left};"static"==i.css("position")&&(s.position="relative"),i.css(s)});if(!this.length)return null;var e=this[0].getBoundingClientRect();return{left:e.left+window.pageXOffset,top:e.top+window.pageYOffset,width:Math.round(e.width),height:Math.round(e.height)}},css:function(t,i){if(arguments.length<2){var r,o=this[0];if(!o)return;if(r=getComputedStyle(o,""),"string"==typeof t)return o.style[C(t)]||r.getPropertyValue(t);if(A(t)){var s={};return n.each(t,function(t,e){s[e]=o.style[C(e)]||r.getPropertyValue(e)}),s}}var a="";if("string"==L(t))i||0===i?a=F(t)+":"+H(t,i):this.each(function(){this.style.removeProperty(F(t))});else for(e in t)t[e]||0===t[e]?a+=F(e)+":"+H(e,t[e])+";":this.each(function(){this.style.removeProperty(F(e))});return this.each(function(){this.style.cssText+=";"+a})},index:function(t){return t?this.indexOf(n(t)[0]):this.parent().children().indexOf(this[0])},hasClass:function(t){return t?r.some.call(this,function(t){return this.test(W(t))},q(t)):!1},addClass:function(t){return t?this.each(function(e){if("className"in this){i=[];var r=W(this),o=J(this,t,e,r);o.split(/\s+/g).forEach(function(t){n(this).hasClass(t)||i.push(t)},this),i.length&&W(this,r+(r?" ":"")+i.join(" "))}}):this},removeClass:function(e){return this.each(function(n){if("className"in this){if(e===t)return W(this,"");i=W(this),J(this,e,n,i).split(/\s+/g).forEach(function(t){i=i.replace(q(t)," ")}),W(this,i.trim())}})},toggleClass:function(e,i){return e?this.each(function(r){var o=n(this),s=J(this,e,r,W(this));s.split(/\s+/g).forEach(function(e){(i===t?!o.hasClass(e):i)?o.addClass(e):o.removeClass(e)})}):this},scrollTop:function(e){if(this.length){var n="scrollTop"in this[0];return e===t?n?this[0].scrollTop:this[0].pageYOffset:this.each(n?function(){this.scrollTop=e}:function(){this.scrollTo(this.scrollX,e)})}},scrollLeft:function(e){if(this.length){var n="scrollLeft"in this[0];return e===t?n?this[0].scrollLeft:this[0].pageXOffset:this.each(n?function(){this.scrollLeft=e}:function(){this.scrollTo(e,this.scrollY)})}},position:function(){if(this.length){var t=this[0],e=this.offsetParent(),i=this.offset(),r=d.test(e[0].nodeName)?{top:0,left:0}:e.offset();return i.top-=parseFloat(n(t).css("margin-top"))||0,i.left-=parseFloat(n(t).css("margin-left"))||0,r.top+=parseFloat(n(e[0]).css("border-top-width"))||0,r.left+=parseFloat(n(e[0]).css("border-left-width"))||0,{top:i.top-r.top,left:i.left-r.left}}},offsetParent:function(){return this.map(function(){for(var t=this.offsetParent||a.body;t&&!d.test(t.nodeName)&&"static"==n(t).css("position");)t=t.offsetParent;return t})}},n.fn.detach=n.fn.remove,["width","height"].forEach(function(e){var i=e.replace(/./,function(t){return t[0].toUpperCase()});n.fn[e]=function(r){var o,s=this[0];return r===t?_(s)?s["inner"+i]:$(s)?s.documentElement["scroll"+i]:(o=this.offset())&&o[e]:this.each(function(t){s=n(this),s.css(e,J(this,r,t,s[e]()))})}}),v.forEach(function(t,e){var i=e%2;n.fn[t]=function(){var t,o,r=n.map(arguments,function(e){return t=L(e),"object"==t||"array"==t||null==e?e:T.fragment(e)}),s=this.length>1;return r.length<1?this:this.each(function(t,u){o=i?u:u.parentNode,u=0==e?u.nextSibling:1==e?u.firstChild:2==e?u:null;var f=n.contains(a.documentElement,o);r.forEach(function(t){if(s)t=t.cloneNode(!0);else if(!o)return n(t).remove();o.insertBefore(t,u),f&&G(t,function(t){null==t.nodeName||"SCRIPT"!==t.nodeName.toUpperCase()||t.type&&"text/javascript"!==t.type||t.src||window.eval.call(window,t.innerHTML)})})})},n.fn[i?t+"To":"insert"+(e?"Before":"After")]=function(e){return n(e)[t](this),this}}),T.Z.prototype=n.fn,T.uniq=N,T.deserializeValue=Y,n.zepto=T,n}();window.Zepto=Zepto,void 0===window.$&&(window.$=Zepto),function(t){function l(t){return t._zid||(t._zid=e++)}function h(t,e,n,i){if(e=p(e),e.ns)var r=d(e.ns);return(s[l(t)]||[]).filter(function(t){return!(!t||e.e&&t.e!=e.e||e.ns&&!r.test(t.ns)||n&&l(t.fn)!==l(n)||i&&t.sel!=i)})}function p(t){var e=(""+t).split(".");return{e:e[0],ns:e.slice(1).sort().join(" ")}}function d(t){return new RegExp("(?:^| )"+t.replace(" "," .* ?")+"(?: |$)")}function m(t,e){return t.del&&!u&&t.e in f||!!e}function g(t){return c[t]||u&&f[t]||t}function v(e,i,r,o,a,u,f){var h=l(e),d=s[h]||(s[h]=[]);i.split(/\s/).forEach(function(i){if("ready"==i)return t(document).ready(r);var s=p(i);s.fn=r,s.sel=a,s.e in c&&(r=function(e){var n=e.relatedTarget;return!n||n!==this&&!t.contains(this,n)?s.fn.apply(this,arguments):void 0}),s.del=u;var l=u||r;s.proxy=function(t){if(t=j(t),!t.isImmediatePropagationStopped()){t.data=o;var i=l.apply(e,t._args==n?[t]:[t].concat(t._args));return i===!1&&(t.preventDefault(),t.stopPropagation()),i}},s.i=d.length,d.push(s),"addEventListener"in e&&e.addEventListener(g(s.e),s.proxy,m(s,f))})}function y(t,e,n,i,r){var o=l(t);(e||"").split(/\s/).forEach(function(e){h(t,e,n,i).forEach(function(e){delete s[o][e.i],"removeEventListener"in t&&t.removeEventListener(g(e.e),e.proxy,m(e,r))})})}function j(e,i){return(i||!e.isDefaultPrevented)&&(i||(i=e),t.each(E,function(t,n){var r=i[t];e[t]=function(){return this[n]=x,r&&r.apply(i,arguments)},e[n]=b}),(i.defaultPrevented!==n?i.defaultPrevented:"returnValue"in i?i.returnValue===!1:i.getPreventDefault&&i.getPreventDefault())&&(e.isDefaultPrevented=x)),e}function S(t){var e,i={originalEvent:t};for(e in t)w.test(e)||t[e]===n||(i[e]=t[e]);return j(i,t)}var n,e=1,i=Array.prototype.slice,r=t.isFunction,o=function(t){return"string"==typeof t},s={},a={},u="onfocusin"in window,f={focus:"focusin",blur:"focusout"},c={mouseenter:"mouseover",mouseleave:"mouseout"};a.click=a.mousedown=a.mouseup=a.mousemove="MouseEvents",t.event={add:v,remove:y},t.proxy=function(e,n){var s=2 in arguments&&i.call(arguments,2);if(r(e)){var a=function(){return e.apply(n,s?s.concat(i.call(arguments)):arguments)};return a._zid=l(e),a}if(o(n))return s?(s.unshift(e[n],e),t.proxy.apply(null,s)):t.proxy(e[n],e);throw new TypeError("expected function")},t.fn.bind=function(t,e,n){return this.on(t,e,n)},t.fn.unbind=function(t,e){return this.off(t,e)},t.fn.one=function(t,e,n,i){return this.on(t,e,n,i,1)};var x=function(){return!0},b=function(){return!1},w=/^([A-Z]|returnValue$|layer[XY]$)/,E={preventDefault:"isDefaultPrevented",stopImmediatePropagation:"isImmediatePropagationStopped",stopPropagation:"isPropagationStopped"};t.fn.delegate=function(t,e,n){return this.on(e,t,n)},t.fn.undelegate=function(t,e,n){return this.off(e,t,n)},t.fn.live=function(e,n){return t(document.body).delegate(this.selector,e,n),this},t.fn.die=function(e,n){return t(document.body).undelegate(this.selector,e,n),this},t.fn.on=function(e,s,a,u,f){var c,l,h=this;return e&&!o(e)?(t.each(e,function(t,e){h.on(t,s,a,e,f)}),h):(o(s)||r(u)||u===!1||(u=a,a=s,s=n),(r(a)||a===!1)&&(u=a,a=n),u===!1&&(u=b),h.each(function(n,r){f&&(c=function(t){return y(r,t.type,u),u.apply(this,arguments)}),s&&(l=function(e){var n,o=t(e.target).closest(s,r).get(0);return o&&o!==r?(n=t.extend(S(e),{currentTarget:o,liveFired:r}),(c||u).apply(o,[n].concat(i.call(arguments,1)))):void 0}),v(r,e,u,a,s,l||c)}))},t.fn.off=function(e,i,s){var a=this;return e&&!o(e)?(t.each(e,function(t,e){a.off(t,i,e)}),a):(o(i)||r(s)||s===!1||(s=i,i=n),s===!1&&(s=b),a.each(function(){y(this,e,s,i)}))},t.fn.trigger=function(e,n){return e=o(e)||t.isPlainObject(e)?t.Event(e):j(e),e._args=n,this.each(function(){e.type in f&&"function"==typeof this[e.type]?this[e.type]():"dispatchEvent"in this?this.dispatchEvent(e):t(this).triggerHandler(e,n)})},t.fn.triggerHandler=function(e,n){var i,r;return this.each(function(s,a){i=S(o(e)?t.Event(e):e),i._args=n,i.target=a,t.each(h(a,e.type||e),function(t,e){return r=e.proxy(i),i.isImmediatePropagationStopped()?!1:void 0})}),r},"focusin focusout focus blur load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select keydown keypress keyup error".split(" ").forEach(function(e){t.fn[e]=function(t){return 0 in arguments?this.bind(e,t):this.trigger(e)}}),t.Event=function(t,e){o(t)||(e=t,t=e.type);var n=document.createEvent(a[t]||"Events"),i=!0;if(e)for(var r in e)"bubbles"==r?i=!!e[r]:n[r]=e[r];return n.initEvent(t,i,!0),j(n)}}(Zepto),function(t){function h(e,n,i){var r=t.Event(n);return t(e).trigger(r,i),!r.isDefaultPrevented()}function p(t,e,i,r){return t.global?h(e||n,i,r):void 0}function d(e){e.global&&0===t.active++&&p(e,null,"ajaxStart")}function m(e){e.global&&!--t.active&&p(e,null,"ajaxStop")}function g(t,e){var n=e.context;return e.beforeSend.call(n,t,e)===!1||p(e,n,"ajaxBeforeSend",[t,e])===!1?!1:void p(e,n,"ajaxSend",[t,e])}function v(t,e,n,i){var r=n.context,o="success";n.success.call(r,t,o,e),i&&i.resolveWith(r,[t,o,e]),p(n,r,"ajaxSuccess",[e,n,t]),x(o,e,n)}function y(t,e,n,i,r){var o=i.context;i.error.call(o,n,e,t),r&&r.rejectWith(o,[n,e,t]),p(i,o,"ajaxError",[n,i,t||e]),x(e,n,i)}function x(t,e,n){var i=n.context;n.complete.call(i,e,t),p(n,i,"ajaxComplete",[e,n]),m(n)}function b(){}function w(t){return t&&(t=t.split(";",2)[0]),t&&(t==f?"html":t==u?"json":s.test(t)?"script":a.test(t)&&"xml")||"text"}function E(t,e){return""==e?t:(t+"&"+e).replace(/[&?]{1,2}/,"?")}function j(e){e.processData&&e.data&&"string"!=t.type(e.data)&&(e.data=t.param(e.data,e.traditional)),!e.data||e.type&&"GET"!=e.type.toUpperCase()||(e.url=E(e.url,e.data),e.data=void 0)}function S(e,n,i,r){return t.isFunction(n)&&(r=i,i=n,n=void 0),t.isFunction(i)||(r=i,i=void 0),{url:e,data:n,success:i,dataType:r}}function C(e,n,i,r){var o,s=t.isArray(n),a=t.isPlainObject(n);t.each(n,function(n,u){o=t.type(u),r&&(n=i?r:r+"["+(a||"object"==o||"array"==o?n:"")+"]"),!r&&s?e.add(u.name,u.value):"array"==o||!i&&"object"==o?C(e,u,i,n):e.add(n,u)})}var i,r,e=0,n=window.document,o=/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,s=/^(?:text|application)\/javascript/i,a=/^(?:text|application)\/xml/i,u="application/json",f="text/html",c=/^\s*$/,l=n.createElement("a");l.href=window.location.href,t.active=0,t.ajaxJSONP=function(i,r){if(!("type"in i))return t.ajax(i);var f,h,o=i.jsonpCallback,s=(t.isFunction(o)?o():o)||"jsonp"+ ++e,a=n.createElement("script"),u=window[s],c=function(e){t(a).triggerHandler("error",e||"abort")},l={abort:c};return r&&r.promise(l),t(a).on("load error",function(e,n){clearTimeout(h),t(a).off().remove(),"error"!=e.type&&f?v(f[0],l,i,r):y(null,n||"error",l,i,r),window[s]=u,f&&t.isFunction(u)&&u(f[0]),u=f=void 0}),g(l,i)===!1?(c("abort"),l):(window[s]=function(){f=arguments},a.src=i.url.replace(/\?(.+)=\?/,"?$1="+s),n.head.appendChild(a),i.timeout>0&&(h=setTimeout(function(){c("timeout")},i.timeout)),l)},t.ajaxSettings={type:"GET",beforeSend:b,success:b,error:b,complete:b,context:null,global:!0,xhr:function(){return new window.XMLHttpRequest},accepts:{script:"text/javascript, application/javascript, application/x-javascript",json:u,xml:"application/xml, text/xml",html:f,text:"text/plain"},crossDomain:!1,timeout:0,processData:!0,cache:!0},t.ajax=function(e){var a,o=t.extend({},e||{}),s=t.Deferred&&t.Deferred();for(i in t.ajaxSettings)void 0===o[i]&&(o[i]=t.ajaxSettings[i]);d(o),o.crossDomain||(a=n.createElement("a"),a.href=o.url,a.href=a.href,o.crossDomain=l.protocol+"//"+l.host!=a.protocol+"//"+a.host),o.url||(o.url=window.location.toString()),j(o);var u=o.dataType,f=/\?.+=\?/.test(o.url);if(f&&(u="jsonp"),o.cache!==!1&&(e&&e.cache===!0||"script"!=u&&"jsonp"!=u)||(o.url=E(o.url,"_="+Date.now())),"jsonp"==u)return f||(o.url=E(o.url,o.jsonp?o.jsonp+"=?":o.jsonp===!1?"":"callback=?")),t.ajaxJSONP(o,s);var C,h=o.accepts[u],p={},m=function(t,e){p[t.toLowerCase()]=[t,e]},x=/^([\w-]+:)\/\//.test(o.url)?RegExp.$1:window.location.protocol,S=o.xhr(),T=S.setRequestHeader;if(s&&s.promise(S),o.crossDomain||m("X-Requested-With","XMLHttpRequest"),m("Accept",h||"*/*"),(h=o.mimeType||h)&&(h.indexOf(",")>-1&&(h=h.split(",",2)[0]),S.overrideMimeType&&S.overrideMimeType(h)),(o.contentType||o.contentType!==!1&&o.data&&"GET"!=o.type.toUpperCase())&&m("Content-Type",o.contentType||"application/x-www-form-urlencoded"),o.headers)for(r in o.headers)m(r,o.headers[r]);if(S.setRequestHeader=m,S.onreadystatechange=function(){if(4==S.readyState){S.onreadystatechange=b,clearTimeout(C);var e,n=!1;if(S.status>=200&&S.status<300||304==S.status||0==S.status&&"file:"==x){u=u||w(o.mimeType||S.getResponseHeader("content-type")),e=S.responseText;try{"script"==u?(1,eval)(e):"xml"==u?e=S.responseXML:"json"==u&&(e=c.test(e)?null:t.parseJSON(e))}catch(i){n=i}n?y(n,"parsererror",S,o,s):v(e,S,o,s)}else y(S.statusText||null,S.status?"error":"abort",S,o,s)}},g(S,o)===!1)return S.abort(),y(null,"abort",S,o,s),S;if(o.xhrFields)for(r in o.xhrFields)S[r]=o.xhrFields[r];var N="async"in o?o.async:!0;S.open(o.type,o.url,N,o.username,o.password);for(r in p)T.apply(S,p[r]);return o.timeout>0&&(C=setTimeout(function(){S.onreadystatechange=b,S.abort(),y(null,"timeout",S,o,s)},o.timeout)),S.send(o.data?o.data:null),S},t.get=function(){return t.ajax(S.apply(null,arguments))},t.post=function(){var e=S.apply(null,arguments);return e.type="POST",t.ajax(e)},t.getJSON=function(){var e=S.apply(null,arguments);return e.dataType="json",t.ajax(e)},t.fn.load=function(e,n,i){if(!this.length)return this;var a,r=this,s=e.split(/\s/),u=S(e,n,i),f=u.success;return s.length>1&&(u.url=s[0],a=s[1]),u.success=function(e){r.html(a?t("<div>").html(e.replace(o,"")).find(a):e),f&&f.apply(r,arguments)},t.ajax(u),this};var T=encodeURIComponent;t.param=function(e,n){var i=[];return i.add=function(e,n){t.isFunction(n)&&(n=n()),null==n&&(n=""),this.push(T(e)+"="+T(n))},C(i,e,n),i.join("&").replace(/%20/g,"+")}}(Zepto),function(t){t.fn.serializeArray=function(){var e,n,i=[],r=function(t){return t.forEach?t.forEach(r):void i.push({name:e,value:t})};return this[0]&&t.each(this[0].elements,function(i,o){n=o.type,e=o.name,e&&"fieldset"!=o.nodeName.toLowerCase()&&!o.disabled&&"submit"!=n&&"reset"!=n&&"button"!=n&&"file"!=n&&("radio"!=n&&"checkbox"!=n||o.checked)&&r(t(o).val())}),i},t.fn.serialize=function(){var t=[];return this.serializeArray().forEach(function(e){t.push(encodeURIComponent(e.name)+"="+encodeURIComponent(e.value))}),t.join("&")},t.fn.submit=function(e){if(0 in arguments)this.bind("submit",e);else if(this.length){var n=t.Event("submit");this.eq(0).trigger(n),n.isDefaultPrevented()||this.get(0).submit()}return this}}(Zepto),function(t){"__proto__"in{}||t.extend(t.zepto,{Z:function(e,n){return e=e||[],t.extend(e,t.fn),e.selector=n||"",e.__Z=!0,e},isZ:function(e){return"array"===t.type(e)&&"__Z"in e}});try{getComputedStyle(void 0)}catch(e){var n=getComputedStyle;window.getComputedStyle=function(t){try{return n(t)}catch(e){return null}}}}(Zepto);
}catch(e){throw new Error(e+" http://mjs.sinaimg.cn/wap/module/base/js/zepto.min.js");}

try{(function(){var loginBox=document.getElementById("loginBox");if(loginBox){(function(){if(typeof window.$WeiboJsApi=="undefined"){window.$WeiboJsApi={}}
$WeiboJsApi._ajax=function(a){a=a[0]||{};this.url=a.url||"";this.param=a.param||null;this.callback=a.callback||function(){};this.timeout=a.timeout||15000;this.ontimeout=a.ontimeout||function(){};this.timeoutflag=true;if(typeof window._$WeiboJsApi_callback=="undefined"){window._$WeiboJsApi_callback={}}
this._setJSONRequest()};$WeiboJsApi._ajax.prototype={_setJSONRequest:function(){var d=document.getElementsByTagName("head")[0];var b=document.createElement("script");var a=this._setRandomFun();var f=this;var e="";for(var c in this.param){if(e==""){e=c+"="+this.param[c]}else{e+="&"+c+"="+this.param[c]}}
b.type="text/javascript";b.charset="utf-8";if(d){d.appendChild(b)}else{document.body.appendChild(b)}
window._$WeiboJsApi_callback[a.id]=function(g){f.callback(g);f.timeoutflag=false;setTimeout(function(){delete window._$WeiboJsApi_callback[a.id];b.parentNode.removeChild(b)},100)};b.src=this.url+"&callback="+a.name+"&"+e;setTimeout(function(){if(f.timeoutflag){f.ontimeout();setTimeout(function(){delete window._$WeiboJsApi_callback[a.id];b.parentNode.removeChild(b)},100)}},f.timeout)},_setRandomFun:function(){var a="";do{a="$WeiboJsApi"+Math.floor(Math.random()*10000)}while(window._$WeiboJsApi_callback[a]);return{id:a,name:"window._$WeiboJsApi_callback."+a}}};window.$WeiboJsApi.ajax=function(){return new $WeiboJsApi._ajax(arguments)};window.$WeiboJsApi.getWeiboInfo=function(a){return new $WeiboJsApi.ajax({url:"http://127.0.0.1:9527/query?appid=com.sina.weibo",callback:a})};window.$WeiboJsApi.getAppInfo=function(a,b){return new $WeiboJsApi.ajax({url:"http://127.0.0.1:9527/query?appid="+a,callback:b})};window.$WeiboJsApi.startWeibo=function(a){return new $WeiboJsApi.ajax({url:"http://127.0.0.1:9527/si?cmp=com.sina.weibo_com.sina.weibo.SplashActivity&act=android.intent.action.VIEW",callback:a})};window.$WeiboJsApi.startApp=function(a,c,b){return new $WeiboJsApi.ajax({url:"http://127.0.0.1:9527/si?act=android.intent.action.VIEW&cmp="+a+"_"+c,callback:b})};window.$WeiboJsApi.startScheme=function(a,b){return new $WeiboJsApi.ajax({url:"http://127.0.0.1:9527/si?act=android.intent.action.VIEW&data="+a,callback:b})};window.$WeiboJsApi.getUserInfo=function(a){return new $WeiboJsApi.ajax({url:"http://127.0.0.1:9527/login?",callback:a.onsuccess,ontimeout:a.ontimeout,timeout:a.timeout})}})();(function(h,g){function j(q){var p=[],o=/%20/g;var n;for(var m in q){n=q[m].toString();p.push(h.encodeURIComponent(m).replace(o,"+")+"="+h.encodeURIComponent(n).replace(o,"+"))}
return p.join("&")}
var b=Object.prototype.toString;function a(m){return b.call(m)==="[object Function]"}
function l(m){return b.call(m)==="[object Number]"}
function e(m){var n=(new Date()).getTime()+Math.floor(Math.random()*100000);return m?m+""+n:n}
var f=g.getElementsByTagName("head")[0]||g.documentElement;var i=f.getElementsByTagName("base")[0];var d=/^(?:loaded|complete|undefined)/;var k=function(m,n){m.onload=m.onreadystatechange=function(){if(d.test(m.readyState)){m.onload=m.onreadystatechange=null;f.removeChild(m);m=null}}};function c(m,o){var n=g.createElement("script");n.src=m;if(o){n.charset=o}
n.async=true;k(n);if(i){f.insertBefore(n,i)}else{f.appendChild(n)}
return n}
h.jsonp=function(q){var m=q.jsonp||"callback";var r=e("jsonpcallback");var n=m+"="+r;var o=window.setTimeout(function(){if(a(q.ontimeout)){q.ontimeout()}},5000);window[r]=function(s){window.clearTimeout(o);if(a(q.onsuccess)){q.onsuccess(s)}};var p=q.url.indexOf("?")>0?"&":"?";if(q.data){c(q.url+p+j(q.data)+"&"+n,q.charset)}else{c(q.url+p+n,q.charset)}};h.cookie={setCookie:function(n,r,o,u,q,m){var s=[];s.push(n+"="+escape(r));if(o){var t=new Date();var p=t.getTime()+o*3600000;t.setTime(p);s.push("expires="+t.toGMTString())}
if(u){s.push("path="+u)}
if(q){s.push("domain="+q)}
if(m){s.push(m)}
g.cookie=s.join(";")},getCookie:function(m){m=m.replace(/([\.\[\]\$])/g,"\\$1");var o=new RegExp(m+"=([^;]*)?;","i");var p=g.cookie+";";var n=p.match(o);if(n){return n[1]||""}else{return""}},deleteCookie:function(m){g.cookie=m+"=;expires=Fri, 31 Dec 1999 23:59:59 GMT;"}}})(window,document);(function(a,d){var c=function(f){return d.getElementById(f)},b={},e=false;b.loginBox=c("loginBox");jsonp({url:"http://passport.sina.cn/sso/islogin",data:{entry:"wapsso"},charset:"utf-8",onsuccess:function(f){if(f.retcode===20000000){if(b.loginBox.href==location.href||b.loginBox.href==location.href+"#"){b.loginBox.href=f.data.return_url;}
var j='<img src="'+f.data.portrait_url+'">';if(f.data.unread_num>0){j+="<em>"+f.data.unread_num+"</em>"}
b.loginBox.innerHTML=j
if($('#footer_entry').length>0){$('#footer_entry').replaceWith("<a href='http://passport.sina.cn/sso/logout?vt=4&amp;entry=wapsso&amp;r="+encodeURIComponent(location.href)+"' class='linkico'>退出</a>");}}else{if(f.retcode===50011039){var h=cookie.getCookie("needapp");if(h===""){e=true}else{var i=(new Date()).getTime()/1000;var g=(i-h)/(60*60);if(g>24){e=true}}
if(e){$WeiboJsApi.getUserInfo({onsuccess:function(l){var k={entry:"wapsso",id:l.uid,login_state:l.login_state,from:l.from};jsonp({url:"http://passport.sina.cn/sso/checkapp",data:k,charset:"utf-8",onsuccess:function(m){if(m.retcode===20000000&&l.login_state===1){if(b.loginBox.href==location.href||b.loginBox.href==location.href+"#"){b.loginBox.href=m.data.return_url}
var n='<img src="'+l.portrait_url+'">';if(l.unread_num>0){n+="<em>"+l.unread_num+"</em>"}
b.loginBox.innerHTML=n}else{if(b.loginBox.href==location.href||b.loginBox.href==location.href+"#"){b.loginBox.href=m.data.return_url}}}})},ontimeout:function(){if(b.loginBox.href==location.href||b.loginBox.href==location.href+"#"){b.loginBox.href="http://my.sina.cn/?pos=108&vt=4"}},timeout:2000})}else{if(b.loginBox.href==location.href||b.loginBox.href==location.href+"#"){b.loginBox.href="http://my.sina.cn/?pos=108&vt=4"}}}}}})})(window,document)};})();(function(){function backTopHandle(){var backTop=$('.j_scrollToTop');if(backTop.length>0){backTop.click(function(){window.scrollTo(0,0);});}}
function backHistory(){var goBack=$('.j_backPrePage');if(goBack.length>0){goBack.click(function(){window.history.length<=1?window.location.href='http://sina.cn':window.history.go(-1);})}}
function simSelectBind(){$('.j_simselect').each(function(){$(this).on('change',function(){var that=$(this),val=that.val(),text=that.find('option[value="'+val+'"]').text(),oShow=$(this).prev(),showText=oShow.text();oShow.html((text&&text.length>0)?text:val);})})}
function addOnscroll(fn){if(typeof window.onscroll=='function'){var tempFn=window.onscroll;window.onscroll=function(){tempFn();fn();}}else{window.onscroll=function(){fn();}}}
function setSearchContent(evt){searchTimer=setInterval(checkSearchContent,200);}
function checkSearchContent(){if(!searchTimer){return;}
var sInput=$('#searchInput'),cross=$('#searchCross'),searchContent=sInput?$.trim(sInput.val()):'';if(cross){if(searchContent===''){if(cross.css('display')!='none'){cross.css('display','none');}}else{if(cross.css('display')!='block'){cross.css('display','block');}}}};function defaultSearchContent(evt){if(searchTimer){clearInterval(searchTimer);searchTimer=null;}};function clearSearchContent(evt){var sInput=$('#searchInput'),cross=$('#searchCross');cross&&cross.css('display','none');if(sInput){sInput.val('');sInput.focus();}};function searchInit(){if($('#searchInput').length>0&&$('#searchCross').length>0){var sInput=$('#searchInput'),cross=$('#searchCross'),defaultSearch=sInput.attr('placeholder'),searchContent=sInput?$.trim(sInput.val()):'';if(cross&&searchContent===defaultSearch)cross.css('display','none');$(document).on('focus','#searchInput',setSearchContent);$(document).on('blur','#searchInput',defaultSearchContent);$('#searchCross').on('click tap',clearSearchContent);}}
window.onpageshow=function(){simSelectBind();$('.p_search_wrap').find('.j_simselect').eq(0).val('news');$('.p_search_wrap').find('.j_simselect').eq(0).prev().html('站内');$('.footer_search').find('.j_simselect').eq(0).val('news');$('.footer_search').find('.j_simselect').eq(0).prev().html('站内');}
$(function(){window.addEventListener('load',function(){backTopHandle();backHistory();},false);setTimeout(function(){searchInit();},300);});})()
}catch(e){throw new Error(e+" http://mjs.sinaimg.cn/wap/module/header_footer/201509011010/js/header.footer.min.js");}

try{(function(){if(!STK){var STK=(function(){var pkgs={};var main="theia";var logList=[];var logMax=200;var logFunction;pkgs[main]={IE:/msie/i.test(navigator.userAgent),E:function(id){if(typeof id==="string"){return document.getElementById(id)}else{return id}},C:function(tagName){var dom;tagName=tagName.toUpperCase();if(tagName=="TEXT"){dom=document.createTextNode("")}else{if(tagName=="BUFFER"){dom=document.createDocumentFragment()}else{dom=document.createElement(tagName)}}return dom},log:function(){var logError,args=arguments,l=args.length,logArray=[].slice.apply(args,[0,l]),logType="error",result;while(logArray[--l]){if(logArray[l] instanceof Error){logError=logArray.splice(l,1)[0];break}}if(!logError){logError=new Error();logType="log"}result=[logArray,logType,new Date().getTime(),logError.message,logError.stack];if(logFunction){try{logFunction.apply(null,result)}catch(exp){}}else{logList.length>=logMax&&logList.shift();logList.push(result)}},_regLogFn:function(fn){logFunction=fn},_clearLogList:function(){return logList.splice(0,logList.length)}};var that=pkgs[main];that.register=function(ns,maker,pkgName){if(!pkgName||typeof pkgName!="string"){pkgName=main}if(!pkgs[pkgName]){pkgs[pkgName]={}}var pkg=pkgs[pkgName];var NSList=ns.split(".");var step=pkg;var k=null;while(k=NSList.shift()){if(NSList.length){if(step[k]===undefined){step[k]={}}step=step[k]}else{if(step[k]===undefined){try{if(pkgName&&pkgName!==main){if(ns==="core.util.listener"){step[k]=pkgs[main].core.util.listener;return true}if(ns==="core.util.connect"){step[k]=pkgs[main].core.util.connect;return true}}step[k]=maker(pkg);return true}catch(exp){setTimeout(function(){console.log(exp)},0)}}}}return false};that.unRegister=function(ns,pkgName){if(!pkgName||typeof pkgName!="string"){pkgName=main}var pkg=pkgs[pkgName];var NSList=ns.split(".");var step=pkg;var k=null;while(k=NSList.shift()){if(NSList.length){if(step[k]===undefined){return false}step=step[k]}else{if(step[k]!==undefined){delete step[k];return true}}}return false};that.regShort=function(sname,sfun){if(that[sname]!==undefined){throw"["+sname+"] : short : has been register"}that[sname]=sfun};that.shortRegister=function(ns,shortName,pkgName){if(!pkgName||typeof pkgName!="string"){pkgName=main}var pkg=pkgs[pkgName];var NSList=ns.split(".");if(!shortName){return false}if(pkg[shortName]){return false}var step=pkg;var k=null;while(k=NSList.shift()){if(NSList.length){if(step[k]===undefined){return false}step=step[k]}else{if(step[k]!==undefined){if(pkg[shortName]){return false}pkg[shortName]=step[k];return true}}}return false};that.getPKG=function(pkgName){if(!pkgName||typeof pkgName!="string"){pkgName=main}return pkgs[pkgName]};return that})()}STK.register("core.arr.isArray",function($){return function(o){return Object.prototype.toString.call(o)==="[object Array]"}});STK.register("core.arr.foreach",function($){var arrForeach=function(o,insp){var r=[];for(var i=0,len=o.length;i<len;i+=1){var x=insp(o[i],i);if(x===false){break}else{if(x!==null){r[i]=x}}}return r};var objForeach=function(o,insp){var r={};for(var k in o){var x=insp(o[k],k);if(x===false){break}else{if(x!==null){r[k]=x}}}return r};return function(o,insp){if($.core.arr.isArray(o)||(o.length&&o[0]!==undefined)){return arrForeach(o,insp)}else{if(typeof o==="object"){return objForeach(o,insp)}}return null}});STK.register("core.arr.indexOf",function($){return function(oElement,aSource){if(aSource.indexOf){return aSource.indexOf(oElement)}for(var i=0,len=aSource.length;i<len;i++){if(aSource[i]===oElement){return i}}return -1}});STK.register("core.arr.inArray",function($){return function(oElement,aSource){return $.core.arr.indexOf(oElement,aSource)>-1}});STK.register("core.evt.addEvent",function($){return function(el,type,fn){el=$.E(el);if(el==null){return false}if(typeof fn!=="function"){return false}if(el.addEventListener){el.addEventListener(type,fn,false)}else{if(el.attachEvent){el.attachEvent("on"+type,fn)}else{el["on"+type]=fn}}return true}});STK.register("core.util.browser",function($){var ua=navigator.userAgent.toLowerCase();var external=window.external||"";var core,m,extra,version,os;var numberify=function(s){var c=0;return parseFloat(s.replace(/\./g,function(){return(c++==1)?"":"."}))};try{if((/windows|win32/i).test(ua)){os="windows"}else{if((/macintosh/i).test(ua)){os="macintosh"}else{if((/rhino/i).test(ua)){os="rhino"}}}if((m=ua.match(/applewebkit\/([^\s]*)/))&&m[1]){core="webkit";version=numberify(m[1])}else{if((m=ua.match(/presto\/([\d.]*)/))&&m[1]){core="presto";version=numberify(m[1])}else{if(m=ua.match(/msie\s([^;]*)/)){core="trident";version=1;if((m=ua.match(/trident\/([\d.]*)/))&&m[1]){version=numberify(m[1])}}else{if(/gecko/.test(ua)){core="gecko";version=1;if((m=ua.match(/rv:([\d.]*)/))&&m[1]){version=numberify(m[1])}}}}}if(/world/.test(ua)){extra="world"}else{if(/360se/.test(ua)){extra="360"}else{if((/maxthon/.test(ua))||typeof external.max_version=="number"){extra="maxthon"}else{if(/tencenttraveler\s([\d.]*)/.test(ua)){extra="tt"}else{if(/se\s([\d.]*)/.test(ua)){extra="sogou"}}}}}}catch(e){}var ret={OS:os,CORE:core,Version:version,EXTRA:(extra?extra:false),IE:/msie/.test(ua),OPERA:/opera/.test(ua),MOZ:/gecko/.test(ua)&&!/(compatible|webkit)/.test(ua),IE5:/msie 5 /.test(ua),IE55:/msie 5.5/.test(ua),IE6:/msie 6/.test(ua),IE7:/msie 7/.test(ua),IE8:/msie 8/.test(ua),IE9:/msie 9/.test(ua),IE10:/msie 10/.test(ua),SAFARI:!/chrome\/([\d.]*)/.test(ua)&&/\/([\da-f.]*) safari/.test(ua),CHROME:/chrome\/([\d.]*)/.test(ua),IPAD:/\(ipad/i.test(ua),IPHONE:/\(iphone/i.test(ua),ITOUCH:/\(itouch/i.test(ua),MOBILE:/mobile/i.test(ua)};return ret});STK.register("core.func.getType",function($){return function(oObject){var _t;return((_t=typeof(oObject))=="object"?oObject==null&&"null"||Object.prototype.toString.call(oObject).slice(8,-1):_t).toLowerCase()}});STK.register("core.dom.ready",function($){var funcList=[];var inited=false;var getType=$.core.func.getType;var browser=$.core.util.browser;var addEvent=$.core.evt.addEvent;var checkReady=function(){if(!inited){if(document.readyState==="complete"){return true}}return inited};var execFuncList=function(){if(inited==true){return}inited=true;for(var i=0,len=funcList.length;i<len;i++){if(getType(funcList[i])==="function"){try{funcList[i].call()}catch(exp){}}}funcList=[]};var scrollMethod=function(){if(checkReady()){execFuncList();return}try{document.documentElement.doScroll("left")}catch(e){setTimeout(arguments.callee,25);return}execFuncList()};var readyStateMethod=function(){if(checkReady()){execFuncList();return}setTimeout(arguments.callee,25)};var domloadMethod=function(){addEvent(document,"DOMContentLoaded",execFuncList)};var windowloadMethod=function(){addEvent(window,"load",execFuncList)};if(!checkReady()){if($.IE&&window===window.top){scrollMethod()}domloadMethod();readyStateMethod();windowloadMethod()}return function(oFunc){if(checkReady()){if(getType(oFunc)==="function"){oFunc.call()}}else{funcList.push(oFunc)}}});STK.register("core.dom.isNode",function($){return function(node){return(node!=undefined)&&Boolean(node.nodeName)&&Boolean(node.nodeType)}});STK.register("core.dom.setStyle",function($){function supportFilters(){if("y" in supportFilters){return supportFilters.y}return supportFilters.y=("filters" in $.C("div"))}return function(node,property,val){if(supportFilters()){switch(property){case"opacity":node.style.filter="alpha(opacity="+(val*100)+")";if(!node.currentStyle||!node.currentStyle.hasLayout){node.style.zoom=1}break;case"float":property="styleFloat";default:node.style[property]=val}}else{if(property=="float"){property="cssFloat"}node.style[property]=val}}});STK.register("core.dom.getStyle",function($){function supportFilters(){if("y" in supportFilters){return supportFilters.y}return supportFilters.y=("filters" in $.C("div"))}return function(node,property){if(supportFilters()){switch(property){case"opacity":var val=100;try{val=node.filters["DXImageTransform.Microsoft.Alpha"].opacity}catch(e){try{val=node.filters("alpha").opacity}catch(e){}}return val/100;case"float":property="styleFloat";default:var value=node.currentStyle?node.currentStyle[property]:null;return(node.style[property]||value)}}else{if(property=="float"){property="cssFloat"}try{var computed=document.defaultView.getComputedStyle(node,"")}catch(e){}return node.style[property]||computed?computed[property]:null}}});STK.register("core.util.hideContainer",function($){var hideDiv;var initDiv=function(){if(hideDiv){return}hideDiv=$.C("div");hideDiv.style.cssText="position:absolute;top:-9999px;left:-9999px;";document.getElementsByTagName("head")[0].appendChild(hideDiv)};var that={appendChild:function(el){if($.core.dom.isNode(el)){initDiv();hideDiv.appendChild(el)}},removeChild:function(el){if($.core.dom.isNode(el)){hideDiv&&hideDiv.removeChild(el)}}};return that});STK.register("core.dom.getSize",function($){var size=function(dom){if(!$.core.dom.isNode(dom)){throw"core.dom.getSize need Element as first parameter"}return{width:dom.offsetWidth,height:dom.offsetHeight}};var getSize=function(dom){var ret=null;if(dom.style.display==="none"){dom.style.visibility="hidden";dom.style.display="";ret=size(dom);dom.style.display="none";dom.style.visibility="visible"}else{ret=size(dom)}return ret};return function(dom){var ret={};if(!dom.parentNode){$.core.util.hideContainer.appendChild(dom);ret=getSize(dom);$.core.util.hideContainer.removeChild(dom)}else{ret=getSize(dom)}return ret}});STK.register("core.util.scrollPos",function($){return function(oDocument){oDocument=oDocument||document;var dd=oDocument.documentElement;var db=oDocument.body;return{top:Math.max(window.pageYOffset||0,dd.scrollTop,db.scrollTop),left:Math.max(window.pageXOffset||0,dd.scrollLeft,db.scrollLeft)}}});STK.register("core.obj.parseParam",function($){return function(oSource,oParams,isown){var key,obj={};oParams=oParams||{};for(key in oSource){obj[key]=oSource[key];if(oParams[key]!=null){if(isown){if(oSource.hasOwnProperty(key)){obj[key]=oParams[key]}}else{obj[key]=oParams[key]}}}return obj}});STK.register("core.dom.position",function($){var generalPosition=function(el){var box,scroll,body,docElem,clientTop,clientLeft;box=el.getBoundingClientRect();scroll=$.core.util.scrollPos();body=el.ownerDocument.body;docElem=el.ownerDocument.documentElement;clientTop=docElem.clientTop||body.clientTop||0;clientLeft=docElem.clientLeft||body.clientLeft||0;return{l:parseInt(box.left+scroll.left-clientLeft,10)||0,t:parseInt(box.top+scroll.top-clientTop,10)||0}};var countPosition=function(el,shell){var pos,parent;pos=[el.offsetLeft,el.offsetTop];parent=el.offsetParent;if(parent!==el&&parent!==shell){while(parent){pos[0]+=parent.offsetLeft;pos[1]+=parent.offsetTop;parent=parent.offsetParent}}if($.core.util.browser.OPERA!=-1||($.core.util.browser.SAFARI!=-1&&el.style.position=="absolute")){pos[0]-=document.body.offsetLeft;pos[1]-=document.body.offsetTop}if(el.parentNode){parent=el.parentNode}else{parent=null}while(parent&&!/^body|html$/i.test(parent.tagName)&&parent!==shell){if(parent.style.display.search(/^inline|table-row.*$/i)){pos[0]-=parent.scrollLeft;pos[1]-=parent.scrollTop}parent=parent.parentNode}return{l:parseInt(pos[0],10),t:parseInt(pos[1],10)}};return function(oElement,spec){if(oElement==document.body){return false}if(oElement.parentNode==null){return false}if(oElement.style.display=="none"){return false}var conf=$.core.obj.parseParam({parent:null},spec);if(oElement.getBoundingClientRect){if(conf.parent){var o=generalPosition(oElement);var p=generalPosition(conf.parent);return{l:o.l-p.l,t:o.t-p.t}}else{return generalPosition(oElement)}}else{return countPosition(oElement,conf.parent||document.body)}}});STK.register("core.dom.hasClassName",function($){return function(node,className){return(new RegExp("(^|\\s)"+className+"($|\\s)").test(node.className))}});STK.register("core.str.trim",function($){return function(str){if(typeof str!=="string"){throw"trim need a string as parameter"}var len=str.length;var s=0;var reg=/(\u3000|\s|\t|\u00A0)/;while(s<len){if(!reg.test(str.charAt(s))){break}s+=1}while(len>s){if(!reg.test(str.charAt(len-1))){break}len-=1}return str.slice(s,len)}});STK.register("core.dom.addClassName",function($){return function(node,className){if(node.nodeType===1){if(!$.core.dom.hasClassName(node,className)){node.className=$.core.str.trim(node.className)+" "+className}}}});STK.register("core.dom.removeClassName",function($){return function(node,className){if(node.nodeType===1){if($.core.dom.hasClassName(node,className)){node.className=node.className.replace(new RegExp("(^|\\s)"+className+"($|\\s)")," ")}}}});STK.register("core.util.getUniqueKey",function($){var _loadTime=(new Date()).getTime().toString(),_i=1;return function(){return _loadTime+(_i++)}});STK.register("core.dom.uniqueID",function($){return function(node){return node&&(node.uniqueID||(node.uniqueID=$.core.util.getUniqueKey()))}});STK.register("core.evt.removeEvent",function($){return function(el,type,fn){el=$.E(el);if(el==null){return false}if(typeof fn!=="function"){return false}if(el.removeEventListener){el.removeEventListener(type,fn,false)}else{if(el.detachEvent){el.detachEvent("on"+type,fn)}}el["on"+type]=null;return true}});STK.register("core.evt.getEvent",function($){return(function(){if(document.addEventListener){return function(){var o=arguments.callee;var e;do{e=o.arguments[0];if(e&&(e.constructor==Event||e.constructor==MouseEvent||e.constructor==KeyboardEvent)){return e}}while(o=o.caller);return e}}else{return function(el,type,fn){return window.event}}}())});STK.register("core.evt.fixEvent",function($){var fixTouchList="clientX clientY pageX pageY screenX screenY".split(" ");return function(e){e=e||$.core.evt.getEvent();if(!e.target){e.target=e.srcElement||document}if(e.pageX==null&&e.clientX!=null){var html=document.documentElement;var body=document.body;e.pageX=e.clientX+(html.scrollLeft||body&&body.scrollLeft||0)-(html.clientLeft||body&&body.clientLeft||0);e.pageY=e.clientY+(html.scrollTop||body&&body.scrollTop||0)-(html.clientTop||body&&body.clientTop||0)}if(!e.which&&e.button){if(e.button&1){e.which=1}else{if(e.button&4){e.which=2}else{if(e.button&2){e.which=3}}}}if(e.relatedTarget===undefined){e.relatedTarget=e.fromElement||e.toElement}if(e.layerX==null&&e.offsetX!=null){e.layerX=e.offsetX;e.layerY=e.offsetY}return e}});STK.register("core.evt.preventDefault",function($){return function(event){event=event||$.core.evt.getEvent();if(event.preventDefault){event.preventDefault()}else{event.returnValue=false}}});STK.register("core.evt.custEvent",function($){var custEventAttribute="__custEventKey__",custEventKey=1,custEventCache={},findCache=function(obj,type){var _key=(typeof obj=="number")?obj:obj[custEventAttribute];return(_key&&custEventCache[_key])&&{obj:(typeof type=="string"?custEventCache[_key][type]:custEventCache[_key]),key:_key}};var hookCache={};var add=function(obj,type,fn,data,once){if(obj&&typeof type=="string"&&fn){var _cache=findCache(obj,type);if(!_cache||!_cache.obj){throw"custEvent ("+type+") is undefined !"}_cache.obj.push({fn:fn,data:data,once:once});return _cache.key}};var fire=function(obj,type,args,defaultAction){var preventDefaultFlag=true;var preventDefault=function(){preventDefaultFlag=false};if(obj&&typeof type=="string"){var _cache=findCache(obj,type),_obj;if(_cache&&(_obj=_cache.obj)){args=typeof args!="undefined"&&[].concat(args)||[];for(var i=_obj.length-1;i>-1&&_obj[i];i--){var fn=_obj[i].fn;var isOnce=_obj[i].once;if(fn&&fn.apply){try{fn.apply(obj,[{obj:obj,type:type,data:_obj[i].data,preventDefault:preventDefault}].concat(args));if(isOnce){_obj.splice(i,1)}}catch(e){$.log("[error][custEvent]"+e.message,e,e.stack)}}}if(preventDefaultFlag&&$.core.func.getType(defaultAction)==="function"){defaultAction()}return _cache.key}}};var that={define:function(obj,type){if(obj&&type){var _key=(typeof obj=="number")?obj:obj[custEventAttribute]||(obj[custEventAttribute]=custEventKey++),_cache=custEventCache[_key]||(custEventCache[_key]={});type=[].concat(type);for(var i=0;i<type.length;i++){_cache[type[i]]||(_cache[type[i]]=[])}return _key}},undefine:function(obj,type){if(obj){var _key=(typeof obj=="number")?obj:obj[custEventAttribute];if(_key&&custEventCache[_key]){if(type){type=[].concat(type);for(var i=0;i<type.length;i++){if(type[i] in custEventCache[_key]){delete custEventCache[_key][type[i]]}}}else{delete custEventCache[_key]}}}},add:function(obj,type,fn,data){return add(obj,type,fn,data,false)},once:function(obj,type,fn,data){return add(obj,type,fn,data,true)},remove:function(obj,type,fn){if(obj){var _cache=findCache(obj,type),_obj,index;if(_cache&&(_obj=_cache.obj)){if($.core.arr.isArray(_obj)){if(fn){var i=0;while(_obj[i]){if(_obj[i].fn===fn){break}i++}_obj.splice(i,1)}else{_obj.splice(0,_obj.length)}}else{for(var i in _obj){_obj[i]=[]}}return _cache.key}}},fire:function(obj,type,args,defaultAction){return fire(obj,type,args,defaultAction)},hook:function(orig,dest,typeMap){if(!orig||!dest||!typeMap){return}var destTypes=[],origKey=orig[custEventAttribute],origKeyCache=origKey&&custEventCache[origKey],origTypeCache,destKey=dest[custEventAttribute]||(dest[custEventAttribute]=custEventKey++),keyHookCache;if(origKeyCache){keyHookCache=hookCache[origKey+"_"+destKey]||(hookCache[origKey+"_"+destKey]={});var fn=function(event){var preventDefaultFlag=true;fire(dest,keyHookCache[event.type].type,Array.prototype.slice.apply(arguments,[1,arguments.length]),function(){preventDefaultFlag=false});preventDefaultFlag&&event.preventDefault()};for(var origType in typeMap){var destType=typeMap[origType];if(!keyHookCache[origType]){if(origTypeCache=origKeyCache[origType]){origTypeCache.push({fn:fn,data:undefined});keyHookCache[origType]={fn:fn,type:destType};destTypes.push(destType)}}}that.define(dest,destTypes)}},unhook:function(orig,dest,typeMap){if(!orig||!dest||!typeMap){return}var origKey=orig[custEventAttribute],destKey=dest[custEventAttribute],keyHookCache=hookCache[origKey+"_"+destKey];if(keyHookCache){for(var origType in typeMap){var destType=typeMap[origType];if(keyHookCache[origType]){that.remove(orig,origType,keyHookCache[origType].fn)}}}},destroy:function(){custEventCache={};custEventKey=1;hookCache={}}};return that});STK.register("core.func.empty",function(){return function(){}});STK.register("core.dom.removeNode",function($){return function(node){node=$.E(node)||node;try{node.parentNode.removeChild(node)}catch(e){}}});STK.register("core.str.parseURL",function($){return function(url){var parse_url=/^(?:([A-Za-z]+):(\/{0,3}))?([0-9.\-A-Za-z]+\.[0-9A-Za-z]+)?(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;var names=["url","scheme","slash","host","port","path","query","hash"];var results=parse_url.exec(url);var that={};for(var i=0,len=names.length;i<len;i+=1){that[names[i]]=results[i]||""}return that}});STK.register("core.json.queryToJson",function($){return function(QS,isDecode){var _Qlist=$.core.str.trim(QS).split("&");var _json={};var _fData=function(data){if(isDecode){return decodeURIComponent(data)}else{return data}};for(var i=0,len=_Qlist.length;i<len;i++){if(_Qlist[i]){var _hsh=_Qlist[i].split("=");var _key=_hsh[0];var _value=_hsh[1];if(_hsh.length<2){_value=_key;_key="$nullName"}if(!_json[_key]){_json[_key]=_fData(_value)}else{if($.core.arr.isArray(_json[_key])!=true){_json[_key]=[_json[_key]]}_json[_key].push(_fData(_value))}}}return _json}});STK.register("core.json.jsonToQuery",function($){var _fdata=function(data,isEncode){data=data==null?"":data;data=$.core.str.trim(data.toString());if(isEncode){return encodeURIComponent(data)}return data};return function(JSON,isEncode){var _Qstring=[];if(typeof JSON=="object"){for(var k in JSON){if(k==="$nullName"){_Qstring=_Qstring.concat(JSON[k]);continue}if(JSON[k] instanceof Array){for(var i=0,len=JSON[k].length;i<len;i++){_Qstring.push(k+"="+_fdata(JSON[k][i],isEncode))}}else{if(typeof JSON[k]!="function"){_Qstring.push(k+"="+_fdata(JSON[k],isEncode))}}}}if(_Qstring.length){return _Qstring.join("&")}return""}});STK.register("core.util.URL",function($){return function(sURL,args){var opts=$.core.obj.parseParam({isEncodeQuery:false,isEncodeHash:false},args||{});var that={};var url_json=$.core.str.parseURL(sURL);var query_json=$.core.json.queryToJson(url_json.query);var hash_json=$.core.json.queryToJson(url_json.hash);that.setParam=function(sKey,sValue){query_json[sKey]=sValue;return this};that.getParam=function(sKey){return query_json[sKey]};that.setParams=function(oJson){for(var key in oJson){that.setParam(key,oJson[key])}return this};that.setHash=function(sKey,sValue){hash_json[sKey]=sValue;return this};that.getHash=function(sKey){return hash_json[sKey]};that.valueOf=that.toString=function(){var url=[];var query=$.core.json.jsonToQuery(query_json,opts.isEncodeQuery);var hash=$.core.json.jsonToQuery(hash_json,opts.isEncodeQuery);if(url_json.scheme!=""){url.push(url_json.scheme+":");url.push(url_json.slash)}if(url_json.host!=""){url.push(url_json.host);if(url_json.port!=""){url.push(":");url.push(url_json.port)}}url.push("/");url.push(url_json.path);if(query!=""){url.push("?"+query)}if(hash!=""){url.push("#"+hash)}return url.join("")};return that}});STK.register("core.io.scriptLoader",function($){var entityList={};var default_opts={url:"",charset:"UTF-8",timeout:30*1000,args:{},onComplete:$.core.func.empty,onTimeout:$.core.func.empty,isEncode:false,uniqueID:null};return function(oOpts){var js,requestTimeout;var opts=$.core.obj.parseParam(default_opts,oOpts);if(opts.url==""){throw"scriptLoader: url is null"}var uniqueID=opts.uniqueID||$.core.util.getUniqueKey();js=entityList[uniqueID];if(js!=null&&$.IE!=true){$.core.dom.removeNode(js);js=null}if(js==null){js=entityList[uniqueID]=$.C("script")}js.charset=opts.charset;js.id="scriptRequest_script_"+uniqueID;js.type="text/javascript";if(opts.onComplete!=null){if($.IE){js.onreadystatechange=function(){if(js.readyState.toLowerCase()=="loaded"||js.readyState.toLowerCase()=="complete"){try{clearTimeout(requestTimeout);document.getElementsByTagName("head")[0].removeChild(js);js.onreadystatechange=null}catch(exp){}opts.onComplete()}}}else{js.onload=function(){try{clearTimeout(requestTimeout);$.core.dom.removeNode(js)}catch(exp){}opts.onComplete()}}}js.src=$.core.util.URL(opts.url,{isEncodeQuery:opts.isEncode}).setParams(opts.args).toString();document.getElementsByTagName("head")[0].appendChild(js);if(opts.timeout>0){requestTimeout=setTimeout(function(){try{document.getElementsByTagName("head")[0].removeChild(js)}catch(exp){}opts.onTimeout()},opts.timeout)}return js}});STK.register("core.io.jsonp",function($){return function(oOpts){var opts=$.core.obj.parseParam({url:"",charset:"UTF-8",timeout:30*1000,args:{},onComplete:null,onTimeout:null,responseName:null,isEncode:false,varkey:"callback"},oOpts);var funcStatus=-1;var uniqueID=opts.responseName||("STK_"+$.core.util.getUniqueKey());opts.args[opts.varkey]=uniqueID;var completeFunc=opts.onComplete;var timeoutFunc=opts.onTimeout;window[uniqueID]=function(oResult){if(funcStatus!=2&&completeFunc!=null){funcStatus=1;completeFunc(oResult)}};opts.onComplete=null;opts.onTimeout=function(){if(funcStatus!=1&&timeoutFunc!=null){funcStatus=2;timeoutFunc()}};return $.core.io.scriptLoader(opts)}});STK.register("core.json.merge",function($){var checkCell=function(obj){if(obj===undefined){return true}if(obj===null){return true}if($.core.arr.inArray((typeof obj),["number","string","function","boolean"])){return true}if($.core.dom.isNode(obj)){return true}return false};var deep=function(ret,key,coverItem){if(checkCell(coverItem)){ret[key]=coverItem;return}if($.core.arr.isArray(coverItem)){if(!$.core.arr.isArray(ret[key])){ret[key]=[]}for(var i=0,len=coverItem.length;i<len;i+=1){deep(ret[key],i,coverItem[i])}return}if(typeof coverItem==="object"){if(checkCell(ret[key])||$.core.arr.isArray(ret[key])){ret[key]={}}for(var k in coverItem){deep(ret[key],k,coverItem[k])}return}};var merge=function(origin,cover,isDeep){var ret={};if(isDeep){for(var k in origin){deep(ret,k,origin[k])}for(var k in cover){deep(ret,k,cover[k])}}else{for(var k in origin){ret[k]=origin[k]}for(var k in cover){ret[k]=cover[k]}}return ret};return function(origin,cover,opts){var conf=$.core.obj.parseParam({isDeep:false},opts);return merge(origin,cover,conf.isDeep)}});STK.register("core.util.language",function($){return function(template,data){var rep=[];for(var i=2,len=arguments.length;i<len;i+=1){rep.push(arguments[i])}return template.replace(/#L\{((.*?)(?:[^\\]))\}/ig,function(){var key=arguments[1];var ret;if(data&&data[key]!==undefined){ret=data[key]}else{ret=key}if(rep.length){ret=ret.replace(/(\%s)/ig,function(){var pic=rep.shift();if(pic!==undefined){return pic}else{return arguments[0]}})}return ret})}});STK.register("core.util.listener",function($){return(function(){var dispatchList={};var fireTaskList=[];var fireTaskTimer;var runFireTaskList=function(){if(fireTaskList.length==0){return}clearTimeout(fireTaskTimer);var curFireTask=fireTaskList.splice(0,1)[0];try{curFireTask.func.apply(curFireTask.func,[].concat(curFireTask.data))}catch(exp){}fireTaskTimer=setTimeout(runFireTaskList,25)};return{register:function(sChannel,sEventType,fCallBack){dispatchList[sChannel]=dispatchList[sChannel]||{};dispatchList[sChannel][sEventType]=dispatchList[sChannel][sEventType]||[];dispatchList[sChannel][sEventType].push(fCallBack)},fire:function(sChannel,sEventType,oData){var funcArray;var i,len;if(dispatchList[sChannel]&&dispatchList[sChannel][sEventType]&&dispatchList[sChannel][sEventType].length>0){funcArray=dispatchList[sChannel][sEventType];funcArray.data_cache=oData;for(i=0,len=funcArray.length;i<len;i++){fireTaskList.push({channel:sChannel,evt:sEventType,func:funcArray[i],data:oData})}runFireTaskList()}},remove:function(sChannel,sEventType,fCallBack){if(dispatchList[sChannel]){if(dispatchList[sChannel][sEventType]){for(var i=0,len=dispatchList[sChannel][sEventType].length;i<len;i++){if(dispatchList[sChannel][sEventType][i]===fCallBack){dispatchList[sChannel][sEventType].splice(i,1);break}}}}},list:function(){return dispatchList},cache:function(sChannel,sEventType){if(dispatchList[sChannel]&&dispatchList[sChannel][sEventType]){return dispatchList[sChannel][sEventType].data_cache}}}})()});STK.register("core.util.winSize",function($){return function(_target){var w,h;var target;if(_target){target=_target.document}else{target=document}if(target.compatMode==="CSS1Compat"){w=target.documentElement.clientWidth;h=target.documentElement.clientHeight}else{if(self.innerHeight){if(_target){target=_target.self}else{target=self}w=target.innerWidth;h=target.innerHeight}else{if(target.documentElement&&target.documentElement.clientHeight){w=target.documentElement.clientWidth;h=target.documentElement.clientHeight}else{if(target.body){w=target.body.clientWidth;h=target.body.clientHeight}}}}return{width:w,height:h}}});(function(){var $=STK.core;var hash={arrCopy:$.arr.copy,arrClear:$.arr.clear,hasby:$.arr.hasby,unique:$.arr.unique,foreach:$.arr.foreach,isArray:$.arr.isArray,inArray:$.arr.inArray,arrIndexOf:$.arr.indexOf,findout:$.arr.findout,domNext:$.dom.next,domPrev:$.dom.prev,isNode:$.dom.isNode,addHTML:$.dom.addHTML,insertHTML:$.dom.insertHTML,setXY:$.dom.setXY,contains:$.dom.contains,position:$.dom.position,trimNode:$.dom.trimNode,insertAfter:$.dom.insertAfter,insertBefore:$.dom.insertBefore,removeNode:$.dom.removeNode,replaceNode:$.dom.replaceNode,Ready:$.dom.ready,setStyle:$.dom.setStyle,setStyles:$.dom.setStyles,getStyle:$.dom.getStyle,addClassName:$.dom.addClassName,hasClassName:$.dom.hasClassName,removeClassName:$.dom.removeClassName,builder:$.dom.builder,addEvent:$.evt.addEvent,custEvent:$.evt.custEvent,removeEvent:$.evt.removeEvent,fireEvent:$.evt.fireEvent,fixEvent:$.evt.fixEvent,getEvent:$.evt.getEvent,stopEvent:$.evt.stopEvent,delegatedEvent:$.evt.delegatedEvent,preventDefault:$.evt.preventDefault,hotKey:$.evt.hotKey,getType:$.func.getType,funcEmpty:$.func.empty,ajax:$.io.ajax,jsonp:$.io.jsonp,ijax:$.io.ijax,scriptLoader:$.io.scriptLoader,jsonToQuery:$.json.jsonToQuery,queryToJson:$.json.queryToJson,parseParam:$.obj.parseParam,trim:$.str.trim,parseURL:$.str.parseURL,listener:$.util.listener,winSize:$.util.winSize,scrollPos:$.util.scrollPos,getUniqueKey:$.util.getUniqueKey};for(var k in hash){if(hash[k]){STK.regShort(k,hash[k])}}})();STK.register("kit.dom.cssText",function($){var _getNewCss=function(oldCss,addCss){var _newCss=(oldCss+";"+addCss).replace(/(\s*(;)\s*)|(\s*(:)\s*)/g,"$2$4"),_m;while(_newCss&&(_m=_newCss.match(/(^|;)([\w\-]+:)([^;]*);(.*;)?\2/i))){_newCss=_newCss.replace(_m[1]+_m[2]+_m[3],"")}return _newCss};return function(oldCss){oldCss=oldCss||"";var _styleList=[],that={push:function(property,value){_styleList.push(property+":"+value);return that},remove:function(property){for(var i=0;i<_styleList.length;i++){if(_styleList[i].indexOf(property+":")==0){_styleList.splice(i,1)}}return that},getStyleList:function(){return _styleList.slice()},getCss:function(){return _getNewCss(oldCss,_styleList.join(";"))}};return that}});STK.register("kit.dom.fix",function($){var _canFix=!($.core.util.browser.IE6||(document.compatMode!=="CSS1Compat"&&STK.IE)),_typeReg=/^(c)|(lt)|(lb)|(rt)|(rb)$/;function _visible(node){return $.core.dom.getStyle(node,"display")!="none"}function _createOffset(offset){offset=$.core.arr.isArray(offset)?offset:[0,0];for(var i=0;i<2;i++){if(typeof offset[i]!="number"){offset[i]=0}}return offset}function _draw(node,type,offset){if(!_visible(node)){return}var _position="fixed",_top,_left,_right,_bottom,_width=node.offsetWidth,_height=node.offsetHeight,_winSize=$.core.util.winSize(),_limitTop=0,_limitLeft=0,_cssText=$.kit.dom.cssText(node.style.cssText);if(!_canFix){_position="absolute";var _scrlPos=$.core.util.scrollPos();_limitTop=_top=_scrlPos.top;_limitLeft=_left=_scrlPos.left;switch(type){case"lt":_top+=offset[1];_left+=offset[0];break;case"lb":_top+=_winSize.height-_height-offset[1];_left+=offset[0];break;case"rt":_top+=offset[1];_left+=_winSize.width-_width-offset[0];break;case"rb":_top+=_winSize.height-_height-offset[1];_left+=_winSize.width-_width-offset[0];break;case"c":default:_top+=(_winSize.height-_height)/2+offset[1];_left+=(_winSize.width-_width)/2+offset[0]}_right=_bottom=""}else{_top=_bottom=offset[1];_left=_right=offset[0];switch(type){case"lt":_bottom=_right="";break;case"lb":_top=_right="";break;case"rt":_left=_bottom="";break;case"rb":_top=_left="";break;case"c":default:_top=(_winSize.height-_height)/2+offset[1];_left=(_winSize.width-_width)/2+offset[0];_bottom=_right=""}}if(type=="c"){if(_top<_limitTop){_top=_limitTop}if(_left<_limitLeft){_left=_limitLeft}}_cssText.push("position",_position).push("top",_top+"px").push("left",_left+"px").push("right",_right+"px").push("bottom",_bottom+"px");node.style.cssText=_cssText.getCss()}return function(node,type,offset){var _type,_offset,_fixed=true,_ceKey;if($.core.dom.isNode(node)&&_typeReg.test(type)){var that={getNode:function(){return node},isFixed:function(){return _fixed},setFixed:function(fixed){(_fixed=!!fixed)&&_draw(node,_type,_offset);return this},setAlign:function(type,offset){if(_typeReg.test(type)){_type=type;_offset=_createOffset(offset);_fixed&&_draw(node,_type,_offset)}return this},destroy:function(){if(!_canFix){$.core.evt.removeEvent(window,"scroll",_evtFun)}$.core.evt.removeEvent(window,"resize",_evtFun);$.core.evt.custEvent.undefine(_ceKey)}};_ceKey=$.core.evt.custEvent.define(that,"beforeFix");that.setAlign(type,offset);function _evtFun(event){event=event||window.event;$.core.evt.custEvent.fire(_ceKey,"beforeFix",event.type);if(_fixed&&(!_canFix||_type=="c")){_draw(node,_type,_offset)}}if(!_canFix){$.core.evt.addEvent(window,"scroll",_evtFun)}$.core.evt.addEvent(window,"resize",_evtFun);return that}}});STK.register("kit.dom.builder",function($){var parentNode=null;return function(node_or_html){var node=null;if(typeof(node_or_html)=="string"){if(!parentNode){parentNode=$.C("div")}parentNode.innerHTML=node_or_html;node=parentNode.children[0];parentNode.removeChild(node);parentNode.innerHTML=""}else{node=node_or_html}var list={};var all_nodes=node.getElementsByTagName("*");if(all_nodes.length>0){$.foreach(all_nodes,function(el){if($.isNode(el)){var node_type=el.getAttribute("node-type");if(node_type){if(!list[node_type]){list[node_type]=[]}list[node_type].push(el)}}})}var obj={};obj.box=node;obj.list=list;return obj}});STK.register("kit.dom.parseDOM",function($){return function(list){for(var a in list){if(list[a]&&(list[a].length==1)){list[a]=list[a][0]}}return list}});STK.register("kit.obj.append",function($){return function(original){for(var i=1,l=arguments.length;i<l;i++){var extended=arguments[i]||{};for(var key in extended){original[key]=extended[key]}}return original}});STK.register("kit.dom.loadStyle",function($){var head;var $empty=$.funcEmpty;var $browser=$.core.util.browser;return function(source,spec){var link,styleCheckTimer,loaded=false,timeout=false;var conf=$.parseParam({id:$.getUniqueKey(),timeout:30*1000,styleCheck:null,onLoad:$empty,onTimeout:$empty,props:{charset:"utf-8",rel:"stylesheet",media:"screen",type:"text/css"}},spec);link=$.C("link");$.foreach(conf.props,function(val,key){link[key]=val});link.id=conf.id;link.href=source;var link_load=function(){clearInterval(styleCheckTimer);if(!timeout&&!loaded){if($.getType(conf.onLoad)==="function"){setTimeout(conf.onLoad,100)}}loaded=true};if($browser.IE){link.onload=link_load}else{if($.getType(conf.styleCheck)==="function"){styleCheckTimer=setInterval(function(){if(conf.styleCheck()){link_load()}},10)}else{var img=document.createElement("img");img.onerror=link_load;img.src=source}}if(conf.timeout&&conf.onTimeout){setTimeout(function(){clearInterval(styleCheckTimer);if(!loaded&&$.getType(conf.onTimeout)==="function"){timeout=true;conf.onTimeout()}},conf.timeout)}if(!head){head=document.getElementsByTagName("head")[0]}head.appendChild(link)}});STK.register("kit.util.makeReady",function($){return function(spec){var conf=$.parseParam({timeout:30*1000,condition:$.funcEmpty,ready:$.funcEmpty},spec);var cache,timer;return{reset:function(){if(cache){cache.length=0;cache=null}if(timer){clearTimeout(timer);timer=null}},exec:function(fn){var that=this;if($.getType(fn)==="function"){if(conf.condition()){fn()}else{if(!cache){cache=[];cache.push(fn);if(!timer){timer=setTimeout(that.reset,conf.timeout)}conf.ready(function(){clearTimeout(timer);timer=null;while($.getType(cache)==="array"&&cache.length>0){cache.shift()()}})}else{cache.push(fn)}}}},destroy:function(){this.reset()}}}});STK.register("kit.dom.appendStyle",function($){return function(cssText,spec){var conf=$.parseParam({autoAppend:true,target:null,type:"text/css"},spec);var style;cssText=cssText||"";cssText=cssText.toString();if($.isNode(conf.target)&&conf.target.tagName.toLowerCase()==="style"){style=conf.target}else{style=document.createElement("style");style.setAttribute("type",conf.type)}if(style.styleSheet){style.styleSheet.cssText=style.innerHTML+cssText}else{style.appendChild(document.createTextNode(cssText))}if(conf.autoAppend){document.getElementsByTagName("head")[0].appendChild(style)}return style}});STK.register("module.mask",function($){var _maskNode,_nodeList=[],_fix,_inBody,_fixCKey;var _setStyle=$.core.dom.setStyle;var _getStyle=$.core.dom.getStyle;var _custEvent=$.core.evt.custEvent;var _cache={},_lastNode;function _init(options){_maskNode=$.C("div");_maskNode.id="ST_outLogin_mask";if($.core.util.browser.IE6&&options&&options.useIframeInIE6){_maskNode.innerHTML='<iframe id = "ST_outLogin_mask" style="position:absolute;z-index:-1;width:100%;height:100%;filter:mask();"></iframe>'}document.body.appendChild(_maskNode);_inBody=true;_fix=$.kit.dom.fix(_maskNode,"lt");var _beforeFixFn=function(){var _winSize=$.core.util.winSize();_maskNode.style.cssText=$.kit.dom.cssText(_maskNode.style.cssText).push("width",_winSize.width*10+"px").push("height",_winSize.height*10+"px").getCss()};_fixCKey=_custEvent.add(_fix,"beforeFix",_beforeFixFn);_beforeFixFn()}var that={getNode:function(){return _maskNode},show:function(option,cb){if(_inBody){option=$.core.obj.parseParam({useIframeInIE6:true,opacity:0.1,background:"#000000"},option);_maskNode.style.background=option.background;_setStyle(_maskNode,"opacity",option.opacity);_maskNode.style.display="block";_fix.setAlign("lt");cb&&cb()}else{$.Ready(function(){_init(option);that.show(option,cb)})}return that},hide:function(node){if(_maskNode&&node){if(_lastNode!=node){delete _cache[$.core.dom.uniqueID(node)]}else{var prev_node=$.core.dom.prev(_maskNode);if(_lastNode){delete _cache[$.core.dom.uniqueID(_lastNode)];_lastNode=undefined}var prev_flag=false;for(var i=0;prev_node&&i<3;i++){if(_cache[$.core.dom.uniqueID(prev_node)]){prev_flag=true;break}prev_node=$.core.dom.prev(prev_node)}if(prev_flag){that.showUnderNode(prev_node)}else{_maskNode.style.display="none"}prev_node=undefined}}node=undefined;return that},showUnderNode:function(node,option){if($.isNode(node)){(_lastNode=node);_cache[$.core.dom.uniqueID(node)]=1;that.show(option,function(){document.body.appendChild(_maskNode);document.body.appendChild(node);_setStyle(_maskNode,"zIndex","999")})}return that},destroy:function(){_custEvent.remove(_fixCKey);_maskNode.style.display="none";_lastNode=undefined;_cache={}}};return that});STK.register("common.listener",function($){var listenerList={};var that={};that.define=function(sChannel,aEventList){if(listenerList[sChannel]!=null){throw"common.listener.define: 频道已被占用"}listenerList[sChannel]=aEventList;var ret={};ret.register=function(sEventType,fCallBack){if(listenerList[sChannel]==null){throw"common.listener.define: 频道未定义"}$.core.util.listener.register(sChannel,sEventType,fCallBack)};ret.fire=function(sEventType,oData){if(listenerList[sChannel]==null){throw"commonlistener.define: 频道未定义"}$.core.util.listener.fire(sChannel,sEventType,oData)};ret.remove=function(sEventType,fCallBack){$.core.util.listener.remove(sChannel,sEventType,fCallBack)};return ret};return that});STK.register("common.channel.sso",function($){return $.common.listener.define("common.channel.sso",["layer_ready","layer_show","layer_hide","validate_failure","play_door_voice","login","login_complete","login_success","login_failure","login_timeout","logout","logout_complete","logout_success","logout_failure","logout_timeout","verify","need_verify"])});STK.register("core.dom.addHTML",function($){return function(node,html){if(node.insertAdjacentHTML){node.insertAdjacentHTML("BeforeEnd",html)}else{var oRange=node.ownerDocument.createRange();oRange.setStartBefore(node);var oFrag=oRange.createContextualFragment(html);node.appendChild(oFrag)}}});STK.register("core.io.getXHR",function($){return function(){var _XHR=false;try{_XHR=new XMLHttpRequest()}catch(try_MS){try{_XHR=new ActiveXObject("Msxml2.XMLHTTP")}catch(other_MS){try{_XHR=new ActiveXObject("Microsoft.XMLHTTP")}catch(failed){_XHR=false}}}return _XHR}});STK.register("common.util.sso",function($){var $merge=$.core.json.merge,$channel_sso=$.common.channel.sso,$jsonp=$.core.io.jsonp,$removeNode=$.core.dom.removeNode;$addHTML=$.core.dom.addHTML;return function(spec){var that={},spec=spec||{};that.para={};var conf=$merge({timeout:20*1000},spec);that.init=function(){if(that.inited){return}that.bindListener();that.inited=true};that.encodeFormData=function(data){var pairs={},regexp=/%20/g;var pkey,value;for(var key in data){value=window.encodeURIComponent(data[key].toString()).replace(regexp,"+");pkey=window.encodeURIComponent(key).replace(regexp,"+");pairs[pkey]=value}return pairs};that.createForm=function(formName,display){if(display==null){display="none"}$removeNode(formName);var form=document.createElement("form");form.height=0;form.width=0;form.style.display=display;form.name=formName;form.id=formName;form.method="post";$addHTML(document.body,form);form.addInput=function(name,value,type){if(type==null){type="text"}var _name=this.getElementsByTagName("input")[name];if(_name){this.removeChild(_name)}_name=document.createElement("input");this.appendChild(_name);_name.id=name;_name.name=name;_name.type=type;_name.value=value};return form};that.login=function(data){that.loginTimer=setTimeout(function(){$channel_sso.fire("login_timeout")},conf.timeout);var sendData=$.core.json.jsonToQuery(data);var xhr=$.core.io.getXHR();if(!"withCredentials" in xhr){return false}xhr.open("POST","https://passport.sina.cn/sso/login",true);xhr.setRequestHeader("Content-Type","application/x-www-form-urlencoded");xhr.withCredentials=true;xhr.onreadystatechange=function(){clearTimeout(that.loginTimer);delete that.loginTimer;if(xhr.readyState==4&&xhr.status==200){var ret=that.parseJSON(xhr.responseText);if(ret.retcode==20000000){var rs={uid:ret.data.uid,nick:ret.data.nick,portrait:ret.data.portrait};window.SINA_OUTLOGIN_LAYER_MOBILE_DATA=rs;$channel_sso.fire("login_success",rs);var crossdomainlist=ret.data.crossdomainlist;for(var d in crossdomainlist){if(!crossdomainlist.hasOwnProperty(d)){continue}$jsonp({url:crossdomainlist[d]+"&savestate=1",})}}else{$channel_sso.fire("login_failure",[ret])}}};xhr.send(sendData)};that.forgetPassword=function(data){var sendData=$.core.json.jsonToQuery(data);var xhr=$.core.io.getXHR();if(!"withCredentials" in xhr){return false}xhr.open("POST","https://passport.sina.cn/forgot/ajforgot",true);xhr.setRequestHeader("Content-Type","application/x-www-form-urlencoded");xhr.withCredentials=true;xhr.onreadystatechange=function(){var BackUrl=window.encodeURIComponent(window.location.href);if(xhr.readyState==4&&xhr.status==200){var ret=that.parseJSON(xhr.responseText);if(ret.retcode==20000000){window.location.href=ret.data.jump_url}else{window.location.href="https://passport.sina.cn/forgot/forgot?entry=wapsso&from=0&r="+BackUrl}}};xhr.send(sendData)};that.parseJSON=function(str){if(typeof(str)==="object"){return str}else{if(window.JSON){return JSON.parse(str)}else{return eval("("+str+")")}}};that.checkVerify=function(loginName,verifyFun){var ops={url:"https://login.sina.com.cn/sso/prelogin.php",args:{entry:"sso",checkpin:1,su:window.btoa(window.encodeURIComponent(loginName))},onComplete:function(rs){if(rs.retcode===0){verifyFun(rs)}}};$jsonp(ops)};that.chackLogin=function(fn){var ops={url:"https://passport.sina.cn/sso/checklogin",args:{entry:"sso"},onComplete:function(rs){if($.getType(fn)==="function"){fn(rs)}}};$jsonp(ops)};that.mobileVerify=function(mobileVerifyurl,fn){var ops={url:mobileVerifyurl,onComplete:function(rs){if($.getType(fn)==="function"){fn(rs)}}};$jsonp(ops)};that.getPinCodeUrl=function(url,img){var ops={url:url,onComplete:function(ret){if(ret.retcode==20000000){img.src=ret.data.image;img.setAttribute("data-pcid",ret.data.pcid)}}};$jsonp(ops)};that.bindListener=function(){$channel_sso.register("login",that.login);$channel_sso.register("verify",that.checkVerify)};return that}});STK.register("kit.extra.template",function($){var templet=function(template,data){return template.replace(/#\{(.+?)\}/ig,function(){var key=arguments[1];var ret=arguments[0];var list=key.split("||");for(var i=0,len=list.length;i<len;i+=1){if(/^default:.*$/.test(list[i])){ret=list[i].replace(/^default:/,"");break}else{if(data[list[i]]!==undefined){ret=data[list[i]];break}}}return ret})};return function(temp,data){data=data||$.$LANG||{};var str=templet(temp,data);return str}});STK.register("kit.evt.input_bindchange",function($){var $browser=$.core.util.browser;return function(node,type,fn){type=(type=="add")?"add":"remove";var action=type+"Event";if($browser.IE){var version=parseInt($browser.Version,10);if(version==5){$[action](node,"keydown",fn);$[action](node,"cut",fn);$[action](node,"input",fn)}else{if(version>5){$[action](node,"input",fn)}else{$[action](node,"propertychange",fn)}}}else{$[action](node,"input",fn)}}});STK.register("kit.util.buffer_pool",function($){return function(spec){var that={};var conf=$.parseParam({delay:50},spec);var timer_final=null;that.trigger_final=function(){if(timer_final){clearTimeout(timer_final);timer_final=null}timer_final=setTimeout(function(){timer_final=null;that.feedback()},conf.delay)};var timer_regular=null;var enable=false;that.trigger_regular=function(){enable=true;if(!timer_regular){timer_regular=setInterval(function(){that.feedback();if(!enable){clearInterval(timer_regular);timer_regular=null}enable=false},conf.delay)}};that.feedback=function(){};return that}});STK.register("kit.dom.placeholder",function($){var $merge=$.core.json.merge;var tempInput;return function(node,spec){var that={};var conf=$.parseParam({},spec);var conf_style={opacity:0.5};that.supportPlaceholder=function(){if(!tempInput){tempInput=$.C("input")}return"placeholder" in tempInput};that.compute_offset=function(){var pos={};$.foreach(["marginTop","paddingTop","borderTopWidth","marginLeft","paddingLeft","borderLeftWidth"],function(prop){pos[prop]=$.getStyle(node,prop);if(pos[prop]=="auto"){pos[prop]="1px"}pos[prop]=parseInt(pos[prop],10)||0});pos.x=pos.marginLeft+pos.paddingLeft+pos.borderLeftWidth;pos.y=pos.marginTop+pos.paddingTop+pos.borderTopWidth+($.core.util.browser.IE6?1:0);return pos};that.getStyles=function(){var styles={};$.foreach(["fontSize","lineHeight"],function(prop){styles[prop]=$.getStyle(node,prop)});styles.position="absolute";return styles};that.focus=function(){that.hide();setTimeout(function(){node.focus()})};that.hide=function(){if(that.label){$.setStyle(that.label,"display","none")}};that.show=function(){if(that.label&&node&&!node.value){$.setStyle(that.label,"display","")}};that.check=function(){if(!node.value){that.show()}else{that.hide()}};that.build_placeholder=function(text){if(!that.label){that.label=$.C("span");that.hide();$.insertBefore(that.label,node);that.bindDomEvents()}that.label.innerHTML=text;var styles=that.getStyles();var offset=that.compute_offset();styles.marginLeft=offset.x+"px";styles.marginTop=offset.y+"px";styles=$merge(styles,conf_style);$.foreach(styles,function(val,key){$.setStyle(that.label,key,val)})};that.checkInput=function(){if(node&&node.value){that.hide()}};that.bindDomEvents=function(){$.addEvent(node,"input",that.checkInput);$.addEvent(node,"propertychange",that.checkInput);$.addEvent(node,"focus",that.hide);$.addEvent(node,"blur",that.check);$.addEvent(that.label,"mousedown",that.focus)};that.destroy=function(){$.removeEvent(node,"focus",that.hide);$.removeEvent(that.label,"mousedown",that.focus);$.removeEvent(node,"blur",that.check);if(that.label&&that.label.parentNode){that.label.parentNode.removeChild(that.label)}that.label=null};that.set=function(text,spec_style){if(!node){return}spec_style=spec_style||{};conf_style=$merge({color:"#888"},spec_style);if(!text){text=node.getAttribute("placeholder")||""}if(that.supportPlaceholder()){node.setAttribute("placeholder",text)}else{that.build_placeholder(text);that.check()}return that};that.node=node;that.conf=conf;that.conf_style=conf_style;return that}});STK.register("common.util.door",function($){var $merge=$.core.json.merge,$channel_sso=$.common.channel.sso,$sso=$.common.util.sso;var getQueryPara=function(query){var para={};var arrPara=query.split("&");var arr=[];for(var i=0;i<arrPara.length;i++){arr=arrPara[i].split("=");para[arr[0]]=arr[1]}return para};return function(spec){var that={},conf={};that.sso=$sso();that.argsCheck=function(){conf=$.parseParam({usesso:false,address:"",img:null,input:null,tip:null,button:null,img_extra:{},autofocus:false},spec)};that.init=function(){that.argsCheck();that.setEvents("add")};that.change=function(){var address="https://passport.sina.cn/captcha/image";if(conf.tip){conf.tip.innerHTML=""}if(conf.input){conf.input.value=""}if(conf.img){$.setStyle(conf.img,"visibility","hidden");that.sso.getPinCodeUrl(conf.address,conf.img)}};that.bound={change:function(){$.preventDefault();that.change();if(conf.input&&conf.autofocus){conf.input.focus()}},doorImgLoad:function(){$.setStyle(conf.img,"visibility","visible")}};that.setEvents=function(type){var action=type==="add"?"addEvent":"removeEvent";$[action](conf.button,"click",that.bound.change);$[action](conf.img,"click",that.bound.change);$[action](conf.img,"load",that.bound.doorImgLoad)};that.destroy=function(){that.setEvents("remove")};that.conf=conf;return that}});STK.register("comp.login.outlogin",function($){var $merge=$.core.json.merge,$template=$.kit.extra.template,$builder=$.kit.dom.builder,$parseDOM=$.kit.dom.parseDOM,$bind_change=$.kit.evt.input_bindchange,$buffer_pool=$.kit.util.buffer_pool,$placeholder=$.kit.dom.placeholder,$door=$.common.util.door,$channel_sso=$.common.channel.sso;$sso=$.common.util.sso;return function(rootNode){var that={},nodes={},conf={forget_vsn_url:"",forget_password_url:"",register_url:"https://login.sina.com.cn/signup/signup.php?entry=#{entry||default:sso}",entry:"wapsso",door_address:"http://passport.sina.cn/captcha/image",savestate:3650,relative_node:null,setTipDelay:100,closeAutoCompleteDelay:200,updateDelay:200,login_failure:0};that.username=null;that.loginFailureNum=0;that.isInside=false;that.mobileVerifyurl=null;that.prev_value="";that.disabled=false;that.submitDisabled=true;that.focusDom=null;that.setOptions=function(spec){spec=spec||{};conf=$.parseParam(conf,spec);that.conf=conf};that.setTip=function(strtip,el){if(strtip+""==="undefined"){return}if(nodes.tip&&strtip!==""){nodes.tip.innerHTML=strtip;nodes.tip.style.display="block"}};that.hideTip=function(clear){if(nodes.tip){nodes.tip.style.display="none";nodes.tip.innerHTML=""}};that.mobileVerify=function(){$.removeEvent(nodes.mobile_Verify,"click",that.mobileVerify);var sso=that.getSSO();sso.mobileVerify(that.mobileVerifyurl,function(rs){that.cfrom=rs.data.cfrom});var countDown=60;var updateCountDown=function(){if(countDown==0){nodes.mobile_Verify.className="lymb-code-btn";nodes.mobile_Verify.innerHTML="获取验证码";countDown=60;$.addEvent(nodes.mobile_Verify,"click",that.mobileVerify)}else{beginCountDown()}};var beginCountDown=function(){nodes.mobile_Verify.className="lymb-code-wait";nodes.mobile_Verify.innerHTML="重新获取("+countDown+")";setTimeout(function(){countDown--;updateCountDown()},1000)};beginCountDown()};that.lockForm=function(isLock){isLock=!!isLock;that.disabled=isLock;$.foreach(["loginname","password","door","vsn"],function(prop){var el=nodes[prop];el.readOnly=isLock})};that.getRemember=function(){var value=nodes.loginname.value;var sso=that.getSSO();if(!value&&sso&&$.getType(sso.getLoginInfo)==="function"){var info=sso.getLoginInfo();if(info&&info.ln){nodes.loginname.value=info.ln}}if(that.placeholder_loginname){that.placeholder_loginname.check()}that.checkFace()};that.showClearButton=function(){if(nodes.clear){if(nodes.loginname.value){$.setStyle(nodes.clear,"display","")}else{$.setStyle(nodes.clear,"display","none")}}};that.hideClearButton=function(){if(nodes.clear){nodes.clear.style.display="none"}};that.clearRemember=function(){};that.reset=function(){that.lockForm(false);nodes.loginname.value="";nodes.password.value="";nodes.door.value="";nodes.vsn.value="";nodes.mobile.value="";that.switchFace("password");that.hideTip();that.submitDisabled=true;nodes.submit.className="lymb-sub";if(that.placeholder_loginname){that.placeholder_loginname.check()}if(that.placeholder_password){that.placeholder_password.check()}if(that.placeholder_vsn){that.placeholder_vsn.check()}that.hideClearButton()};that.getData=function(){var data={};$.foreach(["loginname","door","vsn","password","mobile","advanceLoginname"],function(prop){var el=nodes[prop];var trim_value=$.trim(el.value);if(el.value!==trim_value&&prop!=="password"){el.value=trim_value;el.blur()}data[prop]=el.value});return data};that.validate=function(data,state){var result=true;var errTip="";var errNode=null;$.foreach({loginname:"E010001",password:"E010002",door:"E010003",vsn:"E010004",mobile:"E010003"},function(code,prop){var enable=prop==="loginname"||state===prop;if(prop==="loginname"&&nodes.advanceLoginname_box.style.display!="none"){enable=false}var node=nodes[prop];if(enable&&node&&!data[prop]){errNode=node;errTip=$template("#{"+code+"}");result=false}return result});if(!result){if(errNode){errNode.focus()}setTimeout(function(){that.setTip(errTip,errNode);$channel_sso.fire("validate_failure")},conf.setTipDelay)}return result};that.verify=function(json){json=json||{reason:""};var reason=$template("#{"+json.code+"||default:"+json.reason+"}");var relate_node=null;if(json.code=="4049"||json.code=="2070"){that.switchFace("door");if(that.door){that.door.change()}relate_node=nodes.door}else{that.switchFace("vsn");relate_node=nodes.vsn}if(relate_node){relate_node.focus()}setTimeout(function(){that.setTip(reason,relate_node);if(json.code=="2070"||json.code=="5025"||json.code=="4049"){$channel_sso.fire("validate_failure")}},conf.setTipDelay)};that.submit=function(){if(that.disabled||that.submitDisabled){return}that.hideTip();var loginData={};var data=that.getData();var state=that.getFaceState();if(that.validate(data,state)){that.lockForm(true);loginData.savestate=3650;if(nodes.remember&&nodes.remember.checked){loginData.savestate=conf.savestate}if(data.loginname){loginData.username=encodeURIComponent(data.loginname)}loginData.password=encodeURIComponent(data.password);if(state==="door"){loginData.pincode=data.door;loginData.pcid=nodes.door_img.getAttribute("data-pcid")}else{if(state==="vsn"){loginData.vsn=data.vsn}else{if(state==="mobile"){loginData.password=data.mobile;loginData.cfrom=that.cfrom}}}if(document.referrer){loginData.pagerefer=document.referrer}loginData.entry="wapsso";loginData.loginfrom=1;$channel_sso.fire("login",[loginData])}};that.getFaceState=function(){if(nodes.door_box.style.display!="none"){return"door"}else{if(nodes.vsn_box.style.display!="none"){return"vsn"}else{if(nodes.mobile_box.style.display!="none"){return"mobile"}else{return"password"}}}};that.switchFace=function(type){if(type==="change"){nodes.userhead.src="http://i.sso.sina.com.cn/images/login/thumb_default.gif";nodes.advanceLoginname_box.style.display="none";nodes.loginname_box.style.display="block";nodes.password_box.style.display="block";$.foreach(["door","vsn","mobile"],function(boxType){var node=nodes[boxType+"_box"];$.setStyle(node,"display","none")})}else{type=type||"password";if(type==="door"&&that.door){if($.getStyle(nodes.door_box,"display")==="none"){that.door.change()}}if(type==="password"){$.setStyle(nodes.password_box,"display","block")}$.foreach(["door","vsn","mobile"],function(boxType){var node=nodes[boxType+"_box"];if(boxType===type){if(boxType==="mobile"){$.setStyle(nodes.password_box,"display","none")}$.setStyle(node,"display","block")}else{$.setStyle(node,"display","none")}});if(nodes.forget_vsn&&nodes.forget_password){if(type==="vsn"){$.setStyle(nodes.forget_vsn,"display","");$.setStyle(nodes.forget_password,"display","none")}else{$.setStyle(nodes.forget_vsn,"display","none");$.setStyle(nodes.forget_password,"display","")}}}};var checkpinCache={};that.checkFace=function(){var sso=that.getSSO();var username=$.trim(nodes.loginname.value);if(!username){return}if($.getType(checkpinCache[username])!=="undefined"){that.checkPin(checkpinCache[username])}else{if(!sso){return}sso.checkVerify(username,function(rs){if(rs){if(rs.nopwd===1){var code={nopwd:1};that.checkPin(code);checkpinCache[username]={nopwd:1};that.mobileVerifyurl=rs.smsurl}else{var code={nopwd:0,showpin:rs.showpin};that.checkPin(code);checkpinCache[username]={nopwd:0,showpin:rs.showpin}}}})}};that.forgetPassword=function(){var sso=that.getSSO(),data=that.getData();var forgetData={};forgetData.entry="wapsso";forgetData.username=data.loginname||data.advanceLoginname;forgetData.from=1;forgetData.r=window.location.href;sso.forgetPassword(forgetData)};that.checkPin=function(code){if(code.nopwd){that.switchFace("mobile")}else{var showpin=code.showpin.toString();if(showpin==="1"){that.switchFace("door")}else{if(showpin==="2"){that.switchFace("vsn")}else{if(showpin==="0"){that.switchFace("password")}}}}};that.update=function(){var value=nodes.loginname.value;if(value!=that.prev_value){that.switchFace("password");if(checkpinCache[$.trim(value)]){that.checkFace()}}that.prev_value=value;that.showClearButton()};that.delayUpdate=function(){if(!that.buffer){that.buffer=$buffer_pool({delay:conf.updateDelay});that.buffer.feedback=that.update}that.buffer.trigger_regular();that.changeSubmit()};that.clearName=function(){nodes.loginname.value="";nodes.password.value="";that.update();that.changeSubmit()};that.clearPassword=function(){nodes.password.value="";that.changeSubmit()};that.clearVsn=function(){nodes.vsn.value="";that.changeSubmit()};that.focusLoginName=function(){if(that.focusDom&&that.focusDom!==nodes.loginname){that[that.focusDom]()}nodes.loginname_box.className="ipt-sect ipt-sect-name ipt-sect-focus";that.hideTip();that.focusDom="blurLoginName"};that.focusPassword=function(){if(that.focusDom&&that.focusDom!==nodes.password){that[that.focusDom]()}nodes.password_box.className="ipt-sect ipt-sect-pass ipt-sect-focus";that.hideTip();that.focusDom="blurPassword"};that.focusDoor=function(){if(that.focusDom&&that.focusDom!==nodes.door){that[that.focusDom]()}nodes.door_box.className="ipt-sect ipt-sect-yz ipt-sect-focus";that.hideTip();that.focusDom="blurDoor"};that.focusVsn=function(){if(that.focusDom&&that.focusDom!==nodes.vsn){that[that.focusDom]()}nodes.vsn_box.className="ipt-sect ipt-sect-vd ipt-sect-focus";that.hideTip();that.focusDom="blurVsn"};that.focusMobile=function(){if(that.focusDom&&that.focusDom!==nodes.mobile){that[that.focusDom]()}nodes.mobile_box.className="ipt-sect ipt-sect-yz ipt-sect-focus";that.hideTip();that.focusDom="blurMobile"};that.blurLoginName=function(){nodes.loginname_box.className="ipt-sect ipt-sect-name"};that.blurPassword=function(){nodes.password_box.className="ipt-sect ipt-sect-pass"};that.blurDoor=function(){nodes.door_box.className="ipt-sect ipt-sect-yz"};that.blurVsn=function(){nodes.vsn_box.className="ipt-sect ipt-sect-vd"};that.blurMobile=function(){nodes.mobile_box.className="ipt-sect ipt-sect-yz"};that.clearFocusClearName=function(evt){if(that.focusDom){var stop={loginname:1,password_box:1,password:1,door_box:1,door:1,door_img:1,vsn_box:1,vsn:1,mobile_box:1,mobile:1,mobile_Verify:1,clearName:1,clearPassword:1,clearVsn:1};var node_type=evt.target.getAttribute("node-type");if(!stop[node_type]){that[that.focusDom]()}}};that.changeUser=function(){nodes.loginname.value="";nodes.password.value="";nodes.door.value="";nodes.vsn.value="";nodes.mobile.value="";that.switchFace("change");that.changeSubmit()};that.changeSubmit=function(){that.submitDisabled=false;$.foreach(["loginname","password","door","vsn","mobile"],function(prop){var box=prop+"_box";if(nodes[box].style.display!="none"&&$.trim(nodes[prop].value)===""){that.submitDisabled=true}});nodes.submit.className=that.submitDisabled?"lymb-sub":"lymb-sub lymb-sub-enable"};that.parseDom=function(){var parentNode=rootNode;if(parentNode){var dom=$builder(parentNode);nodes=$parseDOM(dom.list);nodes.box=dom.box;that.nodes=nodes;$.foreach(["root","tip","loginname","password_box","password","door_box","door","door_img","vsn_box","vsn","mobile_box","mobile","mobile_Verify"],function(prop){if(!nodes[prop]){throw ("Can't find necessary node : "+prop+" !")}});$.foreach(["submit","clear","door_voice","door_change","forget_password","forget_vsn","register_button","remember","remember_label"],function(prop){if(!nodes[prop]){that.log("Can't find node : "+prop+" !")}});nodes.relative=conf.relative_node||nodes.root}else{that.log("Can't find login form : "+rootNode.id||rootNode.getAttribute("noe-type"))}};that.domEvents={check_keydown:function(evt){evt=$.fixEvent(evt);var state=that.getFaceState();var focus_node=null;var node_type=evt.target.getAttribute("node-type");if(evt.keyCode==13){if(!nodes.loginname.value){focus_node=nodes.loginname}else{if(!nodes.password.value){focus_node=nodes.password}else{if(!nodes[state].value){focus_node=nodes[state]}else{that.submit()}}}}if(focus_node){setTimeout(function(){focus_node.focus()},10)}},clear:function(){$.preventDefault();that.reset();that.hideClearButton();that.clearRemember();nodes.loginname.focus();nodes.loginname.blur()},submit:function(){$.preventDefault();that.submit()}};that.setDomEvents=function(type){type=type=="add"?"add":"remove";var action=type+"Event";$bind_change(nodes.loginname,type,that.delayUpdate);$bind_change(nodes.password,type,that.changeSubmit);$bind_change(nodes.door,type,that.changeSubmit);$bind_change(nodes.vsn,type,that.changeSubmit);$bind_change(nodes.mobile,type,that.changeSubmit);$[action](nodes.submit,"click",that.domEvents.submit);$[action](nodes.box,"click",that.clearFocusClearName);$[action](nodes.loginname,"blur",that.checkFace);$[action](nodes.loginname,"focus",that.focusLoginName);$[action](nodes.password,"focus",that.focusPassword);$[action](nodes.door,"focus",that.focusDoor);$[action](nodes.vsn,"focus",that.focusVsn);$[action](nodes.mobile,"focus",that.focusMobile);$[action](nodes.mobile_Verify,"click",that.mobileVerify);$[action](nodes.clearName,"click",that.clearName);$[action](nodes.clearPassword,"click",that.clearPassword);$[action](nodes.clearVsn,"click",that.clearVsn);$[action](nodes.changeUser,"click",that.changeUser);$[action](nodes.loginname,"keydown",that.domEvents.check_keydown);$[action](nodes.password,"keydown",that.domEvents.check_keydown);$[action](nodes.door,"keydown",that.domEvents.check_keydown);$[action](nodes.vsn,"keydown",that.domEvents.check_keydown)};that.listenerEvents={loginComplete:function(json){},loginSuccess:function(json){that.hideTip()},loginFailure:function(json){that.lockForm(false);json=json||{reason:""};var username=nodes.loginname.value||nodes.advanceLoginname.value;that.username=!that.loginFailureNum?username:that.username;var reason=json.msg;var state=that.getFaceState();if(that.door&&state==="door"){that.door.change()}if(that.username===username&&(json.retcode===50011002||json.retcode===50011015)){that.loginFailureNum++;if(that.loginFailureNum>=3){reason=$template("#{E010006}")}}else{that.loginFailureNum=0}that.setTip(reason)},verify:function(json){that.lockForm(false);that.verify(json)},logoutSuccess:function(json){that.reset()},onLoginTimeout:function(){that.lockForm(false);var errTip=$template("#{E010005}");that.setTip(errTip)}};that.setListener=function(type){var action=type=="register"?"register":"remove";$channel_sso[action]("login_complete",that.listenerEvents.loginComplete);$channel_sso[action]("login_success",that.listenerEvents.loginSuccess);$channel_sso[action]("login_failure",that.listenerEvents.loginFailure);$channel_sso[action]("logout_success",that.listenerEvents.logoutSuccess);$channel_sso[action]("need_verify",that.listenerEvents.verify);$channel_sso[action]("login_timeout",that.listenerEvents.onLoginTimeout)};that.initPlugin=function(){that.switchFace("password");that.lockForm(false);setTimeout(function(){that.showClearButton();that.placeholder_loginname=$placeholder(nodes.loginname).set();that.placeholder_password=$placeholder(nodes.password).set();that.placeholder_vsn=$placeholder(nodes.vsn).set();nodes.loginname.blur();nodes.password.blur()},conf.closeAutoCompleteDelay);that.door=$door({address:conf.door_address,usesso:true,autofocus:true,img:nodes.door_img,input:nodes.door,button:nodes.door_change});that.door.init();that.setSSO();if(conf.entry){var regHref=$template(conf.register_url,{entry:conf.entry});if($.getType(nodes.register_button)==="array"){$.foreach(nodes.register_button,function(btn){btn.href=regHref})}}if(nodes.forget_password&&conf.forget_password_url){nodes.forget_password.href=conf.forget_password_url}else{if(nodes.forget_password){nodes.forget_password.href="https://passport.sina.cn/forgot/forgot?entry=wapsso&from=0&r="+window.encodeURIComponent(window.location.href)}}if(nodes.register_login){nodes.register_login.href="https://passport.sina.cn/signup/signup?entry=wapsso&r="+window.encodeURIComponent(window.location.href)}if(nodes.forget_vsn&&conf.forget_vsn_url){nodes.forget_vsn.href=conf.forget_vsn_url}};that.setSSO=function(){that.SSO=$sso();that.SSO.init()};that.getSSO=function(){return that.SSO};that.advanceLogin=function(){var sso=that.getSSO();sso.chackLogin(function(rs){if(rs.retcode===20000000&&(rs.data.type===2||rs.data.type===3)){var userData=rs.data;nodes.advanceLoginname.value=userData.username;nodes.userhead.src=userData.portrait;if(userData.nopwd===1){var code={nopwd:1};that.checkPin(code);checkpinCache[userData.username]={nopwd:1};that.mobileVerifyurl=userData.smsurl}else{if(userData.showpin!==undefined){var code={nopwd:0,showpin:userData.showpin};that.checkPin(code)}checkpinCache[userData.username]={nopwd:0,showpin:userData.showpin}}nodes.loginname_box.style.display="none";nodes.advanceLoginname_box.style.display="block"}})};that.log=function(str){if(str){$.log("STK.comp.login.plugin : "+str)}};that.destroy=function(){that.setListener("remove");that.setDomEvents("remove");that.placeholder_loginname.destroy();that.placeholder_password.destroy();that.placeholder_vsn.destroy();if(that.door&&that.door.destroy){that.door.destroy()}};that.init=function(){that.parseDom();that.setDomEvents("add");that.setListener("register");that.initPlugin()};that.nodes=nodes;that.conf=conf;return that}});STK.register("comp.defaultStyle",function($){var cssText=['.layer-mb-login {position: absolute;width: 256px;padding: 40px 12px 20px;background: #f8f8f8;border-radius: 3px;font-family:"STHeiti Light","Microsoft Yahei",Helvetica;}',".layer-mb-login .lymb-icon {display: inline-block;background-image: url(http://i.sso.sina.com.cn/images/login/lymb_icon.png);background-repeat: no-repeat;}",".layer-mb-login .lymb-cls {position: absolute;top: -50px;right: 10px;width: 32px;height: 32px;background-position: 0 0;}",".layer-mb-login .text_remove {position: absolute;display:none;width: 20px;height: 20px;background-position: -40px 0;right: 17px;top: 10px;z-index:4;}",".layer-mb-login .edit_name {position: absolute;width: 26px;height: 22px;background-position: 0 -240px;right:28px;top:13px;}",".layer-mb-login .lymb-thumb {position: absolute;top: -50px;left: 50%;margin-left: -41px;width: 80px;height: 80px;border-radius: 40px;border: 1px solid #e1e1e1;background:#f8f8f8;}",".layer-mb-login .lymb-thumb img {margin:5px 0 0 5px;width: 70px;height: 70px;-webkit-border-radius: 35px;border-radius: 35px;}",".layer-mb-login .lymb-ipt-wrap {position: relative;}",".layer-mb-login .ipt-sect {position:relative;margin-top: -1px;border: 1px solid #dfdfdf;background:#fff;}",".layer-mb-login .ipt-sect-focus{border-color: #0090f7;z-index:2;background:#fff;}",".layer-mb-login .ipt-sect-focus .text_remove{display:block;}",".layer-mb-login .ipt-sect-name .edit_name {right: 8px;top: 12px;}",".layer-mb-login .ipt {position:relative;border:0;width: 200px;padding:0 0 0 50px;height: 39px;color: #1a1a1a;outline: none;font-size: 16px;-webkit-appearance: none;border-radius: 0;}",".layer-mb-login .ipt-sect-focus .ipt{width: 160px;}",".layer-mb-login .ipt::-webkit-input-placeholder {color:#9fa6ac;}",".layer-mb-login .ipt:focus::-webkit-input-placeholder {color:transparent;}",".layer-mb-login .ipt-sect-vd .ipt,",".layer-mb-login .ipt-sect-yz .ipt{width:128px;padding-left:16px;background-color:transparent;}",".layer-mb-login .ipt-sect-name .ipt {background: url(http://i.sso.sina.com.cn/images/login/lymb_icon.png) no-repeat 14px -70px;}",".layer-mb-login .ipt-sect-name.ipt-sect-focus .ipt {background-position: 14px -110px;}",".layer-mb-login .ipt-sect-pass .ipt {background: url(http://i.sso.sina.com.cn/images/login/lymb_icon.png) no-repeat 14px -150px;}",".layer-mb-login .ipt-sect-pass.ipt-sect-focus .ipt {background-position: 14px -190px;}",".layer-mb-login .ipt-cookie {position:relative;width: 254px;padding-left: 0;border-color: transparent;background: none;text-align: center;}",".layer-mb-login .lymb-code{position:absolute;top:0;right:4px;z-index:3;}",".layer-mb-login .lymb-code img{height:39px;}",".layer-mb-login .lymb-code-btn,",".layer-mb-login .lymb-code-wait{position:absolute;top:1px;right:1px;z-index:3;display:inline-block;width:100px;height:37px;line-height:37px;background:#34a83d;color:#fff; text-decoration:none;font-size:14px;text-align:center;}",".layer-mb-login .lymb-code-wait{background:#666;}",".layer-mb-login .lymb-sub {margin-top: 20px;display: block;height: 30px;line-height: 30px;text-align: center;background: #dfdfdf;text-decoration: none;color: #fff;font-size: 16px;}",".layer-mb-login .lymb-sub-enable {background-color: #0090f7;}",".layer-mb-login .lymb-help {font-size: 12px;padding-top: 20px;line-height: 1;color: #9fa6ac;}",".layer-mb-login .lymb-help a {color: #3990e6;}",".layer-mb-login .fgtpass {float: right;}",".layer-mb-login .lymb-warn {border: 1px solid #ffc0c0;padding: 8px 14px;background: #ffefef;color: #f48383;font-size: 14px;}","@media screen and (-webkit-device-pixel-ratio: 2){.layer-mb-login .lymb-icon{background-image:url(http://i.sso.sina.com.cn/images/login/lymb_2t_icon.png);background-size:80px 280px;}}",".layer-mb-promote{position:absolute;border-radius:5px;width:240px;padding:16px 10px 10px;background:hsla(0,0%,0%,.6);color:#fff;}",".layer-mb-promote .promote-txt{line-height:20px;font-size:14px;}",".layer-mb-promote .promote-sub{padding-top:30px;overflow:hidden;text-align:center;}",".layer-mb-promote .promote-sub-cancle,",".layer-mb-promote .promote-sub-veri{display:inline-block;width:117px;height:28px;border:1px solid #77797d;border-radius:5px;background:#6d7175;color:#fff;line-height:28px;text-decoration:none;}",".layer-mb-promote .promote-sub-veri{margin-left:2px;border-color:#d65b41;background-color:#bd4329;}"];return{get:function(){if(typeof cssText!=="string"){cssText=cssText.join("\n")}return cssText}}});STK.register("comp.layer.outlogin",function($){var $merge=$.core.json.merge,$lang=$.core.util.language,$getSize=$.core.dom.getSize,$append=$.kit.obj.append,$fix=$.kit.dom.fix,$builder=$.kit.dom.builder,$parseDOM=$.kit.dom.parseDOM,$loadStyle=$.kit.dom.loadStyle,$makeReady=$.kit.util.makeReady,$appendStyle=$.kit.dom.appendStyle,$mask=$.module.mask,$sso=$.common.util.sso,$channel_sso=$.common.channel.sso,$defaultStyle=$.comp.defaultStyle,$outlogin=$.comp.login.outlogin;var nodes={};var TPL={layer:['<div node-type="box" class="layer-mb-login" style="top:100px;display:none;">','<span  node-type="close" class="lymb-icon lymb-cls"></span>','<div  class="lymb-thumb"><img src="http://i.sso.sina.com.cn/images/login/thumb_default.gif" node-type="userhead"/></div>','<div class="lymb-ipt-wrap">','<div class="ipt-sect ipt-sect-name" node-type="loginname_box">','<input node-type="loginname" type="text" class="ipt" placeholder="#L{微博帐号/手机号/邮箱}"><span class="lymb-icon text_remove" node-type = "clearName"></span>',"</div>",'<div class="ipt-sect ipt-sect-name ipt-cookie" style="display:none;" node-type = "advanceLoginname_box">','<input type="text" class="ipt ipt-cookie" node-type="advanceLoginname" readOnly><span class="lymb-icon edit_name" node-type = "changeUser"></span></span>',"</div>",'<div class="ipt-sect  ipt-sect-pass" node-type="password_box">','<input node-type="password" type="password" class="ipt" placeholder="#L{密码}"><span class="lymb-icon text_remove" node-type = "clearPassword"></span>',"</div>",'<div class="ipt-sect  ipt-sect-vd" node-type="vsn_box">','<input node-type="vsn" type="text" class="ipt" placeholder="请输入微盾"><span class="lymb-icon text_remove" node-type = "clearVsn"></span>',"</div>",'<div class="ipt-sect  ipt-sect-yz" node-type="door_box">','<input node-type="door" type="text" class="ipt" placeholder="#L{请输入验证码}"><a href="#" class="lymb-code"><img node-type="door_img" src=""></a>',"</div>",'<div node-type="mobile_box" class="ipt-sect  ipt-sect-yz">','<input node-type="mobile" type="text" class="ipt" placeholder="点击输入验证码"><a href="#" class="lymb-code-btn" node-type="mobile_Verify">获取验证码</a>',"</div>",'<div node-type="tip" class="lymb-warn">这里会显示任意长度的报错文字</div>','<a href="#" class="lymb-sub" node-type="submit" suda-uatrack="key=guess_wap_summary&value=login_logclick">登录</a>',"</div>",'<div class="lymb-help" node-type="root">','<a node-type="forget_password" href="" class="fgtpass">忘记密码？</a>还没有帐号？<a href="" node-type="register_login">立即注册</a>',"</div>","</div>"].join("")};var that={};var _this={};var options={html:{layer:TPL.layer},sso:{entry:"wapsso"},language:{iframemask:"",E010001:"请输入登录名",E010002:"请输入密码",E010003:"请输入验证码",E010004:"请输入您微盾上显示的动态码",E010005:"网络异常，请检查网络连接",E010006:'如果您忘记了密码请点击：<a href="javascript:;" target="_blank" onclick = "window.SINA_OUTLOGIN_LAYER.forgetPassword()">忘记密码</a>',"4010":'帐号尚未激活，请<a href="https://login.sina.com.cn/signup/signupmail1.php?user=#{loginname}" target="_blank">点此激活</a>',end:""},styles:{zIndex:"10000"},mask:{enable:true,opacity:0.5,background:"#000000"},modes:{simple:"sos-pad-login"},plugin:{position:"center",parentNode:null,relatedNode:null,savestate:365}};$.$LANG=options.language;that.set=function(type,spec){type=type.toString();spec=spec||{};var ops=options[type];if(ops){ops=$merge(ops,spec);options[type]=ops}if(_this[type]&&_this[type].conf){$append(_this[type].conf,ops)}return that};that.init=function(){_this.prepare();return that};var cssLoaded=false;_this.prepareCss=function(fn){if(!_this.cssReady){_this.cssReady=$makeReady({condition:function(){return cssLoaded},ready:function(callback){$appendStyle($defaultStyle.get());if(options.extra&&options.extra.css){$loadStyle(options.extra.css,{timeout:10*1000,styleCheck:function(){if($.isNode(nodes.css_check)){var width=$.getStyle(nodes.css_check,"width");if(width==="123px"){return true}}},onLoad:function(){cssLoaded=true;callback()},onTimeout:function(){_this.cssReady.reset()}})}else{cssLoaded=true;callback()}}})}_this.cssReady.exec(fn)};_this.prepare=function(fn){$.Ready(function(){_this.parseDom();_this.prepareCss(function(){_this.build();if($.getType(fn)==="function"){fn()}})})};_this.setSSO=function(){_this.setListener("add")};_this.build=function(){if(_this.plugin){return}_this.setSSO();_this.parseDom();$.setStyle(nodes.box,"display","");if(options.mask.enable){that.nodes.mask=_this.mask=$mask.showUnderNode(nodes.box,options.mask);$.setStyle(_this.mask.getNode(),"display","none");$.addEvent(document.getElementById("ST_outLogin_mask"),"touchmove",function(e){e.preventDefault()})}_this.plugin=$outlogin(nodes.box);options.plugin.entry=options.sso.entry;_this.plugin.setOptions(options.plugin);_this.plugin.init();$.setStyle(nodes.box,"display","none");_this.setEvents("add");$channel_sso.fire("layer_ready")};_this.insert=function(){if(!$.isNode(nodes.box)){return}var parentNode=options.plugin.parentNode;if(!$.isNode(parentNode)){parentNode=document.body}if(!$.isNode(nodes.box.parentNode)||parentNode!==_this._currentParentNode){parentNode.appendChild(nodes.box)}_this._currentParentNode=parentNode};_this.parseDom=function(){if(!$.isNode(nodes.box)){var html=$lang(options.html.layer,options.language);var dom=$builder(html);that.nodes=nodes=$parseDOM(dom.list);nodes.box=dom.box;_this.insert()}};_this.updateLayer=function(){_this.insert();$.foreach(options.styles,function(val,key){$.setStyle(nodes.box,key,val)})};_this.setPosition=function(){var position=options.plugin.position,boxSize=$getSize(nodes.box),relatedNode,arr,rPos,rSize,winSize;if(position==="center"){if(!_this.fixedLayer){_this.fixedLayer=$fix(nodes.box,"c")}else{_this.fixedLayer.setFixed(true)}}else{if(_this.fixedLayer){_this.fixedLayer.destroy();_this.fixedLayer=null}if(position==="custom"){$.setStyle(nodes.box,"position","absolute")}else{$.setStyle(nodes.box,"position","absolute");relatedNode=options.plugin.relatedNode;if(relatedNode){rPos=$.position(relatedNode);rSize=$getSize(relatedNode)}arr=position.split(/\s*[,，]\s*/gi);$.foreach(arr,function(prop){if(rPos&&rSize){switch(prop){case"top":$.setStyle(nodes.box,"top",rPos.t+"px");break;case"bottom":$.setStyle(nodes.box,"top",rPos.t+rSize.height-boxSize.height+"px");break;case"left":$.setStyle(nodes.box,"left",rPos.l+"px");break;case"right":$.setStyle(nodes.box,"left",rPos.l+rSize.width-boxSize.width+"px");break;default:break}}else{$.setStyle(nodes.box,prop,"0px")}})}}if(nodes.iframemask){var borderWidth=$.getStyle(nodes.box,"borderWidth");borderWidth=parseInt(borderWidth,10);$.setStyle(nodes.iframemask,"width",boxSize.width+"px");$.setStyle(nodes.iframemask,"height",boxSize.height+"px");$.setStyle(nodes.iframemask,"marginLeft",0-borderWidth+"px");$.setStyle(nodes.iframemask,"marginTop",0-borderWidth+"px")}};that.reset=function(){if(_this.plugin){_this.plugin.reset()}};_this.onLogin=function(){that.hide()};_this.onClose=function(){$outlogin.loginFailureNum=0;that.hide()};_this.onLogout=function(){};_this.setEvents=function(type){var action=type==="add"?"addEvent":"removeEvent";$[action](nodes.close,"click",_this.onClose);$[action](window,"unload",that.destroy);$[action](nodes.box,"touchmove",function(e){e.preventDefault()})};_this.setListener=function(type){var action=type==="add"?"register":"remove";$channel_sso[action]("login_success",_this.onLogin);$channel_sso[action]("logout_success",_this.onLogout)};that.forgetPassword=function(){_this.plugin.forgetPassword()};that.isDisplay=function(){return nodes.box?$.getStyle(nodes.box,"display")!=="none":false};that.isVisible=function(){return nodes.box?!!nodes.box.offsetWidth:false};that.show=function(){try{$.preventDefault()}catch(e){}_this.prepare(function(){var isDisplay=that.isDisplay();var isVisible=that.isVisible();if(!isDisplay){if(_this.mask){$.setStyle(_this.mask.getNode(),"display","")}if(nodes.box){$.setStyle(nodes.box,"display","");that.reset()}}_this.updateLayer();_this.setPosition();if(!isVisible){if(_this.plugin){_this.plugin.advanceLogin();_this.plugin.showClearButton()}}if(!isDisplay){$channel_sso.fire("layer_show")}});return that};that.hide=function(){try{$.preventDefault()}catch(e){}that.reset();if(_this.mask){$.setStyle(_this.mask.getNode(),"display","none")}if(nodes.box){$.setStyle(nodes.box,"display","none")}$channel_sso.fire("layer_hide");return that};var parseQueryToJson=function(str){var arr=str.split("&");var arrtmp;var obj={};for(var i=0;i<arr.length;i++){arrtmp=arr[i].split("=");obj[arrtmp[0]]=decodeURIComponent(arrtmp[1])||""}return obj};that.destroy=function(){that.hide();_this.setEvents("remove");_this.setListener("remove");if(that.loginButton){$.removeEvent(that.loginButton,"click",that.show);that.loginButton=null}$.foreach(["mask","SSO","plugin"],function(name){var obj=_this[name];if(obj&&typeof(obj.destroy)==="function"){try{obj.destroy()}catch(e){}}})};that.register=function(channel,fn){$channel_sso.register(channel,fn);return that};that.remove=function(channel,fn){$channel_sso.remove(channel,fn);return that};that.getNodes=function(){return nodes};that.getSinaUserData=function(){return window.SINA_OUTLOGIN_LAYER_MOBILE_DATA?window.SINA_OUTLOGIN_LAYER_MOBILE_DATA:null};that.nodes=nodes;that.options=options;return that});(function($){var $ns=$.comp.layer.outlogin;$ns.getVersion=function(){return"1.0.0"};$ns.listener=$.common.channel.sso;$ns.STK=STK;this.SINA_OUTLOGIN_LAYER=$ns}).call(this,STK)}).call(this);
}catch(e){throw new Error(e+" http://i.sso.sina.com.cn/js/outlogin_layer_mobile.js");}

try{﻿function WapLogin(){var a=this;this.login=function(b,f,c,d){var e=arguments.length;if(window.SINA_OUTLOGIN_LAYER&&!b){_loginLayer=window.SINA_OUTLOGIN_LAYER;_loginLayer.set("sso",{entry:"wapsso"}).init();_loginLayer.show();_loginLayer.register("login_success",function(g){a.updateUserInfo(g);switch(e){case 2:f();break;case 3:f(c);break;case 4:f(c,d);break;default:window.location.href=window.location.href;break}});_loginLayer.register("layer_hide",function(){f=null})}return false};this.updateUserInfo=function(d){if(typeof(d)!="undefined"&&typeof(d.nick)!="undefined"){window.userInfo={};window.userInfo.uname=d.nick;window.userInfo.userface=d.portrait;window.userInfo.uid=d.uid;window.userInfo.islogin=1;var c=["#loginBox","#loginImg",".userImage"],h=$("#footer_entry");for(var g=0;g<c.length;g++){var f=$(c[g]);if(f.length>0&&f.find("img").length>0){f.find("img").attr("src",d.portrait)}else{if(f.length>0&&f.find("img").length<=0){var e='<img src="'+d.portrait+'">';f.html(e)}}}if(h.length>0){var b="http://passport.sina.cn/sso/logout?entry=wapsso&vt=4&r="+encodeURIComponent(window.location.href);h.html("退出").attr("href",b)}}return false}};
}catch(e){throw new Error(e+" http://mjs.sinaimg.cn/wap/module/share/201507071535/js/waplogin.min.js");}

try{/*! iScroll v5.1.3 ~ (c) 2008-2014 Matteo Spinelli ~ http://cubiq.org/license */
(function (window, document, Math) {
var rAF = window.requestAnimationFrame	||
	window.webkitRequestAnimationFrame	||
	window.mozRequestAnimationFrame		||
	window.oRequestAnimationFrame		||
	window.msRequestAnimationFrame		||
	function (callback) { window.setTimeout(callback, 1000 / 60); };
var utils = (function () {
	var me = {};
	var _elementStyle = document.createElement('div').style;
	var _vendor = (function () {
		var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
			transform,
			i = 0,
			l = vendors.length;
		for ( ; i < l; i++ ) {
			transform = vendors[i] + 'ransform';
			if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
		}
		return false;
	})();
	function _prefixStyle (style) {
		if ( _vendor === false ) return false;
		if ( _vendor === '' ) return style;
		return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
	}
	me.getTime = Date.now || function getTime () { return new Date().getTime(); };
	me.extend = function (target, obj) {
		for ( var i in obj ) {
			target[i] = obj[i];
		}
	};
	me.addEvent = function (el, type, fn, capture) {
		el.addEventListener(type, fn, !!capture);
	};
	me.removeEvent = function (el, type, fn, capture) {
		el.removeEventListener(type, fn, !!capture);
	};
	me.prefixPointerEvent = function (pointerEvent) {
		return window.MSPointerEvent ? 
			'MSPointer' + pointerEvent.charAt(9).toUpperCase() + pointerEvent.substr(10):
			pointerEvent;
	};
	me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
		var distance = current - start,
			speed = Math.abs(distance) / time,
			destination,
			duration;
		deceleration = deceleration === undefined ? 0.0006 : deceleration;
		destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
		duration = speed / deceleration;
		if ( destination < lowerMargin ) {
			destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
			distance = Math.abs(destination - current);
			duration = distance / speed;
		} else if ( destination > 0 ) {
			destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
			distance = Math.abs(current) + destination;
			duration = distance / speed;
		}
		return {
			destination: Math.round(destination),
			duration: duration
		};
	};
	var _transform = _prefixStyle('transform');
	me.extend(me, {
		hasTransform: _transform !== false,
		hasPerspective: _prefixStyle('perspective') in _elementStyle,
		hasTouch: 'ontouchstart' in window,
		hasPointer: window.PointerEvent || window.MSPointerEvent, // IE10 is prefixed
		hasTransition: _prefixStyle('transition') in _elementStyle
	});
	// This should find all Android browsers lower than build 535.19 (both stock browser and webview)
	me.isBadAndroid = /Android /.test(window.navigator.appVersion) && !(/Chrome\/\d/.test(window.navigator.appVersion));
	me.extend(me.style = {}, {
		transform: _transform,
		transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
		transitionDuration: _prefixStyle('transitionDuration'),
		transitionDelay: _prefixStyle('transitionDelay'),
		transformOrigin: _prefixStyle('transformOrigin')
	});
	me.hasClass = function (e, c) {
		var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
		return re.test(e.className);
	};
	me.addClass = function (e, c) {
		if ( me.hasClass(e, c) ) {
			return;
		}
		var newclass = e.className.split(' ');
		newclass.push(c);
		e.className = newclass.join(' ');
	};
	me.removeClass = function (e, c) {
		if ( !me.hasClass(e, c) ) {
			return;
		}
		var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
		e.className = e.className.replace(re, ' ');
	};
	me.offset = function (el) {
		var left = -el.offsetLeft,
			top = -el.offsetTop;
		// jshint -W084
		while (el = el.offsetParent) {
			left -= el.offsetLeft;
			top -= el.offsetTop;
		}
		// jshint +W084
		return {
			left: left,
			top: top
		};
	};
	me.preventDefaultException = function (el, exceptions) {
		for ( var i in exceptions ) {
			if ( exceptions[i].test(el[i]) ) {
				return true;
			}
		}
		return false;
	};
	me.extend(me.eventType = {}, {
		touchstart: 1,
		touchmove: 1,
		touchend: 1,
		mousedown: 2,
		mousemove: 2,
		mouseup: 2,
		pointerdown: 3,
		pointermove: 3,
		pointerup: 3,
		MSPointerDown: 3,
		MSPointerMove: 3,
		MSPointerUp: 3
	});
	me.extend(me.ease = {}, {
		quadratic: {
			style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
			fn: function (k) {
				return k * ( 2 - k );
			}
		},
		circular: {
			style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
			fn: function (k) {
				return Math.sqrt( 1 - ( --k * k ) );
			}
		},
		back: {
			style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
			fn: function (k) {
				var b = 4;
				return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
			}
		},
		bounce: {
			style: '',
			fn: function (k) {
				if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
					return 7.5625 * k * k;
				} else if ( k < ( 2 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
				} else if ( k < ( 2.5 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
				} else {
					return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
				}
			}
		},
		elastic: {
			style: '',
			fn: function (k) {
				var f = 0.22,
					e = 0.4;
				if ( k === 0 ) { return 0; }
				if ( k == 1 ) { return 1; }
				return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
			}
		}
	});
	me.tap = function (e, eventName) {
		var ev = document.createEvent('Event');
		ev.initEvent(eventName, true, true);
		ev.pageX = e.pageX;
		ev.pageY = e.pageY;
		e.target.dispatchEvent(ev);
	};
	me.click = function (e) {
		var target = e.target,
			ev;
		if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
			ev = document.createEvent('MouseEvents');
			ev.initMouseEvent('click', true, true, e.view, 1,
				target.screenX, target.screenY, target.clientX, target.clientY,
				e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
				0, null);
			ev._constructed = true;
			target.dispatchEvent(ev);
		}
	};
	return me;
})();
function IScroll (el, options) {
	this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
	this.scroller = this.wrapper.children[0];
	this.scrollerStyle = this.scroller.style;		// cache style for better performance
	this.options = {
// INSERT POINT: OPTIONS 
		startX: 0,
		startY: 0,
		scrollY: true,
		directionLockThreshold: 5,
		momentum: true,
		bounce: true,
		bounceTime: 600,
		bounceEasing: '',
		preventDefault: true,
		preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },
		HWCompositing: true,
		useTransition: true,
		useTransform: true
	};
	for ( var i in options ) {
		this.options[i] = options[i];
	}
	// Normalize options
	this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';
	this.options.useTransition = utils.hasTransition && this.options.useTransition;
	this.options.useTransform = utils.hasTransform && this.options.useTransform;
	this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
	this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;
	// If you want eventPassthrough I have to lock one of the axes
	this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
	this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;
	// With eventPassthrough we also need lockDirection mechanism
	this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
	this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;
	this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;
	this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;
	if ( this.options.tap === true ) {
		this.options.tap = 'tap';
	}
// INSERT POINT: NORMALIZATION
	// Some defaults	
	this.x = 0;
	this.y = 0;
	this.directionX = 0;
	this.directionY = 0;
	this._events = {};
// INSERT POINT: DEFAULTS
	this._init();
	this.refresh();
	this.scrollTo(this.options.startX, this.options.startY);
	this.enable();
}
IScroll.prototype = {
	version: '5.1.3',
	_init: function () {
		this._initEvents();
// INSERT POINT: _init
	},
	destroy: function () {
		this._initEvents(true);
		this._execEvent('destroy');
	},
	_transitionEnd: function (e) {
		if ( e.target != this.scroller || !this.isInTransition ) {
			return;
		}
		this._transitionTime();
		if ( !this.resetPosition(this.options.bounceTime) ) {
			this.isInTransition = false;
			this._execEvent('scrollEnd');
		}
	},
	_start: function (e) {
		// React to left mouse button only
		if ( utils.eventType[e.type] != 1 ) {
			if ( e.button !== 0 ) {
				return;
			}
		}
		if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
			return;
		}
		if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}
		var point = e.touches ? e.touches[0] : e,
			pos;
		this.initiated	= utils.eventType[e.type];
		this.moved		= false;
		this.distX		= 0;
		this.distY		= 0;
		this.directionX = 0;
		this.directionY = 0;
		this.directionLocked = 0;
		this._transitionTime();
		this.startTime = utils.getTime();
		if ( this.options.useTransition && this.isInTransition ) {
			this.isInTransition = false;
			pos = this.getComputedPosition();
			this._translate(Math.round(pos.x), Math.round(pos.y));
			this._execEvent('scrollEnd');
		} else if ( !this.options.useTransition && this.isAnimating ) {
			this.isAnimating = false;
			this._execEvent('scrollEnd');
		}
		this.startX    = this.x;
		this.startY    = this.y;
		this.absStartX = this.x;
		this.absStartY = this.y;
		this.pointX    = point.pageX;
		this.pointY    = point.pageY;
		this._execEvent('beforeScrollStart');
	},
	_move: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}
		if ( this.options.preventDefault ) {	// increases performance on Android? TODO: check!
			e.preventDefault();
		}
		var point		= e.touches ? e.touches[0] : e,
			deltaX		= point.pageX - this.pointX,
			deltaY		= point.pageY - this.pointY,
			timestamp	= utils.getTime(),
			newX, newY,
			absDistX, absDistY;
		this.pointX		= point.pageX;
		this.pointY		= point.pageY;
		this.distX		+= deltaX;
		this.distY		+= deltaY;
		absDistX		= Math.abs(this.distX);
		absDistY		= Math.abs(this.distY);
		// We need to move at least 10 pixels for the scrolling to initiate
		if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
			return;
		}
		// If you are scrolling in one direction lock the other
		if ( !this.directionLocked && !this.options.freeScroll ) {
			if ( absDistX > absDistY + this.options.directionLockThreshold ) {
				this.directionLocked = 'h';		// lock horizontally
			} else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
				this.directionLocked = 'v';		// lock vertically
			} else {
				this.directionLocked = 'n';		// no lock
			}
		}
		if ( this.directionLocked == 'h' ) {
			if ( this.options.eventPassthrough == 'vertical' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'horizontal' ) {
				this.initiated = false;
				return;
			}
			deltaY = 0;
		} else if ( this.directionLocked == 'v' ) {
			if ( this.options.eventPassthrough == 'horizontal' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'vertical' ) {
				this.initiated = false;
				return;
			}
			deltaX = 0;
		}
		deltaX = this.hasHorizontalScroll ? deltaX : 0;
		deltaY = this.hasVerticalScroll ? deltaY : 0;
		newX = this.x + deltaX;
		newY = this.y + deltaY;
		// Slow down if outside of the boundaries
		if ( newX > 0 || newX < this.maxScrollX ) {
			newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
		}
		if ( newY > 0 || newY < this.maxScrollY ) {
			newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
		}
		this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
		this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;
		if ( !this.moved ) {
			this._execEvent('scrollStart');
		}
		this.moved = true;
		this._translate(newX, newY);
/* REPLACE START: _move */
		if ( timestamp - this.startTime > 300 ) {
			this.startTime = timestamp;
			this.startX = this.x;
			this.startY = this.y;
		}
/* REPLACE END: _move */
	},
	_end: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}
		if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}
		var point = e.changedTouches ? e.changedTouches[0] : e,
			momentumX,
			momentumY,
			duration = utils.getTime() - this.startTime,
			newX = Math.round(this.x),
			newY = Math.round(this.y),
			distanceX = Math.abs(newX - this.startX),
			distanceY = Math.abs(newY - this.startY),
			time = 0,
			easing = '';
		this.isInTransition = 0;
		this.initiated = 0;
		this.endTime = utils.getTime();
		// reset if we are outside of the boundaries
		if ( this.resetPosition(this.options.bounceTime) ) {
			return;
		}
		this.scrollTo(newX, newY);	// ensures that the last position is rounded
		// we scrolled less than 10 pixels
		if ( !this.moved ) {
			if ( this.options.tap ) {
				utils.tap(e, this.options.tap);
			}
			if ( this.options.click ) {
				utils.click(e);
			}
			this._execEvent('scrollCancel');
			return;
		}
		if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
			this._execEvent('flick');
			return;
		}
		// start momentum animation if needed
		if ( this.options.momentum && duration < 300 ) {
			momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
			momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
			newX = momentumX.destination;
			newY = momentumY.destination;
			time = Math.max(momentumX.duration, momentumY.duration);
			this.isInTransition = 1;
		}
// INSERT POINT: _end
		if ( newX != this.x || newY != this.y ) {
			// change easing function when scroller goes out of the boundaries
			if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
				easing = utils.ease.quadratic;
			}
			this.scrollTo(newX, newY, time, easing);
			return;
		}
		this._execEvent('scrollEnd');
	},
	_resize: function () {
		var that = this;
		clearTimeout(this.resizeTimeout);
		this.resizeTimeout = setTimeout(function () {
			that.refresh();
		}, this.options.resizePolling);
	},
	resetPosition: function (time) {
		var x = this.x,
			y = this.y;
		time = time || 0;
		if ( !this.hasHorizontalScroll || this.x > 0 ) {
			x = 0;
		} else if ( this.x < this.maxScrollX ) {
			x = this.maxScrollX;
		}
		if ( !this.hasVerticalScroll || this.y > 0 ) {
			y = 0;
		} else if ( this.y < this.maxScrollY ) {
			y = this.maxScrollY;
		}
		if ( x == this.x && y == this.y ) {
			return false;
		}
		this.scrollTo(x, y, time, this.options.bounceEasing);
		return true;
	},
	disable: function () {
		this.enabled = false;
	},
	enable: function () {
		this.enabled = true;
	},
	refresh: function () {
		var rf = this.wrapper.offsetHeight;		// Force reflow
		this.wrapperWidth	= this.wrapper.clientWidth;
		this.wrapperHeight	= this.wrapper.clientHeight;
/* REPLACE START: refresh */
		this.scrollerWidth	= this.scroller.offsetWidth;
		this.scrollerHeight	= this.scroller.offsetHeight;
		this.maxScrollX		= this.wrapperWidth - this.scrollerWidth;
		this.maxScrollY		= this.wrapperHeight - this.scrollerHeight;
/* REPLACE END: refresh */
		this.hasHorizontalScroll	= this.options.scrollX && this.maxScrollX < 0;
		this.hasVerticalScroll		= this.options.scrollY && this.maxScrollY < 0;
		if ( !this.hasHorizontalScroll ) {
			this.maxScrollX = 0;
			this.scrollerWidth = this.wrapperWidth;
		}
		if ( !this.hasVerticalScroll ) {
			this.maxScrollY = 0;
			this.scrollerHeight = this.wrapperHeight;
		}
		this.endTime = 0;
		this.directionX = 0;
		this.directionY = 0;
		this.wrapperOffset = utils.offset(this.wrapper);
		this._execEvent('refresh');
		this.resetPosition();
// INSERT POINT: _refresh
	},
	on: function (type, fn) {
		if ( !this._events[type] ) {
			this._events[type] = [];
		}
		this._events[type].push(fn);
	},
	off: function (type, fn) {
		if ( !this._events[type] ) {
			return;
		}
		var index = this._events[type].indexOf(fn);
		if ( index > -1 ) {
			this._events[type].splice(index, 1);
		}
	},
	_execEvent: function (type) {
		if ( !this._events[type] ) {
			return;
		}
		var i = 0,
			l = this._events[type].length;
		if ( !l ) {
			return;
		}
		for ( ; i < l; i++ ) {
			this._events[type][i].apply(this, [].slice.call(arguments, 1));
		}
	},
	scrollBy: function (x, y, time, easing) {
		x = this.x + x;
		y = this.y + y;
		time = time || 0;
		this.scrollTo(x, y, time, easing);
	},
	scrollTo: function (x, y, time, easing) {
		easing = easing || utils.ease.circular;
		this.isInTransition = this.options.useTransition && time > 0;
		if ( !time || (this.options.useTransition && easing.style) ) {
			this._transitionTimingFunction(easing.style);
			this._transitionTime(time);
			this._translate(x, y);
		} else {
			this._animate(x, y, time, easing.fn);
		}
	},
	scrollToElement: function (el, time, offsetX, offsetY, easing) {
		el = el.nodeType ? el : this.scroller.querySelector(el);
		if ( !el ) {
			return;
		}
		var pos = utils.offset(el);
		pos.left -= this.wrapperOffset.left;
		pos.top  -= this.wrapperOffset.top;
		// if offsetX/Y are true we center the element to the screen
		if ( offsetX === true ) {
			offsetX = Math.round(el.offsetWidth / 2 - this.wrapper.offsetWidth / 2);
		}
		if ( offsetY === true ) {
			offsetY = Math.round(el.offsetHeight / 2 - this.wrapper.offsetHeight / 2);
		}
		pos.left -= offsetX || 0;
		pos.top  -= offsetY || 0;
		pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
		pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;
		time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;
		this.scrollTo(pos.left, pos.top, time, easing);
	},
	_transitionTime: function (time) {
		time = time || 0;
		this.scrollerStyle[utils.style.transitionDuration] = time + 'ms';
		if ( !time && utils.isBadAndroid ) {
			this.scrollerStyle[utils.style.transitionDuration] = '0.001s';
		}
// INSERT POINT: _transitionTime
	},
	_transitionTimingFunction: function (easing) {
		this.scrollerStyle[utils.style.transitionTimingFunction] = easing;
// INSERT POINT: _transitionTimingFunction
	},
	_translate: function (x, y) {
		if ( this.options.useTransform ) {
/* REPLACE START: _translate */
			this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;
/* REPLACE END: _translate */
		} else {
			x = Math.round(x);
			y = Math.round(y);
			this.scrollerStyle.left = x + 'px';
			this.scrollerStyle.top = y + 'px';
		}
		this.x = x;
		this.y = y;
// INSERT POINT: _translate
	},
	_initEvents: function (remove) {
		var eventType = remove ? utils.removeEvent : utils.addEvent,
			target = this.options.bindToWrapper ? this.wrapper : window;
		eventType(window, 'orientationchange', this);
		eventType(window, 'resize', this);
		if ( this.options.click ) {
			eventType(this.wrapper, 'click', this, true);
		}
		if ( !this.options.disableMouse ) {
			eventType(this.wrapper, 'mousedown', this);
			eventType(target, 'mousemove', this);
			eventType(target, 'mousecancel', this);
			eventType(target, 'mouseup', this);
		}
		if ( utils.hasPointer && !this.options.disablePointer ) {
			eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
			eventType(target, utils.prefixPointerEvent('pointermove'), this);
			eventType(target, utils.prefixPointerEvent('pointercancel'), this);
			eventType(target, utils.prefixPointerEvent('pointerup'), this);
		}
		if ( utils.hasTouch && !this.options.disableTouch ) {
			eventType(this.wrapper, 'touchstart', this);
			eventType(target, 'touchmove', this);
			eventType(target, 'touchcancel', this);
			eventType(target, 'touchend', this);
		}
		eventType(this.scroller, 'transitionend', this);
		eventType(this.scroller, 'webkitTransitionEnd', this);
		eventType(this.scroller, 'oTransitionEnd', this);
		eventType(this.scroller, 'MSTransitionEnd', this);
	},
	getComputedPosition: function () {
		var matrix = window.getComputedStyle(this.scroller, null),
			x, y;
		if ( this.options.useTransform ) {
			matrix = matrix[utils.style.transform].split(')')[0].split(', ');
			x = +(matrix[12] || matrix[4]);
			y = +(matrix[13] || matrix[5]);
		} else {
			x = +matrix.left.replace(/[^-\d.]/g, '');
			y = +matrix.top.replace(/[^-\d.]/g, '');
		}
		return { x: x, y: y };
	},
	_animate: function (destX, destY, duration, easingFn) {
		var that = this,
			startX = this.x,
			startY = this.y,
			startTime = utils.getTime(),
			destTime = startTime + duration;
		function step () {
			var now = utils.getTime(),
				newX, newY,
				easing;
			if ( now >= destTime ) {
				that.isAnimating = false;
				that._translate(destX, destY);
				if ( !that.resetPosition(that.options.bounceTime) ) {
					that._execEvent('scrollEnd');
				}
				return;
			}
			now = ( now - startTime ) / duration;
			easing = easingFn(now);
			newX = ( destX - startX ) * easing + startX;
			newY = ( destY - startY ) * easing + startY;
			that._translate(newX, newY);
			if ( that.isAnimating ) {
				rAF(step);
			}
		}
		this.isAnimating = true;
		step();
	},
	handleEvent: function (e) {
		switch ( e.type ) {
			case 'touchstart':
			case 'pointerdown':
			case 'MSPointerDown':
			case 'mousedown':
				this._start(e);
				break;
			case 'touchmove':
			case 'pointermove':
			case 'MSPointerMove':
			case 'mousemove':
				this._move(e);
				break;
			case 'touchend':
			case 'pointerup':
			case 'MSPointerUp':
			case 'mouseup':
			case 'touchcancel':
			case 'pointercancel':
			case 'MSPointerCancel':
			case 'mousecancel':
				this._end(e);
				break;
			case 'orientationchange':
			case 'resize':
				this._resize();
				break;
			case 'transitionend':
			case 'webkitTransitionEnd':
			case 'oTransitionEnd':
			case 'MSTransitionEnd':
				this._transitionEnd(e);
				break;
			case 'wheel':
			case 'DOMMouseScroll':
			case 'mousewheel':
				this._wheel(e);
				break;
			case 'keydown':
				this._key(e);
				break;
			case 'click':
				if ( !e._constructed ) {
					e.preventDefault();
					e.stopPropagation();
				}
				break;
		}
	}
};
IScroll.utils = utils;
if ( typeof module != 'undefined' && module.exports ) {
	module.exports = IScroll;
} else {
	window.IScroll = IScroll;
}
})(window, document, Math);
}catch(e){throw new Error(e+" iscroll-lite.js");}

try{var appliction = (function(window, document){
    "use strict";
    function Rio(obj){
        this.navIndex = 0;
        this.myScroll;
        this.init();
    }
    Rio.prototype = {
        constructor : Rio,
        init : function(){
            this.navScroll();
            this.navLocation();
            this.tabSwitch();
            this.clickEvent();
            this.clickUp();
        },
        navScroll : function(){
            var imageBox;
            var navDom = document.getElementById('scroller');
            if(navDom){
                var navWidth = navDom.scrollWidth;
                navDom.style.width = navWidth+"px";
                this.myScroll = new IScroll('#wrapper', { eventPassthrough: true, scrollX: true, scrollY: false, preventDefault: false });
            }
        },
        navLocation : function(){
            var _this = this;
            var navItemWidth = 0;
            var navItem = $("#scroller li");
            var PageWidth = parseInt($(window).width());
            if(navItem){
                navItem.each(function(index){
                    if($(this).hasClass("cur")){
                        _this.navIndex = index;
                    }
                });
                for(var i = 0; i <= this.navIndex; i++){
                    navItemWidth += parseInt(navItem.eq(i).width());
                }
                if(navItemWidth - PageWidth > 0){
                    navItemWidth = navItemWidth - PageWidth;
                    this.myScroll.scrollTo(-navItemWidth,0);
                }
            }
        },
        tabSwitch : function(){
            var tabDom = $("#tab_box li");
            var tabCon = $("#wrap_box .item");
            if(tabDom){
                tabDom.each(function(index){
                    $(this).click(function(){
                        tabDom.removeClass("cur")
                        $(this).addClass("cur");
                        tabCon.hide();
                        tabCon.eq(index).show();
                    })
                });
            }
        },
        login : function(e){
            if ($("#loginBox").html() === "") {
                e.preventDefault();
                var H = (typeof(WapLogin) == "function") ? (new WapLogin()) : this;
                H.login(false,function() {
                    $("#loginBox").html('<img src="' + f.data.portrait_url + '">');
                })
            }
        },
        goBack : function(){
            window.history.back();
        },
        clickEvent : function(){
            var _this = this;
            var loginDom = document.getElementById("loginBox");
            var goBack = document.getElementById("goBack");
            if(loginDom){
                this.addEvent(loginDom,"click",function(e){_this.login(e)});
            }
            if(goBack){
                this.addEvent(goBack,"click",this.goBack);
            }
        },
        clickUp : function(){
            var clickUp = $("#clickUp");
            var winHeight = parseInt($(window).height());
            this.addEvent(window,"scroll",function(){
                if(winHeight > document.body.scrollTop){
                    clickUp.hide();
                }else{
                    clickUp.show();
                }
            });
            clickUp.click(function(){
                document.body.scrollTop = 0;
            });
        },
        addEvent : function(obj,eventType,func){
            if(window.addEventListener){
                obj.addEventListener(eventType,func,false);
            }else{
                obj.attachEvent("on" + eventType,func); 
            }
        }
    } 
    var rio = new Rio();
})(window, document);
}catch(e){throw new Error(e+" rio.js");}

try{; (function(win, doc, undef) {
    'use strict';
    /**
     *  轮播组图高度控制类
     * @param id
     */
    var picsHeightManager = {
        isPicDivsBlocked : false,   //swipe pic divs is blocked
        init : function () {
            this.setPicsHeight();
            var self = this;
            window.addEventListener('onorientationchange' in window ?
                             'orientationchange' : 'resize', function () {
                var sf = self;
                setTimeout(function () {
                    sf.setPicsHeight();
                },300);
            }, false);
        },
        setheight:function(oSwipe,oImg){
            var _swiptContainerWidth = oSwipe.width();
            var _picsWidth = oImg.width();
            var _picsHeight = oImg.height();
            var _swiptContainerHeight = _swiptContainerWidth * _picsHeight / _picsWidth;
            _swiptContainerHeight = Math.floor(_swiptContainerHeight);
            oSwipe.css("height", _swiptContainerHeight + "px");
            oSwipe.find(".swipe-wrap").css("height", _swiptContainerHeight + "px");
            var _swipe_pics = oSwipe.find(".images_box").children();
            _swipe_pics.css("height", _swiptContainerHeight + "px");
            if (!this.isPicDivsBlocked) {
                this.isPicDivsBlocked = true;
                _swipe_pics.css("display", "block");
            }
        },
        setPicsHeight : function () {
            var me=this;
            try {
                var oSwipe = $('#j_imgSlide'),
                    oImg = oSwipe.children().eq(0).find('a').find('img');
                if(oImg[0].complete==false||oImg[0].readyState==false){
                    oImg[0].onload=function(){
                        me.setheight.apply(me,[oSwipe,oImg]);
                    }
                }
                else{
                    me.setheight(oSwipe,oImg);
                }
                
            } catch (e) {}
        }
    };
    $(document).ready(function(){
        picsHeightManager.init(); 
    });
    var Xwipe = function(el, options, tab) {
        this.el = el;
        this.element = el.children[0];
        this.slides = this.element.children;
        this.sLength = this.slides.length;
        this.sumElement = document.querySelector('.j_slide_sum');//此处结构化dom没有做好，先用document取
        this.options = options || {};
        this.options = {
            curIndex: this.options.curIndex || 0,
            speed: this.options.speed || 300,
            auto: this.options.auto || 0,
            callback: this.options.callback || null,
            afterTouchStop: this.options.afterTouchStop || false
        };
        this.autoTimer = 0;
        this.startStatus = {};
        this.endStatus = {};
        this.delta = {};
        this.slidePos = [];
        this.canSkip = true;
        this.isScrollY;
        this.tab = tab;
        this.init();
        this.initEvents();
        this.cardExpose(this.el);
        this.initExpose();
    }
    Xwipe.prototype = {
        handleEvent: function(e) {
            switch (e.type) {
            case 'touchstart':
                this.touchStart(e);
                break;
            case 'touchmove':
                this.touchMove(e);
                break;
            case 'touchend':
                this.touchEnd(e);
                break;
            case 'resize':
                this.init();
                break;
            default:
                break;
            }
        },
        init: function() {
            this.width = this.el.getBoundingClientRect().width || this.el.offsetWidth;
            this.element.style.width = (this.sLength * this.width) + "px";
            var index = this.sLength;
            while (index--) {
                var slide = this.slides[index];
                slide.style.width = this.width + 'px';
                slide.style.left = (index * -this.width) + 'px';
                this.medium(index, this.width, 0);
            }
            this.medium(this.circle(this.options.curIndex - 1), -this.width, 0);
            this.medium(this.options.curIndex, 0, 0);
            this.medium(this.circle(this.options.curIndex + 1), this.width, 0);
            this.el.style.visibility = 'visible';
            this.clearTimer();
            this.setTimer();
            this.setIndex(this.options.curIndex);
        },
        medium: function(index, dist, speed) {
            this.slidePos[index] = dist;
            this.translate(index, dist, speed);
        },
        translate: function(index, dist, speed) {
            var slide = this.slides[index];
            slide.style.webkitTransitionDuration = speed + 'ms';
            slide.style.webkitTransform = 'translate3d(' + dist + 'px, 0, 0)';
        },
        circle: function(index) {
            return (this.sLength + (index % this.sLength)) % this.sLength;
        },
        initEvents: function() {
            this.el.addEventListener("touchstart", this, false);
            this.el.addEventListener("touchmove", this, false);
            this.el.addEventListener("touchend", this, false);
            win.addEventListener("resize", this, false)
        },
        destroy: function() {
            this.el.removeEventListener("touchstart", this, false);
            this.el.removeEventListener("touchmove", this, false);
            this.el.removeEventListener("touchend", this, false);
            window.removeEventListener("resize", this, false);
            this.element.removeAttribute('style');
            this.clearTimer();
            for (var i = 0,
            len = this.element.children.length; i < len; i++) {
                this.element.children[i].removeAttribute('style');
            }
        },
        touchStart: function(e) {
            var touches = e.touches[0];
            this.startStatus = {
                x: touches.pageX,
                y: touches.pageY,
                time: new Date().getTime()
            };
            this.isScrollY = undef;
            this.clearTimer();
        },
        touchMove: function(e) {
            if (e.touches.length > 1 || e.scale && e.scale !== 1) return;
            var touches = e.touches[0];
            this.endStatus = {
                x: touches.pageX,
                y: touches.pageY,
                time: new Date().getTime()
            };
            this.delta.x = this.endStatus.x - this.startStatus.x;
            this.delta.y = this.endStatus.y - this.startStatus.y;
            this.delta.time = this.endStatus.time - this.startStatus.time;
            if (typeof this.isScrollY == 'undefined') {
                this.isScrollY = !!(this.isScrollY || Math.abs(this.delta.x) < Math.abs(this.delta.y));
            }
            if (!this.isScrollY) {
                e.preventDefault();
                this.translate(this.circle(this.options.curIndex - 1), this.delta.x + this.slidePos[this.circle(this.options.curIndex - 1)], 0);
                this.translate(this.options.curIndex, this.delta.x + this.slidePos[this.circle(this.options.curIndex)], 0);
                this.translate(this.circle(this.options.curIndex + 1), this.delta.x + this.slidePos[this.circle(this.options.curIndex + 1)], 0);
            }
            this.canSlide = true;
        },
        touchEnd: function(e) {
            if (!this.isScrollY && this.canSlide) {
                var isValidSlide = false;
                if (Math.abs(this.delta.x) > this.width / 2 || this.delta.time < 250 && Math.abs(this.delta.x) > 20) {
                    isValidSlide = true;
                    if (this.delta.x > 0) {
                        this.medium(this.circle(this.options.curIndex + 1), this.width, this.options.speed);
                        this.options.curIndex = this.circle(this.options.curIndex - 1);
                    } else {
                        this.medium(this.circle(this.options.curIndex - 1), -this.width, this.options.speed);
                        this.options.curIndex = this.circle(this.options.curIndex + 1);
                    }
                    this.slideCallback(this.options.curIndex);
                    this.setIndex(this.options.curIndex);
                }
                this.medium(this.circle(this.options.curIndex - 1), -this.width, (isValidSlide && (this.delta.x > 0)) ? 0 : this.options.speed);
                this.medium(this.options.curIndex, 0, this.options.speed);
                this.medium(this.circle(this.options.curIndex + 1), this.width, (isValidSlide && (this.delta.x < 0)) ? 0 : this.options.speed);
                if (!this.options.afterTouchStop) {
                    this.setTimer();
                }
            }
            this.canSlide = false;
            this.loadHandle();
        },
        getDirection: function(to) {
            return (to - this.options.curIndex) * (Math.abs(to - this.options.curIndex) > this.sLength / 2 ? -1 : 1) > 0 ? 1 : -1;
        },
        goTo: function(to) {
            if (this.options.curIndex == to || !this.canSkip) return;
            this.canSkip = false;
          
            to = this.circle(to);
            var direction = this.getDirection(to);
            this.translate(to, direction * this.width, 0);
            var _this = this;
            setTimeout(function() {
                _this.medium(_this.options.curIndex, -direction * _this.width, _this.options.speed);
                _this.medium(to, 0, _this.options.speed);
                _this.options.curIndex = to;
            },
            0); 
            setTimeout(function() {
                _this.medium(_this.circle(to - 1), -_this.width, 0);
                _this.medium(_this.circle(to + 1), _this.width, 0);
                _this.canSkip = true;
            },
            _this.options.speed);
            this.slideCallback(to);
            this.setIndex(to);
           
        },
        next: function() {
            this.goTo(this.options.curIndex + 1);
            this.loadHandle();
        },
        setTimer: function() {
            var me=this;
            if (this.options.auto) {
                var _this = this;
                this.autoTimer==0&& (_this.autoTimer = setInterval(function() {
                    _this.next();
                },
                this.options.auto));
            }
            // console.log(this.autoTimer)
        },
        clearTimer: function() {
            // console.log(this.autoTimer)
            if (this.options.auto) {
                
                clearInterval(this.autoTimer);
                this.autoTimer=0;
            }
        },
        slideCallback: function(index) {
            if (this.options.callback) this.options.callback(index);
        },
        setIndex: function(index) {
            if (this.tab) {
                this.tab.innerHTML = index + 1;
            }
        },
        loadHandle: function() {
            this.loadImg(this.circle(this.options.curIndex + 1));
            this.loadImg(this.circle(this.options.curIndex - 1));
        },
        loadImg: function(index) {
            var sildeImg = this.slides[index].querySelector('img'),
            src = sildeImg.getAttribute('data-src');
            if (sildeImg && src) {
                sildeImg.src = src;
                sildeImg.removeAttribute('data-src');
            }
        },
        cardExpose : function(dom){
            
            if(!dom){
                return;
            }
            // 注册节点
            //$(window).trigger('elemExposeAddItem', ['sinaIndex',  [dom], true]);
        },
        initExpose : function(){
            var that= this;
            $(window).on('elemExposeHappen', function(src, items, uid){
                // 触发事件
                try{
                    if(items.indexOf(that.el)==-1){
                        //屏幕外
                        that.clearTimer();
                    }
                    else if(items.indexOf(that.el)!=-1){
                        //屏幕内
                        that.lastTime = new Date();
                        
                        that.setTimer();
                    }
                   
                }catch(err){
                    console.log(err);
                }
            });
        }
        //[{dom:obj,pos:1},{dom:obj,pos:1},{dom:obj,pos:1}]//未验证，待调试。
        ,appendItemBatch:function(items){
            if(toString.call(items)!='[object Array]'){
                appendItem(items.dom,items.pos);
                return;
            }
            // this.element = el.children[0];
            // this.slides = this.element.children;
            // this.sLength = this.slides.length;
            //判断当前是否正在滚动，如果是则停止滚动，如果不是则直接进行append操作
            var isScrolling = false;
            //暂停滚动
            if(this.autoTimer!=0&&this.autoTimer!='undefined'){
                isScrolling=true;
            }
            if(isScrolling){
                this.clearTimer();
            }
            //维护变量
            this.sLength+=items.length;
            this.sumElement.innerHTML = this.sLength;
            this.element.style.width = (this.sLength * this.width) + "px";
            var nextitems = items.filter(function(item){
                return parseInt(item.pos)>this.options.curIndex;
            }).sort(function(a,b){
                return parseInt(b.pos)-parseInt(a.pos);
            }).forEach(function(itemIndex){
                this.element.appendChild(items[itemIndex].dom);
            });
            var preitems =items.filter(function(item){
                return parseInt(item.pos)<=this.options.curIndex;
            }).sort(function(a,b){
                return parseInt(a.pos)-parseInt(b.pos);
            }).forEach(function(itemIndex){
                this.element.insertBefore(items[itemIndex].dom, this.slides[items[itemIndex].pos]);
            });
            var index = this.sLength;
            while (index>=this.options.curIndex&&index--) {
                var slide = this.slides[index];
                slide.style.width = this.width + 'px';
                slide.style.left = (index * -this.width) + 'px';
                this.medium(index, this.width, 0);
            }
            this.medium(this.circle(this.options.curIndex - 1), -this.width, 0);
            this.medium(this.options.curIndex, 0, 0);
            this.medium(this.circle(this.options.curIndex + 1), this.width, 0);
            if(isScrolling){
                this.setTimer();
            }
            
        }
        ,appendItem:function(dom,pos){
            // this.element = el.children[0];
            // this.slides = this.element.children;
            // this.sLength = this.slides.length;
            //判断当前是否正在滚动，如果是则停止滚动，如果不是则直接进行append操作
            var isScrolling = false;
            //暂停滚动
            if(this.autoTimer!=0&&this.autoTimer!='undefined'){
                isScrolling=true;
            }
            if(isScrolling){
                this.clearTimer();
            }
            //维护变量
            this.sLength+=1;
            this.sumElement.innerHTML = this.sLength;
            this.element.style.width = (this.sLength * this.width) + "px";
            if(this.sLength-1>=parseInt(pos)){
                this.element.insertBefore(dom, this.slides[pos]);
            }
            else{
                this.element.appendChild(dom);
            }
            var index = this.sLength;
            while (index>=this.options.curIndex&&index--) {
                var slide = this.slides[index];
                slide.style.width = this.width + 'px';
                slide.style.left = (index * -this.width) + 'px';
                this.medium(index, this.width, 0);
            }
            this.medium(this.circle(this.options.curIndex - 1), -this.width, 0);
            this.medium(this.options.curIndex, 0, 0);
            this.medium(this.circle(this.options.curIndex + 1), this.width, 0);
            if(isScrolling){
                this.setTimer();
            }
            this.loadHandle();
            picsHeightManager.init();
            if($(dom).hasClass('item')==false){
                $(dom).css('display','block');
                $(dom).find('a').css('display','block');
            }
        }
    }
    window.initXwipe = function() {
        var myXwipe = doc.getElementById("j_imgSlide"),
        tab = doc.getElementById("j_topSlide_index"),
        options = {
            auto: 3000,
            curIndex: 0,
            speed: 300,
            afterTouchStop: true
        }
        window.xwipe = new Xwipe(myXwipe, options, tab);
    }
    window.initXwipe();
    
})(window, document); 
}catch(e){throw new Error(e+" xwipe.js");}

try{var sinaSax = (function () {
    "use strict";
    var prtl = 'https:' == window.location.protocol ? 'https://': 'http://';
    var sinaSax = {
        saxType: {},//存储模板类型
        
        //id为数据源pdps的key; data为返回数据集的直接父级，多层嵌套用'-'分割,pv同理; urlFix为发送jsonp请求是额外字段
        sax: [{class: 'j_sax', url: prtl + 'sax.sina.cn/wap/impress', id: 'id', pv: 'content-0-pv', data: 'ad', urlFix: function(){ return "&rotate_count=" + (parseInt((isNaN(sinaSax.storage.getMode('sax_wap'))) ? (Math.random() * 1000): (sinaSax.storage.get('sax_wap'))))}},
            {class: 'j_native', url: prtl + 'sax.sina.cn/native/impress', id: 'pdps', pv: 'pvmonitor',urlFix: function(){ return "&rotate_count=" + (parseInt((isNaN(sinaSax.storage.getMode('sax_native'))) ? (Math.random() * 1000): (sinaSax.storage.get('sax_native'))))}}],
        previewed : false,
        init: function () {
            //console.log(prtl);
            var iterator,
                i = 0,
                len = this.sax.length;
            for(; i< len; i++){
                this.sax[i].pdpsArr = [];
                this.sax[i].pdpsNodes = this.sax[i].pdpsNodes || [];
                this.sax[i].pdpsStr = this.sax[i].pdpsStr || [];
                this.sax[i].pdpsNodes.push(this.getValidClass(this.getClass(this.sax[i].class)));
                iterator = this.sax[i].pdpsNodes.length -1;
                this.sax[i].pdpsStr.push(this.getPdpsArr(this.sax[i].pdpsNodes[iterator]));
            }
            this.creatPvElement();
            this.getSaxType();
            this.ajaxHandle(iterator);
            if(location.hash.indexOf('preview') + 1){
                setTimeout(this.preview.call(this),300);               
            }
            
        },
        preview: function () {
            if(this.previewed)return;
            this.previewed=true;
            var previewData = decodeURIComponent(location.hash.substring(1)).split('|');
            previewData[0] = previewData[0].split('=')[1];
            if(previewData[0] && previewData[3]){
                var url = prtl + 'sax.sina.cn/wap/preview?' + 'adunit_id=' + previewData[0] + '&date=' + previewData[1] + '&ip=' + previewData[2] + '&deid=' + previewData[3]
                        + '&rotate_count=' + parseInt(Math.random()*1000) + '&page_url='+ encodeURIComponent(window.location.href)  +'&version=vt4&timestamp=' + Date.now();
                this.previewArr = previewData;
             
                this.jsonp(url, this.previewCallback);
            }else{
                alert('参数错误');
            }
        },
        previewCallback: function (data, index, iterator, self) {
            if(!data.ad){
                alert('没有预览数据');
            }else{
                self.previewData = data.ad[0];
            }
        },
        insertPreview: function (scriptId, pdps, cb) {
            if(this.previewData){
                try{
                    pdps.innerHTML = this.jsTemplate(scriptId, this.previewData);
                    cb && cb();
                }catch(e){
                    this.callback('error', e);
                }
            }else{
                var self = this;
                var timer = setTimeout(function () {
                    self.insertPreview(scriptId, pdps, cb);
                }, 500);
            }
        },
        creatPvElement: function () {
            var id = "sax_pv_count";
            if(!document.getElementById(id)){
                this.pvBox = this.creatElement("div", {id: id, style: 'display:none'});
                document.body.appendChild(this.pvBox);
            }
            else{
                this.pvBox = document.getElementById(id);
            }
        },
        getClass: function (value) {
            return document.getElementsByClassName(value);
        },
        getValidClass: function (dom) {
            var i = 0,
                len = dom.length,
                nodeArr = [];
            for (; i < len; i++) {
                if (dom[i].getAttribute('loaded') !== 'loaded' && dom[i].getAttribute('data-id') && dom[i].getAttribute('sax-type')) {
                    dom[i].setAttribute('loaded','loaded');
                    nodeArr.push(dom[i]);
                    
              
                }
            }
            return nodeArr;
        },
        
        getCookie :function (ckName) {
            if (undefined == ckName || "" == ckName) {
                return "";
            }
            return this.stringSplice(document.cookie, ckName, ";", "");
        },
        stringSplice : function (src, k, e, sp) {
            if (src == "") { return ""; }
            sp = (sp == "") ? "=" : sp;
            k += sp;
            var ps = src.indexOf(k);
            if (ps < 0) {
                return "";
            }
            ps += k.length;
            var pe = src.indexOf(e, ps);
            if (pe < ps) {
                pe = src.length;
            }
            return src.substring(ps, pe);
        },
        // 鍐� Cookie
        setCookie : function (key, value, expires, path, domain, m) {
            var s = [];
            s.push(key + "=" + escape(value));
            if (expires) {
                var t = new Date();
                var p = t.getTime() + expires * 3600000;
                t.setTime(p);
                s.push("expires=" + t.toGMTString())
            }
            if (path) {
                s.push("path=" + path)
            }
            if (domain) {
                s.push("domain=" + domain)
            }
            if (m) {
                s.push(m)
            }
            document.cookie = s.join(";")
        },
        getRate : function(dom){
            
            if(dom.dataset.rate){
                if(this.getCookie(dom.dataset.id)){
                    return false;
                }
                else{
                    
                    return true;
                }
            }
            else{
                return true;
            }
        },
        setRate : function(dom){
            if(dom.dataset.rate){
                this.setCookie(dom.dataset.id,1,(dom.dataset.rate-0)*24); 
            }
        },
        getPdpsArr: function (nodeArr) {
            var pdpsStr = [];
            for(var i= 0, len= nodeArr.length; i< len; i++){
                pdpsStr.push(nodeArr[i].getAttribute('data-id'));
            }
            return pdpsStr.join(',');
        },
        ajaxHandle: function (iterator) {
            for(var i= 0, len= this.sax.length; i< len; i++) {
                if(this.sax[i].pdpsStr[iterator]){
                    var url = this.sax[i].url + '?' + 'adunit_id=' + this.sax[i].pdpsStr[iterator] + '&page_url=' + encodeURIComponent(window.location.href) + '&timestamp=' + Date.now();
                    url += this.sax[i].urlFix();
                    this.setRotateCount(url);
                    this.jsonp(url, this.callbackHandle, i, iterator,this.completeHandle,5000,this.timeoutFunHandle,this.sax[i].pdpsStr[iterator]);
                }
            }
        },
        getSaxType: (function () {
            var count = 0,
                foo = function () {
                var script = document.getElementsByTagName('script'),
                    i = 0,
                    len = script.length;
                for(; i< len; i++){
                    var saxType = script[i].getAttribute('sax-type');
                    if(saxType && !this.saxType.hasOwnProperty(saxType)){
                        var id = 'sax_template_' + count++;
                        script[i].id = id;
                        this.saxType[saxType] = id;
                    }
                }
            }
            return foo
        }()),
        completeHandle:function(){
            sinaSax.callback("completeFunc");
        },
        timeoutFunHandle:function(pdps){  
            sinaSax.callback("timeoutFunc",[pdps]);
        },
        callbackHandle: function (data, index, iterator, self) {
            var thisArr = self.sax[index].pdpsStr[iterator].split(','),
                dataArr = [];
            data = self.formatData(data, index, "data");
            self.sax[index]['pdpsArr'][iterator] = thisArr;
            for(var i= 0, len= data.length; i< len; i++){
                (function(i){
                    var pdpsIndex = thisArr.indexOf(data[i][self.sax[index]['id']]), //索引
                        scriptId = self.getTemplateScriptId(index, iterator, pdpsIndex),
                        pdpsDom = self.sax[index].pdpsNodes[iterator][pdpsIndex];
                   
                    if(scriptId){
                        try{
                            if(window.location.href.indexOf('wm=3206')!=-1){
                                return;//更新百度热词的渠道广告展示
                            }
                            if(self.previewArr && self.previewArr[0] === pdpsDom.getAttribute('data-id')){
                                self.insertPreview(scriptId, pdpsDom, function(){
                                    self.callback("insertSucc", [pdpsDom]);
                                });
                                self.previewArr= [];
                            }else{
                                if(prtl == 'https://' ){
                                    if(!self.isAllHttpsData(data[i],index)){
                                        
                                        return;
                                    }
                                    
                                }
                                
                                pdpsDom.innerHTML = self.jsTemplate(scriptId, data[i]);
                                dataArr.push(pdpsIndex);
                                self.sendPv(data[i], index);
                                if(self.getRate(pdpsDom)){
                                   self.callback("insertSucc", [pdpsDom]);
                                   console.log('wap成功插入');
                                   self.setRate(pdpsDom);//设置cookie
                                }
                            }
                            
                        }catch(e){
                            
                            self.callback('error', [e]);
                        }
                    }else{
                        //console.log(data[i]);
                        
                        if(prtl == 'https://' ){
                            if(!self.isAllHttpsData(data[i],index,pdpsDom)){
                                
                                return;
                            }
                            
                        }
                        dataArr.push(pdpsIndex);
                        if(self.getRate(pdpsDom)){
                            self.callback("proxy", [pdpsDom, data[i]]);
                            console.log('native成功插入');
                            self.setRate(pdpsDom);//设置cookie
                        }
                        self.sendPv(data[i], index);
                        
                    }
                    self.deeplink(data[i],pdpsDom);
                })(i);
            }
            for(var j= 0, jlen= thisArr.length; j< jlen; j++){
                if(dataArr.indexOf(j) === -1){
                    self.callback("nullData", [self.sax[index]['pdpsNodes'][iterator][j]]);
                }
            }
            //self.clearNoneDataPdpsLock(index, iterator);
        },
        clearNoneDataPdpsLock: function (index, iterator) {
            var pdpsNodes = this.sax[index]['pdpsNodes'][iterator];
            for(var i= 0, len = pdpsNodes.length; i< len; i++){
                if(!pdpsNodes[i].innerHTML && this.isBlank(pdpsNodes[i].innerHTML)){
                    pdpsNodes[i].removeAttribute('loaded');
                }
            }
        },
        listener: {},
        bind: function (event, func) {
            if(!this.listener.hasOwnProperty(event)){
                this.listener[event] = [];
            }
            this.listener[event].push(func);
        },
        callback: function (event, args) {
            if(!this.listener.hasOwnProperty(event)) return;
            for(var i= 0, len= this.listener[event].length; i< len; i++){
                this.listener[event][i].apply(this, args);
            }
        },
        deeplink:function(data,pdpsDom){
            //判断deeplink                
                if(typeof data.content != "undefined" ){                    
                    if( data.content.length >0){
                        var data_centent = data.content;
                        var data_undefined = null;
                        var pdps_a = pdpsDom.children[0];
                        for(var d = 0,dLen = data_centent.length; d<=dLen;d++){
                            (function(d){
                                if(typeof data_centent[d] == "undefined"){
                                    data_undefined = d;
                                }
                                if( d != data_undefined && typeof data_centent[d].type != "undefined"){ //有的centent下无type字段、有的data未定义
                                    if( data_centent[d].type.indexOf("deeplink") > -1){
                                        var pdps_src = data_centent[d].src;
                                        var pdps_link = data_centent[d].link;
                                        pdps_a.addEventListener('click', function(ev){
                                            ev.preventDefault();
                                            sinaSax.huqiFunc(pdps_src,pdps_link);
                                        }, false);
                                    }
                                }
                            })(d);
                        }
                    }
                }
        },
        huqiFunc:function(src,link){
            var loaded_src = null;
            for(var i=0,len = src.length;i<=len;i++){
                if(typeof src[i] !="undefined" && src[i].indexOf("sinaweibo")>-1){
                    loaded_src = src[i];
                    location.href = loaded_src;
                }
            }
            setTimeout(function(){
                window.location.href = link;
            },3000);
        },
        sendPv: function (data, index) {
            var data = this.formatData(data, index, "pv"),
                i = 0,
                len = data.length;
            for(; i< len; i++){
                var pv = data[i];
                if(pv && !this.isBlank(pv)){
                    var img = this.creatElement("img", {src: pv});
                    this.pvBox.appendChild(img);
                }
            }
        },
        isBlank: function (str) {
            return /^\s*$/.test(str)
        },
        formatData: function (data, index, key) {
            if(this.sax[index][key]){
                var treeArr = this.sax[index][key].split('-'),
                    i = 0,
                    len = treeArr.length;
                for(; i< len; i++){
                    data = data[treeArr[i]];
                }
            }
            return data;
        },
        getTemplateScriptId: function (index, iterator, pdpsIndex) {
            var pdpsEl = this.sax[index].pdpsNodes[iterator][pdpsIndex];
            return this.saxType[pdpsEl.getAttribute('sax-type')]
        },
        creatElement: function (tag, option) {
            var el = document.createElement(tag);
            for (var i in option) {
                el.setAttribute(i, option[i]);
            }
            return el;
        },
        setRotateCount:function(url){
            var arr = url.split('&');
            var rotate_count = arr[arr.length-1].split('=');
            var rotate_count_int = parseInt(rotate_count[1]);
            if(url.indexOf('sax.sina.cn/wap')>-1){
                sinaSax.storage.setMode('sax_wap',rotate_count_int+1);
            }
            else if(url.indexOf('sax.sina.cn/native')>-1){
                sinaSax.storage.setMode('sax_native',rotate_count_int+1);
            }
        },
        storage: {
            setMode:function(key,val){
                try{
                    this.set('check',1);
                    this.set(key,val);
                }
                catch(e){}
            },
            getMode:function(key){
                try{
                    this.set('check',1);
                    return this.get(key);
                }
                catch(e){}
            },
            set: function(key, value) {
                sessionStorage.setItem(key, parseInt(value));
            },
            get: function(key) {
                return parseInt(sessionStorage.getItem(key));
            }
        },
        jsonp: (function () {
            var count = 0,
                foo = function (url, func, index, iterator, comple,time,timeoutFun,pdps) { //index 为sax索引，iterator为当前请求次数的pdpsNodes索引
                    var countScript = count,
                        callback = "sax_jsonpCallback_" + count++,
                        url = url + (url.indexOf('?') + 1 ? '&' : '?') + 'callback=' + callback,
                        s = this.creatElement("script", {"src": url, "id": "sax_script_jsonp_" + countScript}),
                        self = this,
                        timmer;
                    window[callback] = function (data) {
                        clearTimeout(timmer);
                        func(data, index, iterator, self);
                        comple && comple();
                        document.getElementById("sax_script_jsonp_" + countScript).remove();
                        window[callback] = null;
                        
                    }
                    if(typeof time !="undefined"){
                        timmer = setTimeout(function(){
                            comple && comple();
                            timeoutFun && timeoutFun(pdps);
                            document.getElementById("sax_script_jsonp_" + countScript).remove();
                            window[callback] = null;
                        },time);
                    }
                    document.body.appendChild(s);
                }
            return foo;
        }()),
        jsTemplate: (function(){
            var cache = {},
                foo = function tmpl(str, data){
                    var fn = !/\W/.test(str) ?
                        cache[str] = cache[str] ||
                            tmpl(document.getElementById(str).innerHTML) :
                        new Function("obj",
                            "var p=[],print=function(){p.push.apply(p,arguments);};" +
                            "with(obj){p.push('" +
                            str
                                .replace(/[\r\t\n]/g, " ")
                                .split("<%").join("\t")
                                .replace(/((^|%>)[^\t]*)'/g, "$1\r")
                                .replace(/\t(.*?)%>/g, "',$1,'")
                                .split("\t").join("');")
                                .split("%>").join("p.push('")
                                .split("\r").join("\\'")
                            + "');}return p.join('');");
                    return data ? fn( data ) : fn;
                };
            return foo
        })(),        
        _getUAInfo:function(){//拆分字段
            var browserObj  = {
                appName : navigator.appName,
                appVersion : navigator.appVersion,
                platform : navigator.platform,
                ua : (navigator.userAgent).toLowerCase()
            }            
            //console.log(browserObj.appName+" %%%%%"+browserObj.appVersion+'%%%%'+browserObj.platform+"%%%%"+browserObj.ua);
            return browserObj;
        },
        saxlog:function (json) {//反屏蔽日志
            json.data = json.data || {};        
            
            var arr = [];
            for (var i in json.data) {
                arr.push(i + '=' + encodeURIComponent(json.data[i]));
            }
            var sData =  arr.join('&');
            var oS = document.createElement('img');
            if(json.url.indexOf('?') == -1){
                json.url +="?"
            }
            oS.src = json.url + sData;
            var oHead = document.getElementsByTagName('head')[0];
            oHead.appendChild(oS);
            
        },
        reloadPdps:function(arr){
            var i=0,
                len = this.sax.length,
                pdpsArrs = [],
                targerNode = [];
            for(;i<len;i++){
                pdpsArrs[i] = this.getClass(this.sax[i].class);
                targerNode = this.searchPdpsNodes(pdpsArrs[i],arr);
                if(typeof targerNode !== "undefined"){
                    targerNode.removeAttribute("loaded");
                    sinaSax.init();
                    return;
                }
            }
        },
        searchPdpsNodes:function(pdpsArrs,arr){
            var i=0,
                len = pdpsArrs.length;
            for(; i < len; i++){
                if(pdpsArrs[i].getAttribute("data-id") == arr){
                    return pdpsArrs[i];
                }
            }
        },
        isAllHttpsData:function(data, index ,pdpsDom){
            //两个接口的展示pv曝光数据的过滤
                if(this.pvHttpsData(data, index)){
                    
                }else{
                    console.log('pvHttpsDataError', data);
                    return false ;
                }
            //两个接口的img src 数据的过滤
                if(this.imagesHttpsData(data, index)){
                    
                }else{
                    console.log('imagesHttpsDataError', data);
                    return false ;
                }
            //两个接口的点击曝光的 数据的过滤
                if(data['play'] || data['namonitor'] ){
                    if(this.playHttpsData(data, index)){
                    }else{
                        console.log('playHttpsDataError', data);
                        return false ;
                    }
                }else{
                    
                }
            //视频的 数据的过滤 在feedpush.js
            //第三方检测数据过滤在feedpush.js
            
            return true;
        },
        pvHttpsData:function(data, index){
            var data = this.formatData(data, index, "pv"),
                i = 0,
                len = data.length;
            for(; i< len; i++){
                var pv = data[i];
                if(pv && !this.isBlank(pv)){
                    if(pv.indexOf(prtl) > -1 ){
                        
                    }else{
                        return false;
                    }
                }
                
            }
            return true;
        },
        imagesHttpsData:function(data, index){
            
            if((index == 0 || index == '0' ) && data['content'] !== undefined && data['content'].length > 0){   //wap接口
                var _content = data.content[0];
                switch (data.type){
                case 'qp':    //只有全屏图片数据在src[1]
                    
                    if(_content.src[1].indexOf(prtl) === -1){
                        //console.log('contentSrcError', data);
                        return  false;
                    }
                    else{
                        
                        break;
                    }
                    
                default: //其他图片数据在src[0]
                    
                    if( _content.src[0].indexOf(prtl) === -1){
                        //console.log('contentSrcError', data);
                        return  false;
                    }else{
                        
                        break;
                    }
                   
                }
            }
            else{
                if(data['images']){
                    var _images = data['images'],
                        i = 0,
                        len = _images.length;
                    for(; i< len; i++){
                        var imgSrc = _images[i]['u'];
                        if(imgSrc && !this.isBlank(imgSrc)){
                            if(imgSrc.indexOf(prtl) > -1 ){
                                
                            }else{
                                return false;
                            }
                        }
                    }
                }
                if(data['img'] && !this.isBlank(data['img'])){
                    //console.log('img');
                    if(data['img']['u'].indexOf(prtl) > -1 ){
                        
                    }else{
                        
                        return false;
                    }
                }
            }
            return  true;
        },
        playHttpsData:function(data, index){//有错误数据
            //console.log('index: '+index);
            if(index === '1' || index === 1){
                if(data['play']){
                    var play = data['play'],
                        i = 0,
                        len = play.length;
                    for(; i< len; i++){
                        var playSrc = play[i];
                        
                        if(playSrc && !this.isBlank(playSrc)){
                            if( playSrc.indexOf(prtl) > -1 ){
                                
                                return true;
                            }else{
                                return false;
                            }
                        }
                    }
                }else if(data['namonitor']['tel']){
                    var telsrc = data['namonitor']['tel'];
                    if( telsrc.indexOf(prtl) > -1 ){
                                
                        return true;
                    }else{
                        return false;
                    }
                }
                return false;
            }
        }
        /*,
        videoHttpsData:function(data,index,pdpsDom){
            if(index === '1' || index === 1){
                if(data['vid']){
                    //this.callback('videoHttpsListenor',[pdpsDom,data]);
                    var ajaxUrl = prtl+"interface.sina.cn/video/wap/videoinfo.d.json?"+"vid="+data['vid'],
                        videosrc;
                    videosrc = this.jsonp(ajaxUrl, this.videoCallback);
                    console.log(data);
                }
            }
        },
        videoCallback:function(data){
            var videosrc;
            if(!data.data.baseUrl){
            }else{
                
                //videoUrl = data.data['baseUrl'];
                console.log('baseUrl',data.data['baseUrl']);
                videosrc = data.data['baseUrl'];
                return videosrc;
            }
        }*/
    }
    return sinaSax;
}());
setTimeout(function(){  //解决焦点图偶现插入失败问题。
    sinaSax.init();
},100);
sinaSax.bind('timeoutFunc', function (pdps) {
    var browserObj = sinaSax._getUAInfo();
    var prtl = 'https:' == window.location.protocol ? 'https://': 'http://';
    sinaSax.saxlog({
        url:prtl+"d00.sina.com.cn/a.gif",
        data:{
            type:"tp_timeout",
            pos:pdps,
            ua:browserObj.ua,
            /*brow:browserObj.appName,
            ver:browserObj.appVersion,
            plat:browserObj.platform,*/
            ref:window.location.href
        }
    });
});
(function(){
    var prtl = 'https:' == window.location.protocol ? 'https://': 'http://';
    setTimeout(function(){
        block(document.querySelectorAll('.j_sax'));
        block(document.querySelectorAll('.j_native'));
        function block(arr){
            for(var i=0; i<arr.length; i++){
                if(typeof arr[i].children[0] !== "undefined"){
                    var style = document.defaultView.getComputedStyle(arr[i], null); 
                    if(style.display=='none'){
                        var browserObj = sinaSax._getUAInfo();
                        //console.log("被隐藏的广告是"+arr[i].getAttribute("data-id"));
                        sinaSax.saxlog({
                            url:prtl+"d00.sina.com.cn/a.gif",
                            data:{
                                type:"tp_hidden",
                                pos:arr[i].getAttribute("data-id"),
                                ua:browserObj.ua,
                                /*brow:browserObj.appName,
                                ver:browserObj.appVersion,
                                plat:browserObj.platform,*/
                                ref:window.location.href
                            }
                        });
                    }
                }
            }
        }
    },500);
})();
var sinaSax = (function () {
    "use strict";
    var prtl = 'https:' == window.location.protocol ? 'https://': 'http://';
    var sinaSax = {
        saxType: {},//存储模板类型
        
        //id为数据源pdps的key; data为返回数据集的直接父级，多层嵌套用'-'分割,pv同理; urlFix为发送jsonp请求是额外字段
        sax: [{class: 'j_sax', url: prtl + 'sax.sina.cn/wap/impress', id: 'id', pv: 'content-0-pv', data: 'ad', urlFix: function(){ return "&rotate_count=" + (parseInt((isNaN(sinaSax.storage.getMode('sax_wap'))) ? (Math.random() * 1000): (sinaSax.storage.get('sax_wap'))))}},
            {class: 'j_native', url: prtl + 'sax.sina.cn/native/impress', id: 'pdps', pv: 'pvmonitor',urlFix: function(){ return "&rotate_count=" + (parseInt((isNaN(sinaSax.storage.getMode('sax_native'))) ? (Math.random() * 1000): (sinaSax.storage.get('sax_native'))))}}],
        previewed : false,
        init: function () {
            //console.log(prtl);
            var iterator,
                i = 0,
                len = this.sax.length;
            for(; i< len; i++){
                this.sax[i].pdpsArr = [];
                this.sax[i].pdpsNodes = this.sax[i].pdpsNodes || [];
                this.sax[i].pdpsStr = this.sax[i].pdpsStr || [];
                this.sax[i].pdpsNodes.push(this.getValidClass(this.getClass(this.sax[i].class)));
                iterator = this.sax[i].pdpsNodes.length -1;
                this.sax[i].pdpsStr.push(this.getPdpsArr(this.sax[i].pdpsNodes[iterator]));
            }
            this.creatPvElement();
            this.getSaxType();
            this.ajaxHandle(iterator);
            if(location.hash.indexOf('preview') + 1){
                setTimeout(this.preview.call(this),300);               
            }
            
        },
        preview: function () {
            if(this.previewed)return;
            this.previewed=true;
            var previewData = decodeURIComponent(location.hash.substring(1)).split('|');
            previewData[0] = previewData[0].split('=')[1];
            if(previewData[0] && previewData[3]){
                var url = prtl + 'sax.sina.cn/wap/preview?' + 'adunit_id=' + previewData[0] + '&date=' + previewData[1] + '&ip=' + previewData[2] + '&deid=' + previewData[3]
                        + '&rotate_count=' + parseInt(Math.random()*1000) + '&page_url='+ encodeURIComponent(window.location.href)  +'&version=vt4&timestamp=' + Date.now();
                this.previewArr = previewData;
             
                this.jsonp(url, this.previewCallback);
            }else{
                alert('参数错误');
            }
        },
        previewCallback: function (data, index, iterator, self) {
            if(!data.ad){
                alert('没有预览数据');
            }else{
                self.previewData = data.ad[0];
            }
        },
        insertPreview: function (scriptId, pdps, cb) {
            if(this.previewData){
                try{
                    pdps.innerHTML = this.jsTemplate(scriptId, this.previewData);
                    cb && cb();
                }catch(e){
                    this.callback('error', e);
                }
            }else{
                var self = this;
                var timer = setTimeout(function () {
                    self.insertPreview(scriptId, pdps, cb);
                }, 500);
            }
        },
        creatPvElement: function () {
            var id = "sax_pv_count";
            if(!document.getElementById(id)){
                this.pvBox = this.creatElement("div", {id: id, style: 'display:none'});
                document.body.appendChild(this.pvBox);
            }
            else{
                this.pvBox = document.getElementById(id);
            }
        },
        getClass: function (value) {
            return document.getElementsByClassName(value);
        },
        getValidClass: function (dom) {
            var i = 0,
                len = dom.length,
                nodeArr = [];
            for (; i < len; i++) {
                if (dom[i].getAttribute('loaded') !== 'loaded' && dom[i].getAttribute('data-id') && dom[i].getAttribute('sax-type')) {
                    dom[i].setAttribute('loaded','loaded');
                    nodeArr.push(dom[i]);
                    
              
                }
            }
            return nodeArr;
        },
        
        getCookie :function (ckName) {
            if (undefined == ckName || "" == ckName) {
                return "";
            }
            return this.stringSplice(document.cookie, ckName, ";", "");
        },
        stringSplice : function (src, k, e, sp) {
            if (src == "") { return ""; }
            sp = (sp == "") ? "=" : sp;
            k += sp;
            var ps = src.indexOf(k);
            if (ps < 0) {
                return "";
            }
            ps += k.length;
            var pe = src.indexOf(e, ps);
            if (pe < ps) {
                pe = src.length;
            }
            return src.substring(ps, pe);
        },
        // 鍐� Cookie
        setCookie : function (key, value, expires, path, domain, m) {
            var s = [];
            s.push(key + "=" + escape(value));
            if (expires) {
                var t = new Date();
                var p = t.getTime() + expires * 3600000;
                t.setTime(p);
                s.push("expires=" + t.toGMTString())
            }
            if (path) {
                s.push("path=" + path)
            }
            if (domain) {
                s.push("domain=" + domain)
            }
            if (m) {
                s.push(m)
            }
            document.cookie = s.join(";")
        },
        getRate : function(dom){
            
            if(dom.dataset.rate){
                if(this.getCookie(dom.dataset.id)){
                    return false;
                }
                else{
                    
                    return true;
                }
            }
            else{
                return true;
            }
        },
        setRate : function(dom){
            if(dom.dataset.rate){
                this.setCookie(dom.dataset.id,1,(dom.dataset.rate-0)*24); 
            }
        },
        getPdpsArr: function (nodeArr) {
            var pdpsStr = [];
            for(var i= 0, len= nodeArr.length; i< len; i++){
                pdpsStr.push(nodeArr[i].getAttribute('data-id'));
            }
            return pdpsStr.join(',');
        },
        ajaxHandle: function (iterator) {
            for(var i= 0, len= this.sax.length; i< len; i++) {
                if(this.sax[i].pdpsStr[iterator]){
                    var url = this.sax[i].url + '?' + 'adunit_id=' + this.sax[i].pdpsStr[iterator] + '&page_url=' + encodeURIComponent(window.location.href) + '&timestamp=' + Date.now();
                    url += this.sax[i].urlFix();
                    this.setRotateCount(url);
                    this.jsonp(url, this.callbackHandle, i, iterator,this.completeHandle,5000,this.timeoutFunHandle,this.sax[i].pdpsStr[iterator]);
                }
            }
        },
        getSaxType: (function () {
            var count = 0,
                foo = function () {
                var script = document.getElementsByTagName('script'),
                    i = 0,
                    len = script.length;
                for(; i< len; i++){
                    var saxType = script[i].getAttribute('sax-type');
                    if(saxType && !this.saxType.hasOwnProperty(saxType)){
                        var id = 'sax_template_' + count++;
                        script[i].id = id;
                        this.saxType[saxType] = id;
                    }
                }
            }
            return foo
        }()),
        completeHandle:function(){
            sinaSax.callback("completeFunc");
        },
        timeoutFunHandle:function(pdps){  
            sinaSax.callback("timeoutFunc",[pdps]);
        },
        callbackHandle: function (data, index, iterator, self) {
            var thisArr = self.sax[index].pdpsStr[iterator].split(','),
                dataArr = [];
            data = self.formatData(data, index, "data");
            self.sax[index]['pdpsArr'][iterator] = thisArr;
            for(var i= 0, len= data.length; i< len; i++){
                (function(i){
                    var pdpsIndex = thisArr.indexOf(data[i][self.sax[index]['id']]), //索引
                        scriptId = self.getTemplateScriptId(index, iterator, pdpsIndex),
                        pdpsDom = self.sax[index].pdpsNodes[iterator][pdpsIndex];
                   
                    if(scriptId){
                        try{
                            if(window.location.href.indexOf('wm=3206')!=-1){
                                return;//更新百度热词的渠道广告展示
                            }
                            if(self.previewArr && self.previewArr[0] === pdpsDom.getAttribute('data-id')){
                                self.insertPreview(scriptId, pdpsDom, function(){
                                    self.callback("insertSucc", [pdpsDom]);
                                });
                                self.previewArr= [];
                            }else{
                                if(prtl == 'https://' ){
                                    if(!self.isAllHttpsData(data[i],index)){
                                        
                                        return;
                                    }
                                    
                                }
                                
                                pdpsDom.innerHTML = self.jsTemplate(scriptId, data[i]);
                                dataArr.push(pdpsIndex);
                                self.sendPv(data[i], index);
                                if(self.getRate(pdpsDom)){
                                   self.callback("insertSucc", [pdpsDom]);
                                   console.log('wap成功插入');
                                   self.setRate(pdpsDom);//设置cookie
                                }
                            }
                            
                        }catch(e){
                            
                            self.callback('error', [e]);
                        }
                    }else{
                        //console.log(data[i]);
                        
                        if(prtl == 'https://' ){
                            if(!self.isAllHttpsData(data[i],index,pdpsDom)){
                                
                                return;
                            }
                            
                        }
                        dataArr.push(pdpsIndex);
                        if(self.getRate(pdpsDom)){
                            self.callback("proxy", [pdpsDom, data[i]]);
                            console.log('native成功插入');
                            self.setRate(pdpsDom);//设置cookie
                        }
                        self.sendPv(data[i], index);
                        
                    }
                    self.deeplink(data[i],pdpsDom);
                })(i);
            }
            for(var j= 0, jlen= thisArr.length; j< jlen; j++){
                if(dataArr.indexOf(j) === -1){
                    self.callback("nullData", [self.sax[index]['pdpsNodes'][iterator][j]]);
                }
            }
            //self.clearNoneDataPdpsLock(index, iterator);
        },
        clearNoneDataPdpsLock: function (index, iterator) {
            var pdpsNodes = this.sax[index]['pdpsNodes'][iterator];
            for(var i= 0, len = pdpsNodes.length; i< len; i++){
                if(!pdpsNodes[i].innerHTML && this.isBlank(pdpsNodes[i].innerHTML)){
                    pdpsNodes[i].removeAttribute('loaded');
                }
            }
        },
        listener: {},
        bind: function (event, func) {
            if(!this.listener.hasOwnProperty(event)){
                this.listener[event] = [];
            }
            this.listener[event].push(func);
        },
        callback: function (event, args) {
            if(!this.listener.hasOwnProperty(event)) return;
            for(var i= 0, len= this.listener[event].length; i< len; i++){
                this.listener[event][i].apply(this, args);
            }
        },
        deeplink:function(data,pdpsDom){
            //判断deeplink                
                if(typeof data.content != "undefined" ){                    
                    if( data.content.length >0){
                        var data_centent = data.content;
                        var data_undefined = null;
                        var pdps_a = pdpsDom.children[0];
                        for(var d = 0,dLen = data_centent.length; d<=dLen;d++){
                            (function(d){
                                if(typeof data_centent[d] == "undefined"){
                                    data_undefined = d;
                                }
                                if( d != data_undefined && typeof data_centent[d].type != "undefined"){ //有的centent下无type字段、有的data未定义
                                    if( data_centent[d].type.indexOf("deeplink") > -1){
                                        var pdps_src = data_centent[d].src;
                                        var pdps_link = data_centent[d].link;
                                        pdps_a.addEventListener('click', function(ev){
                                            ev.preventDefault();
                                            sinaSax.huqiFunc(pdps_src,pdps_link);
                                        }, false);
                                    }
                                }
                            })(d);
                        }
                    }
                }
        },
        huqiFunc:function(src,link){
            var loaded_src = null;
            for(var i=0,len = src.length;i<=len;i++){
                if(typeof src[i] !="undefined" && src[i].indexOf("sinaweibo")>-1){
                    loaded_src = src[i];
                    location.href = loaded_src;
                }
            }
            setTimeout(function(){
                window.location.href = link;
            },3000);
        },
        sendPv: function (data, index) {
            var data = this.formatData(data, index, "pv"),
                i = 0,
                len = data.length;
            for(; i< len; i++){
                var pv = data[i];
                if(pv && !this.isBlank(pv)){
                    var img = this.creatElement("img", {src: pv});
                    this.pvBox.appendChild(img);
                }
            }
        },
        isBlank: function (str) {
            return /^\s*$/.test(str)
        },
        formatData: function (data, index, key) {
            if(this.sax[index][key]){
                var treeArr = this.sax[index][key].split('-'),
                    i = 0,
                    len = treeArr.length;
                for(; i< len; i++){
                    data = data[treeArr[i]];
                }
            }
            return data;
        },
        getTemplateScriptId: function (index, iterator, pdpsIndex) {
            var pdpsEl = this.sax[index].pdpsNodes[iterator][pdpsIndex];
            return this.saxType[pdpsEl.getAttribute('sax-type')]
        },
        creatElement: function (tag, option) {
            var el = document.createElement(tag);
            for (var i in option) {
                el.setAttribute(i, option[i]);
            }
            return el;
        },
        setRotateCount:function(url){
            var arr = url.split('&');
            var rotate_count = arr[arr.length-1].split('=');
            var rotate_count_int = parseInt(rotate_count[1]);
            if(url.indexOf('sax.sina.cn/wap')>-1){
                sinaSax.storage.setMode('sax_wap',rotate_count_int+1);
            }
            else if(url.indexOf('sax.sina.cn/native')>-1){
                sinaSax.storage.setMode('sax_native',rotate_count_int+1);
            }
        },
        storage: {
            setMode:function(key,val){
                try{
                    this.set('check',1);
                    this.set(key,val);
                }
                catch(e){}
            },
            getMode:function(key){
                try{
                    this.set('check',1);
                    return this.get(key);
                }
                catch(e){}
            },
            set: function(key, value) {
                sessionStorage.setItem(key, parseInt(value));
            },
            get: function(key) {
                return parseInt(sessionStorage.getItem(key));
            }
        },
        jsonp: (function () {
            var count = 0,
                foo = function (url, func, index, iterator, comple,time,timeoutFun,pdps) { //index 为sax索引，iterator为当前请求次数的pdpsNodes索引
                    var countScript = count,
                        callback = "sax_jsonpCallback_" + count++,
                        url = url + (url.indexOf('?') + 1 ? '&' : '?') + 'callback=' + callback,
                        s = this.creatElement("script", {"src": url, "id": "sax_script_jsonp_" + countScript}),
                        self = this,
                        timmer;
                    window[callback] = function (data) {
                        clearTimeout(timmer);
                        func(data, index, iterator, self);
                        comple && comple();
                        document.getElementById("sax_script_jsonp_" + countScript).remove();
                        window[callback] = null;
                        
                    }
                    if(typeof time !="undefined"){
                        timmer = setTimeout(function(){
                            comple && comple();
                            timeoutFun && timeoutFun(pdps);
                            document.getElementById("sax_script_jsonp_" + countScript).remove();
                            window[callback] = null;
                        },time);
                    }
                    document.body.appendChild(s);
                }
            return foo;
        }()),
        jsTemplate: (function(){
            var cache = {},
                foo = function tmpl(str, data){
                    var fn = !/\W/.test(str) ?
                        cache[str] = cache[str] ||
                            tmpl(document.getElementById(str).innerHTML) :
                        new Function("obj",
                            "var p=[],print=function(){p.push.apply(p,arguments);};" +
                            "with(obj){p.push('" +
                            str
                                .replace(/[\r\t\n]/g, " ")
                                .split("<%").join("\t")
                                .replace(/((^|%>)[^\t]*)'/g, "$1\r")
                                .replace(/\t(.*?)%>/g, "',$1,'")
                                .split("\t").join("');")
                                .split("%>").join("p.push('")
                                .split("\r").join("\\'")
                            + "');}return p.join('');");
                    return data ? fn( data ) : fn;
                };
            return foo
        })(),        
        _getUAInfo:function(){//拆分字段
            var browserObj  = {
                appName : navigator.appName,
                appVersion : navigator.appVersion,
                platform : navigator.platform,
                ua : (navigator.userAgent).toLowerCase()
            }            
            //console.log(browserObj.appName+" %%%%%"+browserObj.appVersion+'%%%%'+browserObj.platform+"%%%%"+browserObj.ua);
            return browserObj;
        },
        saxlog:function (json) {//反屏蔽日志
            json.data = json.data || {};        
            
            var arr = [];
            for (var i in json.data) {
                arr.push(i + '=' + encodeURIComponent(json.data[i]));
            }
            var sData =  arr.join('&');
            var oS = document.createElement('img');
            if(json.url.indexOf('?') == -1){
                json.url +="?"
            }
            oS.src = json.url + sData;
            var oHead = document.getElementsByTagName('head')[0];
            oHead.appendChild(oS);
            
        },
        reloadPdps:function(arr){
            var i=0,
                len = this.sax.length,
                pdpsArrs = [],
                targerNode = [];
            for(;i<len;i++){
                pdpsArrs[i] = this.getClass(this.sax[i].class);
                targerNode = this.searchPdpsNodes(pdpsArrs[i],arr);
                if(typeof targerNode !== "undefined"){
                    targerNode.removeAttribute("loaded");
                    sinaSax.init();
                    return;
                }
            }
        },
        searchPdpsNodes:function(pdpsArrs,arr){
            var i=0,
                len = pdpsArrs.length;
            for(; i < len; i++){
                if(pdpsArrs[i].getAttribute("data-id") == arr){
                    return pdpsArrs[i];
                }
            }
        },
        isAllHttpsData:function(data, index ,pdpsDom){
            //两个接口的展示pv曝光数据的过滤
                if(this.pvHttpsData(data, index)){
                    
                }else{
                    console.log('pvHttpsDataError', data);
                    return false ;
                }
            //两个接口的img src 数据的过滤
                if(this.imagesHttpsData(data, index)){
                    
                }else{
                    console.log('imagesHttpsDataError', data);
                    return false ;
                }
            //两个接口的点击曝光的 数据的过滤
                if(data['play'] || data['namonitor'] ){
                    if(this.playHttpsData(data, index)){
                    }else{
                        console.log('playHttpsDataError', data);
                        return false ;
                    }
                }else{
                    
                }
            //视频的 数据的过滤 在feedpush.js
            //第三方检测数据过滤在feedpush.js
            
            return true;
        },
        pvHttpsData:function(data, index){
            var data = this.formatData(data, index, "pv"),
                i = 0,
                len = data.length;
            for(; i< len; i++){
                var pv = data[i];
                if(pv && !this.isBlank(pv)){
                    if(pv.indexOf(prtl) > -1 ){
                        
                    }else{
                        return false;
                    }
                }
                
            }
            return true;
        },
        imagesHttpsData:function(data, index){
            
            if((index == 0 || index == '0' ) && data['content'] !== undefined && data['content'].length > 0){   //wap接口
                var _content = data.content[0];
                switch (data.type){
                case 'qp':    //只有全屏图片数据在src[1]
                    
                    if(_content.src[1].indexOf(prtl) === -1){
                        //console.log('contentSrcError', data);
                        return  false;
                    }
                    else{
                        
                        break;
                    }
                    
                default: //其他图片数据在src[0]
                    
                    if( _content.src[0].indexOf(prtl) === -1){
                        //console.log('contentSrcError', data);
                        return  false;
                    }else{
                        
                        break;
                    }
                   
                }
            }
            else{
                if(data['images']){
                    var _images = data['images'],
                        i = 0,
                        len = _images.length;
                    for(; i< len; i++){
                        var imgSrc = _images[i]['u'];
                        if(imgSrc && !this.isBlank(imgSrc)){
                            if(imgSrc.indexOf(prtl) > -1 ){
                                
                            }else{
                                return false;
                            }
                        }
                    }
                }
                if(data['img'] && !this.isBlank(data['img'])){
                    //console.log('img');
                    if(data['img']['u'].indexOf(prtl) > -1 ){
                        
                    }else{
                        
                        return false;
                    }
                }
            }
            return  true;
        },
        playHttpsData:function(data, index){//有错误数据
            //console.log('index: '+index);
            if(index === '1' || index === 1){
                if(data['play']){
                    var play = data['play'],
                        i = 0,
                        len = play.length;
                    for(; i< len; i++){
                        var playSrc = play[i];
                        
                        if(playSrc && !this.isBlank(playSrc)){
                            if( playSrc.indexOf(prtl) > -1 ){
                                
                                return true;
                            }else{
                                return false;
                            }
                        }
                    }
                }else if(data['namonitor']['tel']){
                    var telsrc = data['namonitor']['tel'];
                    if( telsrc.indexOf(prtl) > -1 ){
                                
                        return true;
                    }else{
                        return false;
                    }
                }
                return false;
            }
        }
        /*,
        videoHttpsData:function(data,index,pdpsDom){
            if(index === '1' || index === 1){
                if(data['vid']){
                    //this.callback('videoHttpsListenor',[pdpsDom,data]);
                    var ajaxUrl = prtl+"interface.sina.cn/video/wap/videoinfo.d.json?"+"vid="+data['vid'],
                        videosrc;
                    videosrc = this.jsonp(ajaxUrl, this.videoCallback);
                    console.log(data);
                }
            }
        },
        videoCallback:function(data){
            var videosrc;
            if(!data.data.baseUrl){
            }else{
                
                //videoUrl = data.data['baseUrl'];
                console.log('baseUrl',data.data['baseUrl']);
                videosrc = data.data['baseUrl'];
                return videosrc;
            }
        }*/
    }
    return sinaSax;
}());
setTimeout(function(){  //解决焦点图偶现插入失败问题。
    sinaSax.init();
},100);
sinaSax.bind('timeoutFunc', function (pdps) {
    var browserObj = sinaSax._getUAInfo();
    var prtl = 'https:' == window.location.protocol ? 'https://': 'http://';
    sinaSax.saxlog({
        url:prtl+"d00.sina.com.cn/a.gif",
        data:{
            type:"tp_timeout",
            pos:pdps,
            ua:browserObj.ua,
            /*brow:browserObj.appName,
            ver:browserObj.appVersion,
            plat:browserObj.platform,*/
            ref:window.location.href
        }
    });
});
(function(){
    var prtl = 'https:' == window.location.protocol ? 'https://': 'http://';
    setTimeout(function(){
        block(document.querySelectorAll('.j_sax'));
        block(document.querySelectorAll('.j_native'));
        function block(arr){
            for(var i=0; i<arr.length; i++){
                if(typeof arr[i].children[0] !== "undefined"){
                    var style = document.defaultView.getComputedStyle(arr[i], null); 
                    if(style.display=='none'){
                        var browserObj = sinaSax._getUAInfo();
                        //console.log("被隐藏的广告是"+arr[i].getAttribute("data-id"));
                        sinaSax.saxlog({
                            url:prtl+"d00.sina.com.cn/a.gif",
                            data:{
                                type:"tp_hidden",
                                pos:arr[i].getAttribute("data-id"),
                                ua:browserObj.ua,
                                /*brow:browserObj.appName,
                                ver:browserObj.appVersion,
                                plat:browserObj.platform,*/
                                ref:window.location.href
                            }
                        });
                    }
                }
            }
        }
    },500);
})();
}catch(e){throw new Error(e+" http://mjs.sinaimg.cn/wap/module/sina_sax/201605231200/js/sina_sax.js");}

try{	
	/**
 * [feedPush description]频道首页，栏目页，专题，高清图等广告插入
 * @type {Object}
 */
//频道feed植入广告
	window["channelPushs"] = [
		{
			caIndex : 7,
			domHTML : '<div sax-type="proxy" class="j_native" data-id="FEA0E6FFB154"></div>',
		}
	];
    
(function(window,document) {
    var mode = false,
        isLongTitle = false;
    
    /*var lazyLoadImgConfig ={
        lz1X1:'http://mjs.sinaimg.cn/wap/online/home/v7/images/lz1X1.jpg',
        lz2X1:'http://mjs.sinaimg.cn/wap/online/home/v7/images/lz2X1.jpg',
        lz4X3:'http://mjs.sinaimg.cn/wap/online/home/v7/images/lz4X3.jpg',
        lz148X125:'http://mjs.sinaimg.cn/wap/online/home/v7/images/lz148X125.jpg'
    };*/
    var isUC = false,
        isQQ = false,
        is360 = false,
        isBaidu = false;
    var feedPush = {
        dataLength: 0,
        count: 0,
        ready: false,//记录猜你喜欢是否加载完成
        likeCount: 0,
        ZTcount : 1,
        init: function () {
           
           
            if (window["channelPushs"] && window["channelPushs"].length > 0){
                this.channelPushs = window["channelPushs"];
                this.dataLength = window["channelPushs"].length;
                this.push();
            }
            
            if(window["guessLike"]){
                this.initEvent();
            }
            this.bindEvent();
            
            
        },
        bindEvent:function(){
            
        },
        
        initEvent: function () {
            var self = this;
            guessLike.bind("insertSucc", function (index) {
                self.likeIndex = index;
                self.ready = true;
            })
        },
        dataHandle: function () {
            var $sax_dom_storage_childrens = $('#sax_dom_storage').children();
            for(var i= 0, len= this.dataLength; i< len; i++){
                var items_list = $(".feed_card").not(".hide").not(".j_native");
                var pic_item_list = $(".pic_item").not(".j_native");//兼容新版图片首页
                if($sax_dom_storage_childrens.eq(i).html()){
                    var pushIndex = this.channelPushs[i]['caIndex'];
                    if(pushIndex <= this.likeIndex){
                        this.likeIndex++;
                        if(!$sax_dom_storage_childrens.eq(i).attr('pushed') && items_list.eq(pushIndex -2)[0]){
                            items_list.eq(pushIndex -2).after($sax_dom_storage_childrens.eq(i)[0].cloneNode(true));
                            $sax_dom_storage_childrens.eq(i).attr('pushed',1);
                        }
                    }
                    else if(typeof pic_item_list !== "undefined" && pic_item_list.length > 0){//新版图片首页
                        var sax_pushed_len = $('#sax_dom_storage').children('[pushed="1"]').length; //已插入广告节点的个数
                        if(!$sax_dom_storage_childrens.eq(i).attr('pushed') && pic_item_list.eq(pushIndex -2)[0]){
                            pic_item_list.eq(pushIndex -2 -sax_pushed_len).after($sax_dom_storage_childrens.eq(i)[0].cloneNode(true));
                            $sax_dom_storage_childrens.eq(i).attr('pushed',1);
                        }
                    }
                    else if(pushIndex > this.likeIndex && pushIndex < this.likeIndex+3){
                  
                        like.fixSaxPush($sax_dom_storage_childrens.eq(i)[0].cloneNode(true), pushIndex - this.likeIndex);
                      
                    }
                    else{
                        
                        //解决猜你喜欢的问题，猜你喜欢固定3条，不可以后天增加
                        if(pushIndex === pushIndex,this.likeIndex +3){
                            if(!$sax_dom_storage_childrens.eq(i).attr('pushed') && items_list.eq(pushIndex -1)[0]){
                                items_list.eq(pushIndex -1).before($sax_dom_storage_childrens.eq(i)[0].cloneNode(true));
                                 $sax_dom_storage_childrens.eq(i).attr('pushed',1);
                            }                            
                        }else{
                            if(!$sax_dom_storage_childrens.eq(i).attr('pushed') && items_list.eq(pushIndex -2)[0]){
                                var sax_pushed_len = $('#sax_dom_storage').children('[pushed="1"]').length; //已插入广告节点的个数
                                if($sax_dom_storage_childrens.eq(i).data('id') === 'PDPS000000056289'){
                                    var tarEle = $(".j_navfixable").eq(1)[0].parentNode;
                                    tarEle.appendChild($sax_dom_storage_childrens.eq(i)[0].cloneNode(true));                                      
                                    var $tarEleAd = $(tarEle).children().last();
                                    $tarEleAd.css({"background-color": "#fff","margin-bottom": "8px"});
                                    $tarEleAd.find(".f_card").addClass("j_last");
                                    $sax_dom_storage_childrens.eq(i).attr('pushed',1);
                                    continue;
                                }
                                items_list.eq(pushIndex -2 -sax_pushed_len).after($sax_dom_storage_childrens.eq(i)[0].cloneNode(true));
                                this.checkBoxLast($sax_dom_storage_childrens.eq(i));
                                $sax_dom_storage_childrens.eq(i).attr('pushed',1);
                            }                            
                        }
                    }
                }
            }
          
            if($("#sax_dom_storage").children().eq(this.dataLength-1).attr('pushed')){
                $("#sax_dom_storage").remove();
            }
            if(typeof sinaCnHome !== "undefined"){
                sinaCnHome.S.trigger('feedpush.loaded');
            }
            
        },
        push: function () {
            var str = '',
                i = 0,
                len = this.channelPushs.length,
                divPiece = document.createElement('div');
            divPiece.id = 'sax_dom_storage';
            for( ; i< len; i++){
                str += this.channelPushs[i]['domHTML'];
            }
            divPiece.innerHTML = str;
            
            document.body.appendChild(divPiece);
            $('#sax_dom_storage').hide();
            sinaSax.init();
           
        },
        check: function () {
            this.count++;
            if(this.dataLength === this.count){
                this.checkLike();
            }
        },
        checkLike: function () {
            var self = this;
            if(self.likeCount++ >= 10 || self.ready){               
                    self.dataHandle();
                
            }else{
                setTimeout(function () {
                    self.checkLike();
                },10);
            }
        },
        checkBoxLast:function($dom){
            var $target = $('[data-id="'+parseInt($dom.data('id'))+'"]');
            if($target.parents('.j_navfixable').children().not('.hide').not('.f_more_tips').last()[0] == $target[0]){
                $target.prev().find('.f_card').removeClass('j_last');
                $target.find('.f_card').addClass('j_last');
            }
        }
    }
    feedPush.init();
    var proxy_column_feed = {
        vid:[],
        getCommStr: function (data) {
            var $comment_total = data['comment_total'];
            var $comm_str = (data['adtype'] == '01' ? ($comment_total == 0 ? '' : $comment_total) : $comment_total);
            return $comm_str == 0 ? '' : $comm_str;
        },
        temp31: function (dom, data) {
            var arr=[];
           
                arr.push('<a href="' + data['url'] + '">');
                arr.push('<dl class="feed_card">');
                arr.push('<dt class="feed_dt"><img src="' + data['img']['u'] + '" alt="' + data['title'] + '"></dt>');
                arr.push('<dd class="feed_dd">');
                arr.push('<h3>' + data['title'] + '</h3>');
                arr.push('<p>' + data['intro'] + '</p>');
                arr.push('<div class="f_card_icon">');
                //arr.push('<span class="op_patronage_tips fr">广告</span>');
                arr.push('</div></dd></dl></a>');
            
            dom.innerHTML = arr.join('');
        }
    
    }
    
    sinaSax.bind('proxy', function (dom, data) {
        switch (parseInt(data['templateid'])) {
            case 31:
                proxy_column_feed.temp31(dom, data);
                break;
            
            default :
                break;
        }
        
        
        feedPush.check();
    })
    sinaSax.bind('nullData', function (dom) {
        feedPush.check();
    })
    
    var mediaFlag = false;
    var topTjCallback = function (dom) {        
        var topTjStorage = storage.get('topTjStorage'),
            now = new Date(),
            media = now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate(),
            imgHeight,
            begin = 0,
            imgBox = $(dom).find('.j_adImgUp'),
            img = new Image(),
            clientWidth=document.documentElement.clientWidth;
        img.onload = function () {            
            imgHeight = clientWidth/320*180;
            if(window.location.href.indexOf('tech')!=-1){ //如果是科技则每次下啦全屏广告
                topTjStorage = -1;             
            } 
            if(media !== topTjStorage){
                mediaFlag = true;
                storage.set('topTjStorage', media);
                $(dom).find('.j_adCloseBtn').css({'-webkit-transform': 'rotate(-45deg)'});               
                var timer = setInterval(function () {
                    if(begin> clientWidth/320*180){
                        clearInterval(timer);
                        setTimeout(function () {
                            $(dom).find('.j_adImgUp').css({'height':'0'})
                            $(dom).find('.j_adCloseBtn').css({'-webkit-transform': 'rotate(135deg)'});
                        },5000);
                    }else{
                        begin +=5;
                        imgBox.css({"height": begin + 'px'});
                    }
                },20)
            }
            
            $(dom).find('.j_adClose').on('click', function () {
                if(imgBox.height()){
                    $(this).find('.j_adCloseBtn').css({'-webkit-transform': 'rotate(135deg)'});
                    imgBox.css({"height":0});
                }else{
                    $(this).find('.j_adCloseBtn').css({'-webkit-transform': 'rotate(-45deg)'});
                    imgBox.css({"height":imgHeight+'px'});
                }
            })
        }
        img.src = $(dom).find('.j_adImgUp').attr('data-img');
        
    }
    
    var insertTl = function(pdps){  //插入垂直轮播banner
        var $tl_wrap = $('.tl_wrap'),
            i=0,
            len = $tl_wrap.children().length,
            imgs = new Array(2);
        for(; i<len ; i++){
            imgs[i] = new Image();
            imgs[i].src = $(pdps).find('.imgTL')[i].getAttribute('data-img');
            //console.log(imgs[i].src);
        }
        
        imgs[0].onload = function(){
            $tl_wrap.removeClass('hide');
        }
        imgs[1].onload = function(){
            var wrap_height = parseInt((this.height*document.body.clientWidth)/this.width);
            $('.tl_banner_time').height(wrap_height);
            $tl_wrap.parent().height(wrap_height);
            $('.imgTL').height(wrap_height);
            //$tl_wrap.parent().next().height(wrap_height);
        }
        
    }
    var banner_swiper = function(){
        var speed=4000; //数字越大速度越慢 
        var $tl_wrap = $('.tl_wrap');
        var count = 0;
        var tab=$tl_wrap.children()[0]; 
        var _height = $(tab).height();
        // $tl_wrap.children()[1].childNodes[1].style.height = _height;
        var tab2=document.createElement('li');
        $tl_wrap.append(tab2);
        tab2.innerHTML=tab.innerHTML; //克隆demo1为demo2 
        
        var MyMar=setInterval(Marquee,speed); 
        $tl_wrap[0].addEventListener("touchstart", function(e){
            clearInterval(MyMar);
        }, false);
        $tl_wrap[0].addEventListener("touchend", function(e){
            MyMar=setInterval(Marquee,speed);
        }, false);
        
        
    }
    var index =0;
   
    function Marquee(){ 
        var speed = 2000;
        var $tl_wrap = $('.tl_wrap');
        var _height = $($tl_wrap.children()[0]).height();
        index = _height + index;
        var str = $tl_wrap[0].style.webkitTransform.split(',');
        //console.log(str);
        if(str[1] == ' -'+2*_height+'px'){
            $tl_wrap[0].style.webkitTransitionDuration = 1 + 'ms';
            $tl_wrap[0].style.webkitTransform = 'translate3d(0,-'+ '0' +  'px, 0)';
            index=0;
            return;
        }
        else {
            $tl_wrap[0].style.webkitTransitionDuration = speed + 'ms';
            $tl_wrap[0].style.webkitTransform = 'translate3d(0,-'+ index +  'px, 0)';
        }
    } 
    function countDays(){
        var time_now_server,time_now_client,time_end,time_server_client,timerID;
        time_end_=new Date("2016/08/06");//结束的时间
        time_end=time_end_.getTime();
        endTime = time_end_.getDay();
        time_now_server=new Date();//开始的时间
        time_now_server=time_now_server.getTime();
        time_now_client=new Date();
        time_now_client=time_now_client.getTime();
        time_server_client=time_now_server-time_now_client;
        
        show_time(time_server_client,timerID,time_end,endTime);
       
        
    }
     function show_time(time_server_client,timerID,time_end,endTime){
        var timer = document.querySelector(".tl_banner_count");
        if(!timer){return;}
        timer.innerHTML =time_server_client;
        var time_now,time_distance,str_time,newTime;
        var int_day,int_hour,int_minute,int_second;
        var time_now=new Date();
        var newTime = new Date();
        var month = newTime.getMonth();
        time_now=time_now.getTime()+time_server_client;
        time_distance=time_end-time_now;
        if(time_distance>0){
            int_day=Math.floor(time_distance/86400000)
            time_distance-=int_day*86400000;
            int_hour=Math.floor(time_distance/3600000)
            time_distance-=int_hour*3600000;
            int_minute=Math.floor(time_distance/60000)
            time_distance-=int_minute*60000;
            int_second=Math.floor(time_distance/1000)
            if(int_day<10)
            int_day="0"+int_day;
            
            str_time=int_day;
            timer.innerText=str_time;
            //setTimeout("show_time()",1000);
        }
        else{
            timer.innerText =timer.innerText;
            clearTimeout(timerID);
        } 
        if(month == '7'){
            int_day = endTime - newTime.getDate();
            if(int_day <= 0)int_day= 0;
            timer.innerText=int_day;
        }
    }
    
    var bottomTjCallback = function (dom) {
        
        var imgHeight,
            begin = 0,
            imgBox = $(dom).find('.j_lmtimage'),
            img = new Image(),
            now = new Date(),
            bottomTjStorage = storage.get('bottomTjStorage'),
            media = now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate();
        img.onload = function () {
            
            imgHeight = img.height;
            if(media !== bottomTjStorage){
                if(mediaFlag){
                    
                    setTimeout(function () {
                        
                        var timer = setInterval(function () {
                            if(begin> imgHeight){
                                clearInterval(timer);
                                setTimeout(function () {
                                    $(dom).find('.j_lmtimage').css({'height':'0'})
                                   
                                },5000);
                            }else{
                                begin +=5;
                                imgBox.css({"height": begin + 'px'})
                            }
                        },20)
                    },6000)
                }
                else{
                    var timer = setInterval(function () {
                        if(begin> imgHeight){
                            clearInterval(timer);
                            setTimeout(function () {
                                $(dom).find('.j_lmtimage').css({'height':'0'})
                               
                            },5000);
                        }else{
                            begin +=5;
                            imgBox.css({"height": begin + 'px'})
                        }
                    },20)
                }
                storage.set('bottomTjStorage', media);
                
            }
        }
        img.src = $(dom).find('.j_lmtimage').attr('data-img');
        
        $(dom).find('.j_adClose').on('click', function (ev) {
            
            ev.preventDefault();
            $('.j_lmtimage').remove();
                    
        })
    }
    
    var sina_tj_qp = document.getElementsByClassName('sina_tj_qp')[0],
        sina_tj_lmt = document.getElementsByClassName('sina_tj_lmt')[0],
        //sina_tj_jdt = $('.sina_tj_jdt'),
        sina_tj_jdt = $('.j_sax[sax-type="slide"]'),
        sina_tj_tl = $('.j_sax[sax-type="tl"]'),
        sina_tj_tl_pdps,
        sina_tj_qp_pdps,
        sina_tj_lmt_pdps;
    var sina_tj_jdt_pdps = [];
    if(sina_tj_qp){
        sina_tj_qp_pdps = sina_tj_qp.getAttribute('data-id');
    }
    if(sina_tj_lmt){
        sina_tj_lmt_pdps = sina_tj_lmt.getAttribute('data-id');
    }
    if(sina_tj_tl.length > 0){
        sina_tj_tl_pdps = sina_tj_tl[0].getAttribute('data-id');
    }
    if(sina_tj_jdt){//焦点图可能有多个广告
        for(var i=0;i<$(sina_tj_jdt).length;i++){
            sina_tj_jdt_pdps[i] = sina_tj_jdt[i].getAttribute('data-id');            
        }
        
    }
    function insertJDT(pdps){
        if(window.xwipe){
            window.xwipe.appendItem(pdps,pdps.getAttribute('data-pos')-1);
            /*$(pdps).find('a').css('display','block');
            $(pdps).css('display','block');
            $(pdps).css('position','reletive');*/
        }else{
            window.initXwipe();
        }
    }
    
    
    sinaSax.bind("insertSucc", function (pdps) {
        switch (pdps.getAttribute('data-id')){
            case sina_tj_qp_pdps:
                topTjCallback(pdps);
                break;
            case sina_tj_lmt_pdps:
                bottomTjCallback(pdps);
                break;
            case sina_tj_jdt_pdps[0]:
                insertJDT(pdps);
                break;
            case sina_tj_jdt_pdps[1]:
                insertJDT(pdps);
                break;
            case sina_tj_tl_pdps:
                insertTl(pdps);
                countDays();
                banner_swiper();
                break;
            default :
                break;
        }
    })
    sinaSax.bind("error", function (e) {
        //console.log(e,"E")
    });
    sinaSax.bind("nullData", function (pdps) {
        switch (pdps.getAttribute('data-id')){
            case sina_tj_jdt_pdps:
                if(window.imgXwipe){
                    imgXwipe.destroy();
                    imgXwipe = null;
                }
        }
    });
    var storage =  {
        set: function (key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        },
        get: function (key) {
            return JSON.parse(localStorage.getItem(key));
        }
    }
    window.onload = function(){
       
        
    }
}(window,document));
}catch(e){throw new Error(e+" liyue_fp.js");}
